/**=========================================================
 * Module: project.js
 * Project Controller
 =========================================================*/

App.controller('ProjectController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService',
   'Restangular', 'DataService', 'ngDialog', '$filter', 'toaster', 'LocalRestangular',
  function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, ngDialog, $filter, toaster, LR) {
    "use strict";

    $scope.type = 'project';
    $scope.id = $state.params.filter;

    $scope.model = {}
    $scope.error = {};
    $scope.page = {
        title: '',
        subTitle: ''
    };

    $scope.pop = function(type, title, text) {
        toaster.pop(type, title, text, 0, 'trustedHtml');
    };

    $scope.unassign = function(){
        var model = $scope.model;
        model.action = 'unassign';
        ngDialog.openConfirm({
          template: '/app/views/entities/confirm.html',
          className: 'ngdialog-theme-default',
          scope: $scope
        }).then(function (value) {
            D.save('project', model).
                then(function(response){
                    $state.go('app.dashboard',{}, {location:'replace'});
                }).catch(console.error);
            });
    }

    $scope.assign = function(){
        var project = $scope.model;
        project.action = 'assign';
        if(!project.assignee) project.fromDashboard = true;
        ngDialog.openConfirm({
          template: '/app/views/entities/confirm.html',
          className: 'ngdialog-theme-default',
          scope: $scope
        }).then(function (value) {
            D.save('project', project).then(function(response){
                $timeout(function(){ $state.go('app.do',
                        {action:'open', type:'project', filter: $scope.model.id },
                        { reload: true }); }, CONFIG.stateGoTimeout)
            }).catch(function(err){
                if(err.data && err.data.msg && err.data.msg.indexOf('alreadyAssigned')){
                    $scope.pop('error', $filter('translate')('labels.ALREADYASSIGNED'));
                }
            });
        });
    }
    var unwatch = null

    $scope.watchActivated = false;
    $scope.init = function(mode){

        $scope.currentDate = new Date().getTime() + 43200000;
        var isCreation = mode == 'create';

        if(!$rootScope.user.id && !$scope.watchActivated){
            $scope.watchActivated = true;
            unwatch = $scope.$watch('user.id', function(){
                if($rootScope.user.id){
                    $scope.init(mode);
                }
            });
            return
        }

        $scope.page = {
            title: isCreation ? 'labels.CREATEPROJECT' : $filter('translate')('labels.PROJECT_') + ' ' + $scope.model.name,
            titleParams: { projectName: '' },
            subTitle: isCreation ? '' : $scope.model.code,
            label: isCreation ? '' : 'enums.status.'+$scope.model.status,
            labelCls: isCreation ? '' : 'label-primary',
            isProject: true,
            assignee: $scope.model.assignee,
            assigneeName: $scope.model.assigneeName
        };

        if($state.params.action=='create'){
            $scope.loadOrders($rootScope.user.group);
            $scope.model = {
                owner: $rootScope.user.id,
                group: $rootScope.user.group.id
            };
            let projectDefaults = {
                'aag': {
                    hasReview: true
                }
            }
            if(projectDefaults[$rootScope.user.group.id]){
                $scope.model = Object.assign($scope.model, projectDefaults[$rootScope.user.group.id])
            }
        }

        $scope.stateAction = $state.params.action;
        $scope.actions = {};
        if($rootScope.user.groupType=='CLIENT'){
            $scope.actions.view = $state.params.action!='view';
            $scope.actions.open = $state.params.action=='view';
        	$scope.actions.log = true && $state.params.action!='actionlog';
        	$scope.actions.edit = $scope.model.status=='DRAFT' || $scope.model.status=='SENT' || $scope.model.status=='REVISION';
        	$scope.actions.stop = $scope.model.status=='DRAFT' || $scope.model.status=='SENT' || $scope.model.status=='REVISION' || $scope.model.status=='ESTIMATION';
        	$scope.actions.report = $scope.model.status=='REVISION' || $scope.model.status=='ESTIMATION' || $scope.model.status=='CONFIRMED' || $scope.model.status=='PROCESSING' || $scope.model.status=='DELIVERED' || $scope.model.status=='ARCHIVED' || $scope.model.status=='STOPPED';
        	$scope.actions.offers = $scope.model.status=='ESTIMATION' || $scope.model.status=='CONFIRMED' || $scope.model.status=='PROCESSING' || $scope.model.status=='DELIVERED' || $scope.model.status=='ARCHIVED' || $scope.model.status=='STOPPED';
        	$scope.actions.changeowner = $rootScope.user.superUser && $state.params.action!='archive' && $state.params.action!='changeowner' && $rootScope.user.group.id!='leo';
            $scope.actions.changeorder = $rootScope.user.group.opts.hasOrders
            $scope.actions.archive = $scope.model.status=='DELIVERED';
            $scope.actions.modifydate = $scope.model.status=='CONFIRMED' || $scope.model.status=='PROCESSING';
            $scope.actions.editclientcode =  $rootScope.user.group.id!='leo';
            $scope.actions.modifysource = $scope.model.status=='REVISION' //|| $scope.model.status=='ESTIMATION' || $scope.model.status=='CONFIRMED' || $scope.model.status=='PROCESSING';
            $scope.actions.addsupplier = $scope.model.status=='ESTIMATION';
            $scope.actions.clone = true;
        	$scope.page.showProjectMessages = $scope.model.status;
            if($state.params.action=='create') $scope.actions = {};
            $scope.actions.costs = ((['grt','dih'].indexOf($rootScope.user.group.supergroup)>=0) || 'fpr'==$rootScope.user.group.id) && ($scope.model.status=='ESTIMATION' || $scope.model.status=='CONFIRMED' || $scope.model.status=='PROCESSING' || $scope.model.status=='DELIVERED' || $scope.model.status=='ARCHIVED');
        }
        if($rootScope.user.groupType=='SUPPLIER'){
            $scope.actions.offer = $state.params.action!='estimate' && ($scope.model.status=='ESTIMATION' || $scope.model.status=='CONFIRMED' || $scope.model.status=='PROCESSING' || $scope.model.status=='DELIVERED' || $scope.model.status=='ARCHIVED');
        }
        if($rootScope.user.groupType=='ADMIN'){
            $scope.actions.view = $state.params.action!='view';
            $scope.actions.open = $state.params.action=='view';
        	$scope.actions.log = $state.params.action!='actionlog';
        	$scope.actions.report = $scope.model.status=='REVISION' || $scope.model.status=='ESTIMATION' || $scope.model.status=='CONFIRMED' || $scope.model.status=='PROCESSING' || $scope.model.status=='DELIVERED' || $scope.model.status=='ARCHIVED';
        	$scope.actions.edit = $scope.model.status=='DRAFT' || $scope.model.status=='SENT' || $scope.model.status=='REVISION';
        	$scope.actions.stop = $state.params.action!='archive';
        	$scope.actions.changeowner = $state.params.action!='archive' && $state.params.action!='changeowner';
            $scope.actions.changeorder = true
            $scope.actions.modifydate = $scope.model.status=='CONFIRMED' || $scope.model.status=='PROCESSING';
            $scope.actions.modifysource = $scope.model.status=='REVISION' || $scope.model.status=='ESTIMATION' || $scope.model.status=='CONFIRMED' || $scope.model.status=='PROCESSING';
            $scope.actions.addsupplier = $scope.model.status=='ESTIMATION';
            $scope.actions.editclientcode = true;
            $scope.actions.archive = $scope.model.status=='DELIVERED';
            $scope.actions.deliver = $scope.model.status=='ANALYSIS';
        	$scope.page.showProjectMessages = true;
            $scope.actions.offers = $scope.model.status=='ESTIMATION' || $scope.model.status=='CONFIRMED' || $scope.model.status=='PROCESSING' || $scope.model.status=='DELIVERED' || $scope.model.status=='ARCHIVED';
            $scope.actions.files = true;
            $scope.actions.delete = true;
            $scope.actions.backtoanalysis = $scope.model.status=='ESTIMATION';
            $scope.actions.wait = $scope.model.status=='ANALYSIS';
            $scope.actions.breakproject = $scope.model.status=='ANALYSIS';
            $scope.actions.joinprojects = $scope.model.status=='ANALYSIS' || $scope.model.status=='SENT';
            $scope.actions.urge = $scope.model.status=='ESTIMATION' && $state.params.action=='offers';
            $scope.actions.similarprojects = true;
            $scope.actions.standby = true;
            $scope.actions.viewemails = true;
            $scope.actions.changestatus = true;
            $scope.actions.setnostats = $rootScope.user.superUser
            $scope.actions.setimpaginationforfait = $scope.model.group=='leo'
            $scope.actions.costs = $scope.model.status=='ESTIMATION' || $scope.model.status=='CONFIRMED' || $scope.model.status=='PROCESSING' || $scope.model.status=='DELIVERED' || $scope.model.status=='ARCHIVED';
            $scope.actions.exportxlsx = $scope.model.status=='CONFIRMED' || $scope.model.status=='PROCESSING' || $scope.model.status=='DELIVERED' || $scope.model.status=='ARCHIVED' || $scope.model.status=='STOPPED';
            $scope.actions.qaiprocesses = $scope.model.withQAi
        }

        if(mode=='clone') {
            $scope.page.title = 'labels.CLONEPROJECT';
            $scope.page.subTitle = $scope.model.name + ' ('+ $scope.model.code +')';
            $scope.page.label = '';
            $scope.actions = {};
        }

        $scope.page.showBackToProject = false;
        if(mode=='messages'){
        	$scope.page.showBackToProject = true;
        	$scope.page.showProjectMessages = false;
        }

        var role = $rootScope.user.role;

        $scope.ownerFieldAvailable = role=='SUPERUSER' || role=='ADMIN' || role=='SUPERADMIN';
        if($rootScope.user && $rootScope.user.group && $rootScope.user.group.id=='leo') { $scope.ownerFieldAvailable = false; }
        if(role=='SUPERUSER' && $rootScope.user && $rootScope.user.group && $rootScope.user.group.id && $rootScope.user.notSupOf && $rootScope.user.notSupOf.indexOf($rootScope.user.group.id)>=0){ $scope.ownerFieldAvailable = false }

        if($rootScope.user.group && $rootScope.user.group.id){
        	if(mode=='open'){
        		var gotoAction = 'view';
        		if($scope.model.status=='ANALYSIS' && $rootScope.user.admin){
        			gotoAction = 'analyze';
        		} else if($scope.model.status=='ESTIMATION' && $rootScope.user.groupType=='SUPPLIER'){
        			gotoAction = 'estimate';
        		} else if($scope.model.status=='ESTIMATION' && $rootScope.user.groupType=='CLIENT'){
        			gotoAction = 'offers';
        		} else if($scope.model.status=='CONFIRMED' || $scope.model.status=='PROCESSING' || $scope.model.status=='DELIVERED' || $scope.model.status=='ARCHIVED'){
        			gotoAction = 'process';
        			if($rootScope.user.groupType=='SUPPLIER' && $scope.model.supplier!=$rootScope.user.group.id)
        				goToAction = 'estimate';
        		} else if($scope.model.status=='REVISION' && $rootScope.user.groupType=='CLIENT'){
        			gotoAction = 'review';
        		} else if($scope.model.status=='NOTCONFIRMED'){
    				goToAction = 'estimate';
        		}
                $state.params.action = gotoAction;

                if($rootScope.user.customRole=='REVIEWER'){
                    $state.params.action = 'view'
                    $state.params.type = 'translation'
                    $state.params.filter = ($scope.model.id + '-' + $scope.model.source + '-' + $rootScope.user.opts.reviewLanguage).toLowerCase()
                }
        		
        		$state.go('app.entity',$state.params, {location:'replace'});
        		return;
        	}

            D.query('account','_disabled=false&_withSGUsers=true' + ($rootScope.user.admin ? '&_withGroup=true' :'') + '&group='+($rootScope.user.admin ? $scope.model.group : $rootScope.user.group.id), { cache: false }).then(
                function(response){
                    $scope.userSelect = response;
                    D.query('reference','client='+$scope.model.group, { cache: false }).then(
                        function(response){
                            $scope.loaded = true;
                            $scope.formCreated = true;
                            $scope.suppliers = response;

                            if($rootScope.user.groupType=='CLIENT'){
                                $scope.model.skiprevision = $rootScope.user.group.opts.skipSourceReport;
                                if($rootScope.user.group.supergroup=='grt'){
                                    $scope.model.sourceFilesType = 'final';
                                }
                            }

                            if($state.params.action=='import'){
                                $scope.model.tempId = $rootScope.generateUUID(true, '_TEMP_')
                                $scope.page.title = 'sidebar.nav.IMPORTPROJECT'
                            }
                            $scope.importForm = {
                                title: '',
                                status: 'notsubmittable',
                                type: 'project',
                                model: $scope.model,
                                successLabel: 'labels.SUCCESSSAVE',
                                refreshFile: function(data){
                                    if($rootScope.files['project'+this.model.tempId+'upload'] && $rootScope.files['project'+this.model.tempId+'upload'].length>0){
                                        if(!this.model.name){
                                            this.model.name = $rootScope.files['project'+this.model.tempId+'upload'][0].name.replace(/\.[^/.]+$/, "")
                                        }
                                        this.status = '';
                                    } else {
                                        this.status = 'notsubmittable';
                                    }
                                },
                                fields: [
                                    {
                                        available: true,
                                        type: 'text',
                                        name: 'name',
                                        required: true,
                                        column: 12
                                    },{
                                        available: true,
                                        type: 'file',
                                        name: 'upload',
                                        limit: -1,
                                        canUpload: true,
                                        tooltip: function(){ return $scope.model.status=='DRAFT' && $rootScope.user.groupType=='CLIENT' ? {
                                            name: 'DRAFTPROJECTUPLOAD',
                                            wait: 2,
                                            position: 'top',
                                            attachTo: '#Files_upload_' + $scope.model.id,
                                            arrowSize: 'long'
                                        } : null }(),
                                        bucket: $rootScope.bucketName($scope.model.group)
                                    },{
                                        available: true,
                                        type: 'submit',
                                        name: 'empty',
                                        label: 'labels.SAVEPROJECT'
                                    }
                                ],
                                validate: function(){
                                	var errors = [];
                                	for(var j=0; j<this.fields.length; j++){
                                        var field = this.fields[j];
                                        if(field.required && (!this.model[field.name] || (Array.isArray(this.model[field.name]) && this.model[field.name].length===0))){
                                            errors.push({field:field,error:'required'});
                                        }
                                    }
                                    
                                    /*if(this.model.dtp=="true" && !this.model.dtpTypes){
                                		errors.push({field:this.steps[1].fields[2],error:'required'});
                                	}
                                    if(this.model.urgentOffer==true && !this.model.offerDeadline){
                                		errors.push({field:this.steps[2].fields[4],error:'required'});
                                    }

                                    if(!this.model.suppliers)this.model.suppliers=[];
                                    
                                    if(this.model.skipConfirm===true && this.model.suppliers.length>1){
                                        errors.push({field:this.steps[2].fields[1],error:'onlyOneSupplierToSkipConfirm'});
                                    }
                                    var fake = 0;
                                    var notFake = 0;
                                    var fakeSupplier = '';
                                    for(var i=0; i<this.model.suppliers.length; i++){
                                        var id = this.model.suppliers[i];
                                        var supplier = $scope.suppliers.filter(function(s) { return s.supplier==id})[0];
                                        if(supplier.fake) {
                                            fake++;
                                            fakeSupplier = supplier.supplierName;
                                        }
                                        else notFake++;
                                    }
                                    if(fake>0 && notFake>0){
                                        errors.push({field:this.steps[2].fields[1],error:'fakeAndNotFakeSuppliers', data: fakeSupplier});
                                    }*/
                                	if(errors.length) {
                                		var errorMessages ="<ul>";
                                		for(var i=0; i<errors.length; i++){
                                			var e = errors[i];
                                			errorMessages += "<li>"
                                                +$filter('translate')('labels.VALIDATIONERROR'+e.error.toUpperCase(), 
                                                    { 
                                                        name: $filter('translate')('fields.'+e.field.name.toUpperCase()),
                                                        data: e.data
                                                    })
                                				+"</li>";
                                		}
                                		errorMessages += "</ul>";
                                		$scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), errorMessages);
                                		return false;
                                	}
                                	else {
                                        $scope.importForm.status=''
                                        return true;
                                    }
                                },
                                submit: function(){
                                	if(this.validate() && $scope.importForm.status==''){
                                        $scope.importForm.status = 'submitting';
                                        $scope.model.action = 'import';
	                                    D.save($scope.type, $scope.model).then(
	                                        function(response){
	                                            $scope.importForm.status = 'submitted';
	                                            $state.go('app.entity', {action:'view',type:'project',filter:response.id});
	                                        }
	                                        
	                                    ).catch(function(response){
                                                if(response.status==500 && response.data.exc=='InvalidValueException'
                                                                && response.data.msg.indexOf('beforeOfferDeadline')){
                                                                    $scope.importForm.errorLabel = 'labels.ERRORBEFOREOFFERDEADLINE'
                                                                }
	                                            $scope.importForm.status = 'error';
	                                        });
                                	}
                                }
                            }


                            $rootScope.user.group.sectors = $rootScope.user.group.sectors || []

                            if(isCreation) { 
                                $scope.model.skipConfirm = $rootScope.user.group.opts.skipConfirm
                                $scope.model.skipConfirmLimit = $rootScope.user.group.opts.skipConfirmLimit
                                if($state.params.filter && $state.params.filter.indexOf('fromInboundEmail=')>=0){
                                    var inboundEmailId = $state.params.filter.substr('fromInboundEmail='.length)
                                    $scope.parsingInboundEmail = true
                                    D.load('inboundEmail', inboundEmailId).then(function(ieresp){
                                        $scope.fromInboundEmail = ieresp
                                        $scope.model.fromInboundEmail = ieresp.id
                                        $scope.model.name = ieresp.subject
                                        //$scope.model.owner = ieresp.fromAccount
                                        $scope.model.clientCode = (ieresp.fromName ? ieresp.fromName + ' - ' : '') + ieresp.from
                                        $scope.model.source = 'it_IT'
                                        $scope.model.sourceFilesVisible = true
                                        
                                        $timeout(function(){
                                            $('.app-field-source .chosen-select').val($scope.model.source)
                                            $('.app-field-source .chosen-select').trigger('chosen:updated')
                                        }, 1000)

                                        D.call('extractFromText', 'put', null, ieresp).then(function(eftResp){
                                            $scope.model.destinations = eftResp.destinations.filter(function(d){ return !d.startsWith('it')})

                                            $timeout(function(){
                                                $('.app-field-destinations .chosen-select').val($scope.model.destinations)
                                                $('.app-field-destinations .chosen-select').trigger('chosen:updated')
                                                $scope.parsingInboundEmail = false

                                                for(var fk in $scope.creationForm.steps[2].fields){
                                                    if($scope.creationForm.steps[2].fields[fk].name=='skipConfirm'){
                                                        $scope.creationForm.steps[2].fields[fk].available = false
                                                    }
                                                }
                                            }, 1000)

                                            if(eftResp.dates.length){
                                                if(eftResp.dates.length>1){
                                                    $scope.model.offerDeadline = eftResp.dates[0].time * 1000
                                                    $scope.model.delivery = eftResp.dates[eftResp.dates.length-1].time * 1000
                                                    if(eftResp.urgent){
                                                        $scope.model.urgentOffer = true
                                                    }
                                                } else {
                                                    $scope.model.delivery = eftResp.dates[0].time * 1000
                                                }
                                            }
                                        }).catch(console.error)
                                        
                                        
                                            
                                        $scope.inboundEmailFilesForm = {
                                            title: '',
                                            status: '',
                                            type: 'inboundEmail',
                                            model: $scope.fromInboundEmail,
                                            fields: [
                                                {
                                                    available: true,
                                                    type: 'file',
                                                    name: 'attachment',
                                                    canUpload: false,
                                                    cantDelete: true,
                                                    bucket: $rootScope.bucketName($scope.model.group)
                                                }
                                            ]
                                        }
                                    }).catch(console.error)
                                }
                            }

                            var selectField = function(form, name){
                                if(form.steps){
                                    for(var i=0; i<form.steps.length; i++){
                                        for(var j=0; j<form.steps[i].fields.length; j++){
                                            if(form.steps[i].fields[j].name==name){
                                                return form.steps[i].fields[j]
                                            }
                                        }
                                    }
                                } else {
                                    for(var j=0; j<form.fields.length; j++){
                                        if(form.fields[j].name==name){
                                            return form.fields[j]
                                        }
                                    }
                                }
                            }
                            if($rootScope.user.group.opts.hasQAi && !$scope.model['code']){
                                $scope.model['withQAi'] = true;
                            }
                            if($rootScope.user.group.opts.defaultSourceFilesVisible && !$scope.model['code']){
                                $scope.model['sourceFilesVisible'] = true;
                            }
                            $scope.creationForm = {
                                title: '',
                                status: '',
                                type: 'project',
                                activeStep: 0,
                                model: $scope.model,
                                successLabel: 'labels.SUCCESSSAVE',
                                steps: [
                                    {
                                        title: 'labels.PROJECTINFO',
                                        subTitle: 'labels.PROJECTINFOLEGEND',
                                        fields: [
                                            {
                                                available: true,
                                                type: 'text',
                                                name: 'name',
                                                required: true,
                                                column: 12,
                                                labelAlign: 'left',
                                                labelColumn: 12,
                                                inputColumn: 12
                                            },{
                                                available: true,
                                                type: 'separator'
                                            },{
                                                available: true,
                                                type: 'date',
                                                name: 'delivery',
                                                required: true,
                                                column: 12,
                                                labelAlign: 'left',
                                                labelColumn: 12,
                                                inputColumn: 4
                                            },{
                                                available: $scope.ownerFieldAvailable,
                                                type: 'select',
                                                data: $scope.userSelect,
                                                valueField: 'id',
                                                labelField: 'name',
                                                name: 'owner',
                                                column: 12,
                                                placeholder: 'labels.SELECTUSER',
                                                labelAlign: 'left',
                                                labelColumn: 12,
                                                inputColumn: 6
                                            },{
                                                available: true,
                                                type: 'text',
                                                name: 'clientCode',
                                                required: $rootScope.user.group.id == 'fpr',
                                                column: 12,
                                                labelAlign: 'left',
                                                labelColumn: 12,
                                                inputColumn: 12,
                                                tooltip: {
                                                    name: 'CREATEPROJECTCLIENTCODE',
                                                    wait: 2,
                                                    position: 'bottom',
                                                    attachTo: '.app-field-clientCode input',
                                                    arrowSize: 'long'
                                                }
                                            },{
                                                available: $rootScope.user.group.sectors.length && $rootScope.user.group.opts.hasSectorInProject,
                                                type: 'select',
                                                name: 'sector',
                                                data: [{id:'',name:'-'}].concat($rootScope.user.group.sectors),
                                                valueField: 'id',
                                                labelField: 'name',
                                                placeholder: '-',
                                                column: 12,
                                                labelAlign: 'left',
                                                labelColumn: 12,
                                                inputColumn: 6
                                            },{
                                                available: !!$scope.orders,
                                                type: 'select',
                                                name: 'order',
                                                data: $scope.orders,
                                                valueField: 'number',
                                                labelField: 'number',
                                                placeholder: '-',
                                                column: 12,
                                                labelAlign: 'left',
                                                labelColumn: 12,
                                                inputColumn: 6
                                            }
                                        ]
                                    },{
                                        title: 'labels.TRANSLATIONDETAILS',
                                        subTitle: 'labels.TRANSLATIONDETAILSLEGEND',
                                        fields: [
                                            {
                                                available: true,
                                                type: 'language',
                                                name: 'source',
                                                column: 12,
                                                placeholder: 'labels.SELECTLANGUAGE',
                                                required: true,
                                                labelAlign: 'left',
                                                labelColumn: 12,
                                                inputColumn: 6
                                            },{
                                                available: true,
                                                type: 'language',
                                                multiple: true,
                                                name: 'destinations',
                                                column: 12,
                                                placeholder: 'labels.SELECTLANGUAGES',
                                                required: true,
                                                tooltip: {
                                                    name: 'CREATEPROJECTDESTINATIONS',
                                                    wait: 2,
                                                    position: 'top',
                                                    attachTo: '.app-field-destinations ul',
                                                    arrowSize: 'long'
                                                },
                                                labelAlign: 'left',
                                                labelColumn: 12,
                                                inputColumn: 12
                                            },{
                                                available: true,
                                                type: 'radiocheckboxes',
                                                name: 'dtp',
                                                subName: 'dtpTypes',
                                                subValueField: 'value',
                                                subLabelField: 'label',
                                                required: true,
                                                tooltip: {
                                                    name: 'CREATEPROJECTDTP',
                                                    wait: 2,
                                                    position: 'right',
                                                    attachTo: '.app-field-dtp input:first',
                                                    arrowPosition: 'top',
                                                    arrowSize: 'long'
                                                },
                                                options: [
                                                    {
                                                        label: 'labels.YES',
                                                        value: true,
                                                        options: [
                                                            {
                                                                label: 'enums.dtp.LAYOUT_SOURCE',
                                                                value: 'LAYOUT_SOURCE'
                                                            },{
                                                                label: 'enums.dtp.PDF_LOW',
                                                                value: 'PDF_LOW'
                                                            },{
                                                                label: 'enums.dtp.PDF_HIGH',
                                                                value: 'PDF_HIGH'
                                                            },{
                                                                label: 'enums.dtp.PLAIN',
                                                                value: 'PLAIN'
                                                            },{
                                                                label: 'enums.dtp.GRAPHICTEXT',
                                                                value: 'GRAPHICTEXT'
                                                            }
                                                        ]
                                                    },{
                                                        label: 'labels.NO',
                                                        value: false
                                                    }
                                                ],
                                                column:12,
                                                labelAlign: 'left',
                                                labelColumn: 12,
                                                inputColumn: 6
                                            },{
                                            	available: true,
                                            	type: 'checkbox',
                                            	name: 'sourceFilesVisible',
                                                column: 12,
                                                tooltip: {
                                                    name: 'CREATEPROJECTSOURCEFILESVISIBLE',
                                                    wait: 2,
                                                    position: 'bottom',
                                                    attachTo: '.app-field-sourceFilesVisible input',
                                                    arrowPosition: 'left',
                                                    arrowSize: 'long'
                                                },
                                                labelAlign: 'left',
                                                labelColumn: 12,
                                                inputColumn: 6
                                            },{
                                                available: $rootScope.user.group.opts.hasReviewInProject,
                                                type: 'separator',
                                                style: { opacity: 0, margin: 0 }
                                            },{
                                                available: $rootScope.user.group.opts.hasReviewInProject, 
                                                type: 'checkbox',
                                                name: 'hasReview',
                                                column: 12,
                                                onchange: function(){
                                                    if($rootScope.user.group.opts.hasReviewDeadline){
                                                        for(let i=0; i<$scope.creationForm.steps[1].fields.length; i++){
                                                            if($scope.creationForm.steps[1].fields[i].name=='reviewDeadline'){
                                                                $scope.creationForm.steps[1].fields[i].available = $scope.model.hasReview;
                                                            }
                                                        }
                                                    }
                                                    if($rootScope.user.group.opts.canAnticipateReview){
                                                        for(let i=0; i<$scope.creationForm.steps[1].fields.length; i++){
                                                            if($scope.creationForm.steps[1].fields[i].name=='anticipateReview'){
                                                                $scope.creationForm.steps[1].fields[i].available = $scope.model.hasReview;
                                                            }
                                                        }
                                                    }
                                                },
                                                labelAlign: 'left',
                                                labelColumn: 12,
                                                inputColumn: 6
                                            },{
                                                available: $rootScope.user.group.opts.hasReviewInProject,
                                                type: 'empty',
                                                name: 'empty',
                                                column: 12,
                                            },{
                                                available: false,
                                                type: 'checkbox',
                                                name: 'anticipateReview',
                                                column: 12,
                                                labelAlign: 'left',
                                                labelColumn: 12,
                                                inputColumn: 6
                                            },{
                                                available: false, //$rootScope.user.group.opts.hasReviewInProject && $rootScope.user.group.opts.hasReviewDeadline, 
                                                type: 'number',
                                                name: 'reviewDeadline',
                                                column: 12,
                                                style: { width: '4em' },
                                                labelAlign: 'left',
                                                labelColumn: 12,
                                                inputColumn: 6
                                            },{
                                                available: $rootScope.user.group.opts.hasQAi, 
                                                type: 'checkbox',
                                                name: 'withQAi',
                                                column: 12,
                                                labelAlign: 'left',
                                                labelColumn: 12,
                                                inputColumn: 6
                                            },{
                                                available: true,
                                                type: 'separator',
                                                style: { opacity: 0, margin: 0 }
                                            },{
                                                available: true,
                                                type: 'selectwithvalue',
                                                name: 'charNumberLimit',
                                                column: 12,
                                                valueField: 'value',
                                                labelField: 'label',
                                                placeholder: '-',
                                                showValue: {
                                                    '': false, 'SOURCE': false, 'NUMBER': true
                                                },
                                                data: [
                                                    { value: '', label: 'enums.charNumberLimit.NO' },
                                                    { value: 'SOURCE', label: 'enums.charNumberLimit.SOURCE' },
                                                    { value: 'NUMBER', label: 'enums.charNumberLimit.NUMBERINPUT' }
                                                ],
                                                selectStyle: {  },
                                                inputStyle: { marginTop: '4px' },
                                                onchange: function(){
                                                    if($scope.model.charNumberLimit!='NUMBER'){
                                                        $scope.model.charNumberLimitValue = ''
                                                    }
                                                },
                                                labelAlign: 'left',
                                                labelColumn: 12,
                                                inputColumn: 6
                                            },{
                                                available: $rootScope.user.group.supergroup=='grt',
                                                type: 'radio',
                                                name: 'sourceFilesType',
                                                column: 12,
                                                options: [
                                                    { value: 'final', label: 'fields.SOURCEFILESFINAL' },
                                                    { value: 'temp', label: 'fields.SOURCEFILESTEMP' }
                                                ],
                                                labelAlign: 'left',
                                                labelColumn: 12,
                                                inputColumn: 6
                                            },{
                                                available: true,
                                                type: 'textarea',
                                                label: 'fields.NOTESINCREATIONFORM',
                                                name: 'notes',
                                                column:12,
                                                labelColumn: 12,
                                                inputColumn: 12,
                                                labelAlign: 'left'
                                            }
                                        ]
                                    },{
                                        title: 'labels.SUPPLIERCHOICE',
                                        subTitle: 'labels.SUPPLIERCHOICELEGEND',
                                        fields: [
                                            {
                                                available: true,
                                                type: 'suppliers',
                                                name: 'suppliers',
                                                data: $scope.suppliers,
                                                valueField: 'supplier',
                                                labelField: 'supplierName',
                                                required: true,
                                                column: 12,
                                                labelAlign: 'left',
                                                labelColumn: 12,
                                                inputColumn: 12
                                            },{
                                            	available: !$scope.model.skiprevision,
                                                type: 'checkbox',
                                                checkboxLabel: 'labels.SKIPREVISION',
                                            	name: 'skipSourceReport',
                                                column: 12,
                                                tooltip: {
                                                    name: 'CREATEPROJECTSKIPSOURCEREPORT',
                                                    wait: 2,
                                                    position: 'right',
                                                    attachTo: '.app-field-skipSourceReport input',
                                                    arrowPosition: 'top',
                                                    size: 'large',
                                                    arrowSize: 'long'
                                                },
                                                labelAlign: 'left',
                                                labelColumn: 12,
                                                inputColumn: 6
                                            },{
                                            	available: true,
                                            	type: 'checkbox',
                                            	name: 'skipConfirm',
                                                column: 12,
                                                tooltip: {
                                                    name: 'CREATEPROJECTSKIPCONFIRM',
                                                    wait: 2,
                                                    position: 'right',
                                                    attachTo: '.app-field-skipConfirm input',
                                                    arrowPosition: 'bottom',
                                                    size: 'large',
                                                    arrowSize: 'long'
                                                },
                                                onchange: function(){
                                                    for(let i=0; i<$scope.creationForm.steps[2].fields.length; i++){
                                                        if($scope.creationForm.steps[2].fields[i].name=='skipConfirmLimit'){
                                                            $scope.creationForm.steps[2].fields[i].available = $scope.model.skipConfirm;
                                                            if($scope.model.skipConfirmLimit===null || $scope.model.skipConfirmLimit===undefined){
                                                                $scope.model.skipConfirmLimit = $rootScope.user.group.opts.skipConfirmLimit
                                                            }
                                                        }
                                                    }
                                                },
                                                labelAlign: 'left',
                                                labelColumn: 12,
                                                inputColumn: 6
                                            },{
                                                available: !!$scope.model.skipConfirmLimit,
                                                type: 'decimal',
                                                displayType: 'decimal',
                                                decimalSep: $rootScope.user.decimalSep,
                                                decimals: 0,
                                                name: 'skipConfirmLimit',
                                                labelParams: { currency: $rootScope.user.group.currency },
                                                postfix: $filter('translate')('enums.currencySymbol.' + ($rootScope.user.group.currency)),
                                                column: 12,
                                                labelAlign: 'left',
                                                labelColumn: 12,
                                                inputColumn: 4
                                            },{
                                                available: true,
                                                type: 'separator'
                                            },{
                                            	available: true,
                                            	type: 'checkbox',
                                            	name: 'urgentOffer',
                                                column: 12,
                                                tooltip: {
                                                    name: 'CREATEPROJECTURGENTOFFER',
                                                    wait: 2,
                                                    position: 'right',
                                                    attachTo: '.app-field-urgentOffer input',
                                                    arrowPosition: 'top',
                                                    size: 'large',
                                                    arrowSize: 'long'
                                                },
                                                labelAlign: 'left',
                                                labelColumn: 12,
                                                inputColumn: 6
                                            },{
                                                available: true,
                                                type: 'datetime',
                                                name: 'offerDeadline',
                                                noWeekend: true,
                                                column: 12,
                                                placeholder: 'fields.TIME',
                                                availableHours: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23],
                                                hasTime: $rootScope.user.group.opts.offerDlFieldWTime,
                                                defaultTime: 64800,
                                                labelAlign: 'left',
                                                labelColumn: 12,
                                                inputColumn: 12
                                            }

                                        ]
                                    },{
                                        title: 'labels.SENDPROJECT',
                                        subTitle: 'labels.SENDPROJECTLEGEND',
                                        fields: [
                                            {
                                                available: true,
                                                type: 'alert',
                                                alertCls: 'info',
                                                message: 'labels.PROJECTCREATIONINFO',
                                                name: 'empty',
                                                labelColumn: 0,
                                            },
                                            {
                                                available: true,
                                                type: 'submit',
                                                name: 'empty',
                                                label: 'labels.SAVEPROJECT',
                                                column: 12,
                                                labelColumn: 0,
                                                cls: 'btn-lg'
                                            }
                                        ]
                                    }
                                ],
                                validate: function(){
                                	var errors = [];
                                	for(var i=0; i<this.steps.length; i++){
                                		for(var j=0; j<this.steps[i].fields.length; j++){
                                			var field = this.steps[i].fields[j];
                                			if(field.required && (!this.model[field.name] || (Array.isArray(this.model[field.name]) && this.model[field.name].length===0))){
                                				errors.push({field:field,error:'required'});
                                			}
                                		}
                                    }
                                    if(this.model.dtp=="true" && !this.model.dtpTypes){
                                		errors.push({field:selectField(this, 'dtp'),error:'required'});
                                	}
                                    if((this.model.urgentOffer==true && !this.model.offerDeadline) || (!this.model.offerDeadline && $rootScope.user.group.id=='leo')){
                                		errors.push({field:selectField(this, 'offerDeadline'),error:'required'});
                                    }
                                    if(this.model.charNumberLimit=='NUMBER' && !this.model.charNumberLimitValue){
                                        errors.push({field:selectField(this, 'charNumberLimit'),error:'required'});
                                    }

                                    if(this.model.hasReview && (''+this.model.reviewDeadline!='' && this.model.reviewDeadline!==null && this.model.reviewDeadline!==undefined) && 
                                        (isNaN(this.model.reviewDeadline) || isNaN(parseInt(this.model.reviewDeadline)) || parseInt(this.model.reviewDeadline)<0 || parseInt(this.model.reviewDeadline)>99)){
                                        errors.push({field:selectField(this, 'reviewDeadline'), error: 'invalid'})
                                    }

                                    if(this.model.offerDeadline){
                                        var inputDate = new Date(this.model.offerDeadline);
                                        var currentDate = new Date();
                                        currentDate.setHours(0, 0, 0, 0); 
                                        if(inputDate < currentDate){
                                            errors.push({field:selectField(this, 'offerDeadline'),error:'invalid'});
                                        }
                                    }
                                    
                                    if(!this.model.suppliers)this.model.suppliers=[];
                                    
                                    if(this.model.skipConfirm===true && this.model.suppliers.length>1){
                                        errors.push({field:selectField(this, 'skipConfirm'),error:'onlyOneSupplierToSkipConfirm'});
                                    }
                                    var fake = 0;
                                    var notFake = 0;
                                    var fakeSupplier = '';
                                    for(var i=0; i<this.model.suppliers.length; i++){
                                        var id = this.model.suppliers[i];
                                        var supplier = $scope.suppliers.filter(function(s) { return s.supplier==id})[0];
                                        if(supplier.fake) {
                                            fake++;
                                            fakeSupplier = supplier.supplierName;
                                        }
                                        else notFake++;
                                    }
                                    if(fake>0 && notFake>0){
                                        errors.push({field:selectField(this, 'suppliers'),error:'fakeAndNotFakeSuppliers', data: fakeSupplier});
                                    }
                                	if(errors.length) {
                                		var errorMessages ="<ul>";
                                		for(var i=0; i<errors.length; i++){
                                			var e = errors[i];
                                			errorMessages += "<li>"
                                                +$filter('translate')('labels.VALIDATIONERROR'+e.error.toUpperCase(), 
                                                    { 
                                                        name: $filter('translate')('fields.'+e.field.name.toUpperCase()),
                                                        data: e.data
                                                    })
                                				+"</li>";
                                		}
                                		errorMessages += "</ul>";
                                		$scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), errorMessages);
                                		return false;
                                	}
                                	else return true;
                                },
                                submit: function(){
                                	if(this.validate()){
	                                    $scope.creationForm.status = 'submitting';
	                                    D.save($scope.type, $scope.model).then(
	                                        function(response){
	                                            $scope.creationForm.status = 'submitted';
	                                            $state.go('app.entity', {action:'view',type:'project',filter:response.id});
	                                        }
	                                        
	                                    ).catch(function(response){
                                                if(response.status==500 && response.data.exc=='InvalidValueException'
                                                                && response.data.msg.indexOf('beforeOfferDeadline')>=0){
                                                                    $scope.creationForm.errorLabel = 'labels.ERRORBEFOREOFFERDEADLINE'
                                                                }
                                                if(response.status==500 && response.data.exc=='InvalidValueException'
                                                                && response.data.msg.indexOf('fromInboundEmail')>=0){
                                                                    $scope.creationForm.errorLabel = 'labels.ERRORFROMINBOUNDEMAIL'
                                                                }
	                                            $scope.creationForm.status = 'error';
	                                        });
                                	}
                                }
                            };

                                $scope.cloneForm = {
                                        title: '',
                                        status: '',
                                        type: 'project',
                                        model: $scope.model,
                                        successLabel: 'labels.SUCCESSSAVE',
                                        fields: [
                                                    {
                                                        available: true,
                                                        type: 'text',
                                                        name: 'name',
                                                        required: true
                                                    },{
                                                        available: true,
                                                        type: 'text',
                                                        name: 'clientCode',
                                                        required: $rootScope.user.group.id == 'fpr'
                                                    },{
                                                        available: true,
                                                        type: 'date',
                                                        name: 'delivery',
                                                        required: true
                                                    },{
                                                    	available: true,
                                                    	type: 'checkbox',
                                                    	name: 'copySourceFiles'
                                                    },{
                                                        available: true,
                                                        type: 'separator'
                                                    },{
                                                        available: true,
                                                        type: 'submit',
                                                        name: 'empty',
                                                        label: 'labels.SAVE'
                                                    }

                                        ],
                                        validate: function(){
                                        	var errors = [];
                                        		for(var j=0; j<this.fields.length; j++){
                                        			var field = this.fields[j];
                                        			if(field.required && !this.model[field.name] && this.model[field.name]!==false){
                                        				errors.push({field:field,error:'required'});
                                        			}
                                        		}
                                        	if(errors.length) {
                                        		var errorMessages ="<ul>";
                                        		for(var i=0; i<errors.length; i++){
                                        			var e = errors[i];
                                        			errorMessages += "<li>"
                                        				+$filter('translate')('labels.VALIDATIONERROR'+e.error.toUpperCase(), { name: $filter('translate')('fields.'+e.field.name.toUpperCase()) })
                                        				+"</li>";
                                        		}
                                        		errorMessages += "</ul>";
                                        		$scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), errorMessages);
                                        		return false;
                                        	}
                                        	else return true;
                                        },
                                        submit: function(){
                                        	if(this.validate()){
    	                                    	ngDialog.openConfirm({
    	                                            template: '/app/views/entities/project-confirmclone.html',
    	                                            className: 'ngdialog-theme-default',
    	                                            scope: $scope
    	                                          }).then(function (value) {
    			                                        $scope.cloneForm.status = 'submitting';
    			                                        $scope.model.action = 'clone';
                                                        $scope.model.fromId = $scope.model.id ? ''+$scope.model.id : $scope.model.fromId;
                                                        $scope.model.id = '';
                                                        $scope.model.offerDeadline = null;
                                                        $scope.model.offerDeadline_Time = null;
                                                        D.save($scope.type, $scope.model).then(
    			                                            function(response){
    			                                                $scope.cloneForm.status = 'submitted';
    			                                                $state.go('app.entity', {action:'view',type:'project',filter:response.id});
    			                                            }
    			                                            
    			                                        ).catch(function(response){
    			                                                $scope.cloneForm.status = 'error';
    			                                            });
    	                                          });
                                        	}
                                        }
                                    };

                            $scope.changeOrderForm = {
                                title: '',
                                status: '',
                                type: 'project',
                                model: $scope.model,
                                successLabel: 'labels.SUCCESSSAVE',
                                fields: [
                                    {
                                        available: true,
                                        type: 'select',
                                        data: $scope.orders,
                                        valueField: 'number',
                                        labelField: 'number',
                                        name: 'order',
                                        placeholder: '-',
                                        required: true
                                    },{
                                        available: true,
                                        type: 'separator'
                                    },{
                                        available: true,
                                        type: 'submit',
                                        name: 'empty',
                                        label: 'labels.SAVE'
                                    }
                                ],
                                validate: function(){
                                    var errors = [];
                                        for(var j=0; j<this.fields.length; j++){
                                            var field = this.fields[j];
                                            if(field.required && !this.model[field.name] && this.model[field.name]!==false){
                                                errors.push({field:field,error:'required'});
                                            }
                                        }

                                    if(errors.length) {
                                        var errorMessages ="<ul>";
                                        for(var i=0; i<errors.length; i++){
                                            var e = errors[i];
                                            errorMessages += "<li>"
                                                +$filter('translate')('labels.VALIDATIONERROR'+e.error.toUpperCase(), { name: $filter('translate')('fields.'+e.field.name.toUpperCase()) })
                                                +"</li>";
                                        }
                                        errorMessages += "</ul>";
                                        $scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), errorMessages);
                                        return false;
                                    }
                                    else return true;
                                },
                                submit: function(){
                                    if(this.validate()){
                                        ngDialog.openConfirm({
                                            template: '/app/views/entities/confirm.html',
                                            className: 'ngdialog-theme-default',
                                            scope: $scope
                                          }).then(function (value) {
                                                $scope.changeOrderForm.status = 'submitting';
                                                $scope.model.action = 'changeOrder';
                                                D.save($scope.type, $scope.model).then(
                                                    function(response){
                                                        $scope.changeOrderForm.status = 'submitted';
                                                        $state.go('app.entity', {action:'view',type:'project',filter:response.id});
                                                    }
                                                    
                                                ).catch(function(response){
                                                        $scope.changeOrderForm.status = 'error';
                                                    });
                                          });
                                    }
                                }
                            }

                            var userSelectForChangeOwner = $scope.userSelect
                            var uf = false
                            if($rootScope.user.superUser && !$rootScope.user.admin){
                                for(var idx=0; idx<$scope.userSelect.length; idx++){
                                    if($rootScope.user.id==$scope.userSelect[idx].id){
                                        uf = true
                                    }
                                }
                                if(!uf){
                                    userSelectForChangeOwner = [$rootScope.user].concat(userSelectForChangeOwner)
                                }
                            }

                            $scope.changeOwnerForm = {
                                    title: '',
                                    status: '',
                                    type: 'project',
                                    model: $scope.model,
                                    successLabel: 'labels.SUCCESSSAVE',
                                    fields: [
                                                {
                                                    available: $rootScope.user.superUser || $rootScope.user.admin,
                                                    type: 'select',
                                                    data: userSelectForChangeOwner,
                                                    valueField: 'id',
                                                    labelField: 'name',
                                                    name: 'owner',
                                                    placeholder: 'labels.SELECTUSER',
                                                    required: true
                                                },{
                                                    available: true,
                                                    type: 'separator'
                                                },{
                                                    available: true,
                                                    type: 'submit',
                                                    name: 'empty',
                                                    label: 'labels.SAVE'
                                                }

                                    ],
                                    validate: function(){
                                    	var errors = [];
                                    		for(var j=0; j<this.fields.length; j++){
                                    			var field = this.fields[j];
                                    			if(field.required && !this.model[field.name] && this.model[field.name]!==false){
                                    				errors.push({field:field,error:'required'});
                                    			}
                                    		}

                                    	if(errors.length) {
                                    		var errorMessages ="<ul>";
                                    		for(var i=0; i<errors.length; i++){
                                    			var e = errors[i];
                                    			errorMessages += "<li>"
                                    				+$filter('translate')('labels.VALIDATIONERROR'+e.error.toUpperCase(), { name: $filter('translate')('fields.'+e.field.name.toUpperCase()) })
                                    				+"</li>";
                                    		}
                                    		errorMessages += "</ul>";
                                    		$scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), errorMessages);
                                    		return false;
                                    	}
                                    	else return true;
                                    },
                                    submit: function(){
                                    	if(this.validate()){
	                                    	ngDialog.openConfirm({
	                                            template: '/app/views/entities/project-confirmedit.html',
	                                            className: 'ngdialog-theme-default',
	                                            scope: $scope
	                                          }).then(function (value) {
			                                        $scope.changeOwnerForm.status = 'submitting';
			                                        $scope.model.action = 'changeOwner';
			                                        D.save($scope.type, $scope.model).then(
			                                            function(response){
			                                                $scope.changeOwnerForm.status = 'submitted';
			                                                $state.go('app.entity', {action:'view',type:'project',filter:response.id});
			                                            }
			                                            
			                                        ).catch(function(response){
			                                                $scope.changeOwnerForm.status = 'error';
			                                            });
	                                          });
                                    	}
                                    }
                                };

                                $scope.allowedStatusChanges = [
                                    {from:'REVISION',to:'ANALYSIS'},
                                    {from:'PROCESSING',to:'DELIVERED'},
                                    {from:'DELIVERED',to:'PROCESSING'},
                                    {from:'CONFIRMED',to:'PROCESSING'},
                                    {from:'CONFIRMED',to:'DELIVERED'}
                                ]
                                $scope.changeStatus = function(to){
                                    ngDialog.openConfirm({
                                        template: '/app/views/entities/project-confirmcs.html',
                                        className: 'ngdialog-theme-default',
                                        scope: $scope
                                      }).then(function(value){
                                          R.one('action','ChangeProjectStatus')
                                           .customPUT({id:$scope.model.id, status: to})
                                           .then(function(resp){
                                               $state.go('app.do', {action: 'open', type: 'project', filter: $scope.model.id})
                                           })
                                      })
                                }

                                $scope.backtoanalysisForm = {
                                        title: '',
                                        status: '',
                                        type: 'project',
                                        model: $scope.model,
                                        successLabel: 'labels.SUCCESSSAVE',
                                        fields: [
                                                    {
                                                        available: true,
                                                        type: 'submit',
                                                        name: 'empty',
                                                        label: 'labels.BACKTOANALYSIS'
                                                    }

                                        ],
                                        validate: function(){
                                        	return true;
                                        },
                                        submit: function(){
                                        	if(this.validate()){
    	                                    	ngDialog.openConfirm({
    	                                            template: '/app/views/entities/confirm.html',
    	                                            className: 'ngdialog-theme-default',
    	                                            scope: $scope
    	                                          }).then(function (value) {
    			                                        $scope.backtoanalysisForm.status = 'submitting';
                                                        $scope.model.action = 'backtoanalysis';
                                                        D.save($scope.type, $scope.model).then(
    			                                            function(response){
    			                                                $scope.backtoanalysisForm.status = 'submitted';
    			                                                $state.go('app.do', {action:'open',type:'project',filter:response.id}, { reload: true });
    			                                            }
    			                                            
    			                                        ).catch(function(response){
    			                                                $scope.backtoanalysisForm.status = 'error';
    			                                            });
    	                                          });
                                        	}
                                        }
                                    };

                                    $scope.setNoStatsForm = {
                                        title: '',
                                        status: '',
                                        type: 'project',
                                        model: $scope.model,
                                        successLabel: 'labels.SUCCESSSAVE',
                                        fields: [
                                                    {
                                                        available: true,
                                                        type: 'checkbox',
                                                        name: 'ns',
                                                        required: true
                                                    },{
                                                        available: true,
                                                        type: 'separator'
                                                    },{
                                                        available: true,
                                                        type: 'submit',
                                                        name: 'empty',
                                                        label: 'labels.SAVE'
                                                    }

                                        ],
                                        validate: function(){
                                        	return true;
                                        },
                                        submit: function(){
                                        	if(this.validate()){
    	                                    	ngDialog.openConfirm({
    	                                            template: '/app/views/entities/confirm.html',
    	                                            className: 'ngdialog-theme-default',
    	                                            scope: $scope
    	                                          }).then(function (value) {
    			                                        $scope.setNoStatsForm.status = 'submitting';
    			                                        $scope.model.action = 'setNoStats';
    			                                        D.save($scope.type, $scope.model).then(
    			                                            function(response){
    			                                                $scope.setNoStatsForm.status = 'submitted';
    			                                            }
    			                                            
    			                                        ).catch(function(response){
    			                                                $scope.setNoStatsForm.status = 'error';
    			                                            });
    	                                          });
                                        	}
                                        }
                                    }

                                    $scope.setImpaginationForfaitForm = {
                                        title: 'labels.SETIMPAGINATIONFORFAIT',
                                        status: '',
                                        type: 'project',
                                        info: $filter('translate')('labels.SETIMPAGINATIONFORMINFO'),
                                        model: { id: $scope.model.id, impaginationForfait: $scope.model.opts.impaginationForfait, action: 'SetImpaginationForfait' },
                                        successLabel: 'labels.SUCCESSSAVE',
                                        fields: [
                                            {
                                                available: true,
                                                type: 'number',
                                                decimals: 0,
                                                name: 'impaginationForfait',
                                                required: true
                                            },{
                                                available: true,
                                                type: 'submit',
                                                name: 'empty',
                                                label: 'labels.SAVE'
                                            }
                                        ],
                                        validate: function(){
                                            return true;
                                        },
                                        submit: function(){
                                        	if(this.validate()){
    	                                    	ngDialog.openConfirm({
    	                                            template: '/app/views/entities/confirm.html',
    	                                            className: 'ngdialog-theme-default',
    	                                            scope: $scope
    	                                          }).then(function (value) {
    			                                        $scope.setImpaginationForfaitForm.status = 'submitting';
    			                                        D.save($scope.type, $scope.setImpaginationForfaitForm.model).then(
    			                                            function(response){
    			                                                $scope.setImpaginationForfaitForm.status = 'submitted';
    			                                            }
    			                                            
    			                                        ).catch(function(response){
    			                                                $scope.setImpaginationForfaitForm.status = 'error';
    			                                            });
    	                                          });
                                        	}
                                        }
                                    }

                                    $scope.editClientCodeForm = {
                                        title: '',
                                        status: '',
                                        type: 'project',
                                        model: $scope.model,
                                        successLabel: 'labels.SUCCESSSAVE',
                                        fields: [
                                                    {
                                                        available: true,
                                                        type: 'text',
                                                        name: 'clientCode',
                                                        required: true
                                                    },{
                                                        available: true,
                                                        type: 'separator'
                                                    },{
                                                        available: true,
                                                        type: 'submit',
                                                        name: 'empty',
                                                        label: 'labels.SAVE'
                                                    }

                                        ],
                                        validate: function(){
                                        	var errors = [];
                                        		for(var j=0; j<this.fields.length; j++){
                                        			var field = this.fields[j];
                                        			if(field.required && !this.model[field.name] && this.model[field.name]!==false){
                                        				errors.push({field:field,error:'required'});
                                        			}
                                        		}

                                        	if(errors.length) {
                                        		var errorMessages ="<ul>";
                                        		for(var i=0; i<errors.length; i++){
                                        			var e = errors[i];
                                        			errorMessages += "<li>"
                                        				+$filter('translate')('labels.VALIDATIONERROR'+e.error.toUpperCase(), { name: $filter('translate')('fields.'+e.field.name.toUpperCase()) })
                                        				+"</li>";
                                        		}
                                        		errorMessages += "</ul>";
                                        		$scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), errorMessages);
                                        		return false;
                                        	}
                                        	else return true;
                                        },
                                        submit: function(){
                                        	if(this.validate()){
    	                                    	ngDialog.openConfirm({
    	                                            template: '/app/views/entities/project-confirmedit.html',
    	                                            className: 'ngdialog-theme-default',
    	                                            scope: $scope
    	                                          }).then(function (value) {
    			                                        $scope.editClientCodeForm.status = 'submitting';
    			                                        $scope.model.action = 'editClientCode';
    			                                        D.save($scope.type, $scope.model).then(
    			                                            function(response){
    			                                                $scope.editClientCodeForm.status = 'submitted';
    			                                                $state.go('app.do', {action:'open',type:'project',filter:response.id});
    			                                            }
    			                                            
    			                                        ).catch(function(response){
    			                                                $scope.editClientCodeForm.status = 'error';
    			                                            });
    	                                          });
                                        	}
                                        }
                                    };

                                $scope.modifyDateForm = {
                                        title: '',
                                        status: '',
                                        type: 'project',
                                        model: $scope.model,
                                        successLabel: 'labels.SUCCESSSAVE',
                                        fields: [
                                                    {
                                                        available: true,
                                                        type: 'date',
                                                        name: 'delivery',
                                                        required: true
                                                    },{
                                                        available: true,
                                                        type: 'separator'
                                                    },{
                                                        available: true,
                                                        type: 'submit',
                                                        name: 'empty',
                                                        label: 'labels.SAVE'
                                                    }

                                        ],
                                        validate: function(){
                                        	var errors = [];
                                        		for(var j=0; j<this.fields.length; j++){
                                        			var field = this.fields[j];
                                        			if(field.required && !this.model[field.name] && this.model[field.name]!==false){
                                        				errors.push({field:field,error:'required'});
                                        			}
                                        		}

                                        	if(errors.length) {
                                        		var errorMessages ="<ul>";
                                        		for(var i=0; i<errors.length; i++){
                                        			var e = errors[i];
                                        			errorMessages += "<li>"
                                        				+$filter('translate')('labels.VALIDATIONERROR'+e.error.toUpperCase(), { name: $filter('translate')('fields.'+e.field.name.toUpperCase()) })
                                        				+"</li>";
                                        		}
                                        		errorMessages += "</ul>";
                                        		$scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), errorMessages);
                                        		return false;
                                        	}
                                        	else return true;
                                        },
                                        submit: function(){
                                        	if(this.validate()){
    	                                    	ngDialog.openConfirm({
    	                                            template: '/app/views/entities/project-confirmedit.html',
    	                                            className: 'ngdialog-theme-default',
    	                                            scope: $scope
    	                                          }).then(function (value) {
    			                                        $scope.modifyDateForm.status = 'submitting';
    			                                        $scope.model.action = 'modifyDate';
    			                                        D.save($scope.type, $scope.model).then(
    			                                            function(response){
    			                                                $scope.modifyDateForm.status = 'submitted';
    			                                                $state.go('app.entity', {action:'view',type:'project',filter:response.id});
    			                                            }
    			                                            
    			                                        ).catch(function(response){
    			                                                $scope.modifyDateForm.status = 'error';
    			                                            });
    	                                          });
                                        	}
                                        }
                                    };

                                    if($state.params.action=='break'){
                                        $scope.originalSource = [];
                                        $scope.newSource = [];
                                        $scope.fieldNewSource = [{
                                            type: 'language',
                                            name: 'newSourceLanguage',
                                            labelColumn: 6,
                                            inputColumn: 6
                                        }];
                                        $scope.form = {
                                            model: {
                                                newSourceLanguage: ''
                                            }
                                        }
                                        for(var i=0; i<$scope.model.destinations.length; i++){
                                            $scope.originalSource.push($scope.model.destinations[i]);
                                        }
                                        $scope.changeSource = function(d){
                                            var index = $scope.originalSource.indexOf(d);
                                            if(index>=0){
                                                $scope.originalSource.splice(index, 1);
                                                $scope.newSource.push(d);
                                            } else {
                                                index = $scope.newSource.indexOf(d);
                                                if(index>=0){
                                                    $scope.newSource.splice(index, 1);
                                                    $scope.originalSource.push(d);
                                                }
                                            }
                                        }
                                        $scope.breakProject = function(){
                                            ngDialog.openConfirm({
                                                template: '/app/views/entities/project-confirmbreak.html',
                                                className: 'ngdialog-theme-default',
                                                scope: $scope
                                              }).then(function (value) {
                                                    $scope.form.submitting = true;
                                                    $scope.model.action = 'breakproject';
                                                    $scope.model.targets = $scope.newSource;
                                                    $scope.model.newSourceLanguage = $scope.form.model.newSourceLanguage;
                                                    D.save($scope.type, $scope.model).then(
                                                        function(response){
                                                            $state.go('app.do', {action:'open',type:'project',filter:response.id});
                                                        }
                                                        
                                                    ).catch(function(response){
                                                            $scope.form.submitting = false;
                                                        });
                                              });
                                        }
                                    }

                                    if($state.params.action=='join'){
                                        D.query('project', 'group=' + $scope.model.group + '&status=ANALYSIS|SENT&source='+$scope.model.source + '&_withSuppliersNames=true').then(function(response){
                                            response.sort(function(a, b) { return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1 })
                                            $scope.joinableProjects = response.filter(function(p) { 
                                                return ($scope.model.dataSource.indexOf('UI')>=0 && p.dataSource.indexOf('UI')>=0) || ($scope.model.dataSource.indexOf('IMPORT')>=0 && p.dataSource.indexOf('IMPORT')>=0) 
                                            });
                                            $scope.projectOwners = [];
                                            var onProjectsChange = function(){
                                                var previousValue = $scope.joinProjectsForm.model.owner
                                                $scope.joinProjectsForm.model.owner = null
                                                $scope.projectOwners = [];
                                                for(var i=0; i<$scope.joinableProjects.length; i++){
                                                    if($scope.projectOwners.filter(function(o){ return o.value==$scope.joinableProjects[i].owner }).length==0
                                                        && $scope.joinProjectsForm.model.projects.indexOf($scope.joinableProjects[i].id)>=0){
                                                        $scope.projectOwners.push({ value: $scope.joinableProjects[i].owner, label: $scope.joinableProjects[i].ownerName })
                                                        if(previousValue==$scope.joinableProjects[i].owner){
                                                            $scope.joinProjectsForm.model.owner = $scope.joinableProjects[i].owner
                                                        }
                                                    }
                                                }
                                                if($scope.projectOwners.length==1) {
                                                    $scope.joinProjectsForm.model.owner = $scope.projectOwners[0].value
                                                } 
                                                if($scope.projectOwners.length>1 && $scope.joinProjectsDefaultUser && $scope.projectOwners.filter(function(o){ return o.value==$scope.joinProjectsDefaultUser }).length){
                                                    $scope.joinProjectsForm.model.owner = $scope.joinProjectsDefaultUser
                                                }
                                                $scope.joinProjectsForm.fields.filter(function(f){ return f.name=='owner'})[0].options = $scope.projectOwners
                                            }
                                            
                                            $scope.joinProjectsForm = {
                                                title: 'labels.JOINPROJECTS',
                                                status: '',
                                                type: 'project',
                                                model: {
                                                    action: 'join',
                                                    projects: [ $scope.model.id ],
                                                    owner: $scope.projectOwners.length==1 ? $scope.projectOwners[0].value : null
                                                },
                                                fields: [
                                                    {
                                                        available: true,
                                                        type: 'checkboxesProjects',
                                                        name: 'projects',
                                                        data: $scope.joinableProjects,
                                                        valueField: 'id',
                                                        labelField: 'name',
                                                        onchange: function(){
                                                            onProjectsChange()
                                                        }
                                                    },{
                                                        available: true,
                                                        type: 'text',
                                                        name: 'name',
                                                        required: true
                                                    },{
                                                        available: $scope.model.group=='aag',
                                                        type: 'button',
                                                        name: 'empty',
                                                        btnLabel: 'labels.AUTONAME',
                                                        onClick: function(form, event){
                                                            event.preventDefault()
                                                            form.model.name = ''
                                                            for(var p in form.model.projects){
                                                                form.model.name += $scope.joinableProjects.filter(function(e){ return e.id==form.model.projects[p] })[0].name.split('_')[0] + ' '
                                                            }
                                                            form.model.name = form.model.name.trim()
                                                        }
                                                    },
                                                    {
                                                        available: true,
                                                        type: 'radio',
                                                        name: 'owner',
                                                        options: $scope.projectOwners,
                                                        required: true
                                                    },{
                                                        available: true,
                                                        type: 'submit',
                                                        name: 'empty'
                                                    }
                                                ],
                                                validate: function(){
                                                    var errors = [];
                                                        for(var j=0; j<this.fields.length; j++){
                                                            var field = this.fields[j];
                                                            if(field.required && !this.model[field.name] && this.model[field.name]!==false){
                                                                errors.push({field:field,error:'required'});
                                                            }
                                                            if(field.name=='projects' && this.model[field.name].length<2){
                                                                errors.push({field:field,error:'required'});
                                                            }
                                                        }
    
                                                    if(errors.length) {
                                                        var errorMessages ="<ul>";
                                                        for(var i=0; i<errors.length; i++){
                                                            var e = errors[i];
                                                            errorMessages += "<li>"
                                                                +$filter('translate')('labels.VALIDATIONERROR'+e.error.toUpperCase(), { name: $filter('translate')('fields.'+e.field.name.toUpperCase()) })
                                                                +"</li>";
                                                        }
                                                        errorMessages += "</ul>";
                                                        $scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), errorMessages);
                                                        return false;
                                                    }
                                                    else return true;
                                                },
                                                submit: function(){
                                                    if(this.validate()){
                                                        ngDialog.openConfirm({
                                                            template: '/app/views/entities/project-confirmjoinprojects.html',
                                                            className: 'ngdialog-theme-default',
                                                            scope: $scope
                                                        }).then(function (value) {
                                                                $scope.joinProjectsForm.status = 'submitting';
                                                                $scope.joinProjectsForm.model.action = 'join';
                                                                $scope.joinProjectsForm.model.taskId = '' + (3444246000000 - new Date().getTime())
                                                                D.save($scope.type, $scope.joinProjectsForm.model).then(
                                                                    function(response){
                                                                        FIREBASE.listen('TaskResult', $scope.joinProjectsForm.model.taskId, function (value) {
                                                                            if (value) {
                                                                                if (value.error) {
                                                                                    $timeout(function(){
                                                                                        $scope.joinProjectsForm.status = 'error';
                                                                                        if (value.exc == 'InvalidValueException') {
                                                                                            $scope.joinProjectsForm.errorLabel = $filter('translate')('labels.ERROR') + ': ' + $filter('translate')('fields.' + value.msg.split('=')[0].toUpperCase()) + ' (' + value.msg.split('=')[1] + ')'
                                                                                        }
                                                                                    }, 100)
                                                                                    
                                                                                } else {
                                                                                    $timeout(function(){
                                                                                        $scope.joinProjectsForm.progressMessage = 'Files: ' + (value.copied || '0') + '/' + (value.files || '0') + ' - Projects: ' + (value.closed || '0') + '/' + (value.projects || '0')
                                                                                    }, 100)
                                                                                }
                                                                                if (value.success) {
                                                                                    $scope.joinProjectsForm.status = 'submitted';
                                                                                    $timeout(function () {
                                                                                        $state.go('app.do', {
                                                                                            action: 'open',
                                                                                            type: 'project',
                                                                                            filter: value.project
                                                                                        }, {
                                                                                            reload: true
                                                                                        });
                                                                                    }, CONFIG.stateGoTimeout * 5)
                                                                                }
                                                                            }
                                                                        })
                                                                        
                                                                    }
                                                                    
                                                                ).catch(function(response){
                                                                        $scope.joinProjectsForm.status = 'error';
                                                                        if(response.data.exc=='InvalidValueException'){
                                                                            $scope.joinProjectsForm.errorLabel = $filter('translate')('labels.ERROR') + ': ' + $filter('translate')('fields.'+response.data.msg.split('=')[0].toUpperCase()) + ' (' + response.data.msg.split('=')[1] + ')'
                                                                        }
                                                                        
                                                                    });
                                                        });
                                                    }
                                                }
                                            }
                                            onProjectsChange()
                                        }).catch(console.error)
                                    }

                                    if($state.params.action=='addsupplier'){
                                        $scope.otherSuppliers = [];
                                        for(var i=0; i<$scope.suppliers.length; i++){
                                            if($scope.model.suppliers.indexOf($scope.suppliers[i].supplier)<0){
                                                $scope.otherSuppliers.push($scope.suppliers[i]);
                                            }
                                        }
                                    
                                        $scope.addSupplierForm = {
                                            title: '',
                                            status: '',
                                            type: 'project',
                                            model: $scope.model,
                                            successLabel: 'labels.SUCCESSSAVE',
                                            fields: [
                                                {
                                                    available: $scope.model.skipConfirm,
                                                    type: 'alert',
                                                    noLabel: true,
                                                    alertCls: 'warning',
                                                    message: $filter('translate')('labels.ALERTSKIPCONFIRMONADDSUPPLIER')
                                                },
                                                {
                                                    available: true,
                                                    type: 'static',
                                                    displayType: 'list',
                                                    displayField: 'name',
                                                    name: 'suppliersData',
                                                    label: 'fields.SELECTEDSUPPLIERS'
                                                },{
                                                    available: true,
                                                    type: 'checkboxes',
                                                    name: 'newsuppliers',
                                                    labels: 'fields.NEWSUPPLIERS',
                                                    data: $scope.otherSuppliers,
                                                    valueField: 'supplier',
                                                    labelField: 'supplierName',
                                                    required: true
                                                },{
                                                    available: true,
                                                    type: 'separator'
                                                },{
                                                    available: true,
                                                    type: 'submit',
                                                    name: 'empty',
                                                    label: 'labels.ADD'
                                                }

                                            ],
                                            validate: function(){
                                                var errors = [];
                                                    for(var j=0; j<this.fields.length; j++){
                                                        var field = this.fields[j];
                                                        if(field.required && !this.model[field.name] && this.model[field.name]!==false){
                                                            errors.push({field:field,error:'required'});
                                                        }
                                                    }

                                                if(errors.length) {
                                                    var errorMessages ="<ul>";
                                                    for(var i=0; i<errors.length; i++){
                                                        var e = errors[i];
                                                        errorMessages += "<li>"
                                                            +$filter('translate')('labels.VALIDATIONERROR'+e.error.toUpperCase(), { name: $filter('translate')('fields.'+e.field.name.toUpperCase()) })
                                                            +"</li>";
                                                    }
                                                    errorMessages += "</ul>";
                                                    $scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), errorMessages);
                                                    return false;
                                                }
                                                else return true;
                                            },
                                            submit: function(){
                                                if(this.validate()){
                                                    ngDialog.openConfirm({
                                                        template: '/app/views/entities/project-confirmaddsuppliers.html',
                                                        className: 'ngdialog-theme-default',
                                                        scope: $scope
                                                    }).then(function (value) {
                                                            $scope.addSupplierForm.status = 'submitting';
                                                            $scope.model.action = 'addSuppliers';
                                                            D.save($scope.type, $scope.model).then(
                                                                function(response){
                                                                    $scope.addSupplierForm.status = 'submitted';
                                                                    $timeout(function(){ $state.go('app.do',
                                                                            {action:'open', type:'project', filter: $scope.model.id },
                                                                            { reload: true }); }, CONFIG.stateGoTimeout)
                                                                }
                                                                
                                                            ).catch(function(response){
                                                                    $scope.addSupplierForm.status = 'error';
                                                                });
                                                    });
                                                }
                                            }
                                        }
                                    }
                                    $scope.modifySourceForm = {
                                            title: '',
                                            status: '',
                                            type: 'project',
                                            model: $scope.model,
                                            successLabel: 'labels.SUCCESSSAVE',
                                            fields: [
                                                        {
                                                            available: true,
                                                            type: 'language',
                                                            name: 'source',
                                                            placeholder: 'labels.SELECTLANGUAGE',
                                                            required: true
                                                        },{
                                                            available: true,
                                                            type: 'separator'
                                                        },{
                                                            available: true,
                                                            type: 'submit',
                                                            name: 'empty',
                                                            label: 'labels.SAVE'
                                                        }

                                            ],
                                            validate: function(){
                                                var errors = [];
                                                    for(var j=0; j<this.fields.length; j++){
                                                        var field = this.fields[j];
                                                        if(field.required && !this.model[field.name] && this.model[field.name]!==false){
                                                            errors.push({field:field,error:'required'});
                                                        }
                                                    }

                                                if(errors.length) {
                                                    var errorMessages ="<ul>";
                                                    for(var i=0; i<errors.length; i++){
                                                        var e = errors[i];
                                                        errorMessages += "<li>"
                                                            +$filter('translate')('labels.VALIDATIONERROR'+e.error.toUpperCase(), { name: $filter('translate')('fields.'+e.field.name.toUpperCase()) })
                                                            +"</li>";
                                                    }
                                                    errorMessages += "</ul>";
                                                    $scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), errorMessages);
                                                    return false;
                                                }
                                                else return true;
                                            },
                                            submit: function(){
                                                if(this.validate()){
                                                    ngDialog.openConfirm({
                                                        template: '/app/views/entities/project-confirmedit.html',
                                                        className: 'ngdialog-theme-default',
                                                        scope: $scope
                                                      }).then(function (value) {
                                                            $scope.modifySourceForm.status = 'submitting';
                                                            $scope.model.action = 'modifySource';
                                                            D.save($scope.type, $scope.model).then(
                                                                function(response){
                                                                    $scope.modifySourceForm.status = 'submitted';
                                                                    $state.go('app.entity', {action:'view',type:'project',filter:response.id});
                                                                }
                                                                
                                                            ).catch(function(response){
                                                                    $scope.modifySourceForm.status = 'error';
                                                                });
                                                      });
                                                }
                                            }
                                        };

                            $scope.adminFilesForm = {
                                    title: 'fields.SOURCEFILES',
                                    status: 'notsubmittable',
                                    type: 'project',
                                    model: $scope.model,
                                    fields: [
                                                {
                                                    available: true,
                                                    type: 'file',
                                                    name: 'upload',
                                                    limit: -1,
                                                    canUpload: true,
                                                    noLabel: true,
                                                    zipFilename: $scope.model.code + '_' + $filter('translate')('fields.SOURCEFILES').replace(' ','_'),
                                                    bucket: $rootScope.bucketName($scope.model.group) 
                                                }

                                    ],
                                    submit: function(){

                                    }
                                };

                            $scope.reviewForm = {
                                    title: 'labels.REUPLOADFILES',
                                    status: '', //$scope.model.changedFiles ? '' : 'notsubmittable',
                                    type: 'project',
                                    model: $scope.model,
                                    successLabel: 'labels.SUCCESSSAVE',
                                    fields: [
                                                {
                                                    available: true,
                                                    type: 'submit',
                                                    name: 'empty',
                                                    label: 'labels.RESENDTOADMIN'
                                                },{
                                                    available: true,
                                                    type: 'file',
                                                    name: 'upload',
                                                    limit: -1,
                                                    canUpload: $rootScope.user.groupType=='CLIENT',
                                                    onupload: function(){
                                                    	$scope.reviewForm.status = '';
                                                    	$scope.viewChangeStatusForm = false;
                                                    },
                                                    onremove: function(){
                                                    	$scope.reviewForm.status = '';
                                                    	$scope.viewChangeStatusForm = false;
                                                    },
                                                    bucket: $rootScope.bucketName($scope.model.group)
                                                }

                                    ],
                                    submit: function(){
                                        $scope.reviewForm.status = 'submitting';
                                        $scope.model.action = 'review';
                                        D.save($scope.type, $scope.model).then(
                                            function(response){
                                                loadingProject = true;
                                                $scope.reviewForm.status = 'submitted';
                                                $timeout(function(){ $state.go('app.entity', {action:'view',type:'project',filter:response.id}, { reload: true}); }, CONFIG.stateGoTimeout)
                                            }
                                            
                                        ).catch(function(response){
                                                $scope.reviewForm.status = 'error';
                                            });
                                    }
                                };

                                $scope.deliverForm = {
                                	status: '',
                                	type: 'project',
                                	model: $scope.model,
                                	fields: [
    									{
    										available: true,
                                            type: 'submit',
                                            name: 'empty',
                                            label: 'labels.DELIVERPROJECT',
                                            noLabel: true,
                                            cancel: 'back'
    									}
                                	],
                                    submit: function(){
                                    	ngDialog.openConfirm({
                                            template: '/app/views/entities/project-confirmdeliver.html',
                                            className: 'ngdialog-theme-default',
                                            scope: $scope
                                          }).then(function (value) {
    		                                    $scope.deliverForm.status = 'submitting';
                                                $scope.model.action = 'deliver';
                                                D.save($scope.type, $scope.model).then(
    		                                        function(response){
                                                        loadingProject = true;
    		                                            $scope.deliverForm.status = 'submitted';
    		                                            $timeout(function(){ $state.go('app.entity', {action:'view',type:'project',filter:response.id}, { reload: true }); }, CONFIG.stateGoTimeout)
    		                                        }
    		                                        
    		                                    ).catch(function(err){
    		                                            $scope.deliverForm.status = 'error';
                                                        if(err.data && err.data.exc && err.data.exc=='InvalidValueException'){
                                                            if(err.data.msg.indexOf('webdavFileExists=')===0){
                                                                $scope.deliverForm.errorLabel = $filter('translate')('labels.WEBDAVFILEEXISTS', { file: err.data.msg.substring('webdavFileExists='.length) })
                                                            }
                                                        }	
    		                                        });
                                          });
                                    }

                                };

                            $scope.stopForm = {
                            	status: '',
                            	type: 'project',
                            	model: $scope.model,
                            	fields: [
									{
										available: true,
                                        type: 'submit',
                                        name: 'empty',
                                        label: 'labels.CLOSEPROJECT',
                                        noLabel: true,
                                        cancel: 'back'
									}
                            	],
                                submit: function(){
                                	ngDialog.openConfirm({
                                        template: '/app/views/entities/project-confirmstop.html',
                                        className: 'ngdialog-theme-default',
                                        scope: $scope
                                      }).then(function (value) {
		                                    $scope.stopForm.status = 'submitting';
                                            $scope.model.action = 'stop';
                                            D.save($scope.type, $scope.model).then(
		                                        function(response){
                                                    loadingProject = true;
		                                            $scope.stopForm.status = 'submitted';
		                                            $timeout(function(){ $state.go('app.entity', {action:'view',type:'project',filter:response.id}, { reload: true}); }, CONFIG.stateGoTimeout)
		                                        }
		                                        
		                                    ).catch(function(response){
		                                            $scope.stopForm.status = 'error';
		                                        });
                                      });
                                }

                            };

                            $scope.deleteForm = {
                                	status: '',
                                	type: 'project',
                                	model: $scope.model,
                                	fields: [
                                	    {
                                	    	available: true,
                                            type: 'text',
                                            label: 'fields.CODE',
                                            name: 'controlCode'
                                        },
    									{
    										available: true,
                                            type: 'submit',
                                            name: 'empty',
                                            label: 'labels.CLOSEPROJECT',
                                            noLabel: true,
                                            cancel: 'back'
    									}
                                	],
                                    submit: function(){
                                    	ngDialog.openConfirm({
                                            template: '/app/views/entities/project-confirmdelete.html',
                                            className: 'ngdialog-theme-default',
                                            scope: $scope
                                          }).then(function (value) {
    		                                    $scope.reviewForm.status = 'submitting';
    		                                    $scope.model.action = 'delete';
    		                                    D.save($scope.type, $scope.model).then(
    		                                        function(response){
    		                                            $scope.reviewForm.status = 'submitted';
    		                                            $state.go('app.entity', {action:'list',type:'projects'});
    		                                        }
    		                                        
    		                                    ).catch(function(response){
    		                                            $scope.reviewForm.status = 'error';
    		                                        });
                                          });
                                    }

                                };

                            $scope.archiveForm = {
                                	status: '',
                                	type: 'project',
                                	model: $scope.model,
                                	fields: [
    									{
    										available: true,
                                            type: 'submit',
                                            name: 'empty',
                                            label: 'labels.ARCHIVEPROJECT',
                                            noLabel: true,
                                            cancel: 'back'
    									}
                                	],
                                    submit: function(){
                                    	ngDialog.openConfirm({
                                            template: '/app/views/entities/project-confirmarchive.html',
                                            className: 'ngdialog-theme-default',
                                            scope: $scope
                                          }).then(function (value) {
    		                                    $scope.archiveForm.status = 'submitting';
                                                $scope.model.action = 'archive';
                                                D.save($scope.type, $scope.model).then(
    		                                        function(response){
                                                        loadingProject = true;
    		                                            $scope.archiveForm.status = 'submitted';
    		                                            $timeout(function(){ $state.go('app.entity', {action:'view',type:'project',filter:response.id}, { reload: true }); }, CONFIG.stateGoTimeout)
    		                                        }
    		                                        
    		                                    ).catch(function(response){
    		                                            $scope.archiveForm.status = 'error';
    		                                        });
                                          });
                                    }

                                };

                                D.query('group','id='+$scope.model.group, { cache: false }).then(
                                    function(response){
                                        if($rootScope.user.admin){
                                            $scope.hasQAi=response[0].opts.hasQAi;
                                        }else if($rootScope.user.groupType=='CLIENT'){
                                            $scope.hasQAi=$rootScope.user.group.opts.hasQAi;
                                        }else{
                                            $scope.hasQAi=false;
                                        }

                                        $scope.editForm = {
                                            title: '',
                                            status: '',
                                            type: 'project',
                                            model: $scope.model,
                                            successLabel: 'labels.SUCCESSSAVE',
                                            fields: [
                                                        {
                                                            available: true,
                                                            type: 'text',
                                                            name: 'name',
                                                            required: true
                                                        },{
                                                            available: true,
                                                            type: 'text',
                                                            name: 'clientCode',
                                                            required: $rootScope.user.group.id == 'fpr'
                                                        },{
                                                            available: true,
                                                            type: 'date',
                                                            name: 'delivery',
                                                            required: true
                                                        },{
                                                            available: $scope.ownerFieldAvailable,
                                                            type: 'select',
                                                            data: $scope.userSelect,
                                                            valueField: 'id',
                                                            labelField: 'name',
                                                            name: 'owner',
                                                            placeholder: 'labels.SELECTUSER'
                                                        },{
                                                            available: !!$scope.orders,
                                                            type: 'select',
                                                            name: 'order',
                                                            data: $scope.orders,
                                                            valueField: 'number',
                                                            labelField: 'number',
                                                            placeholder: '-'
                                                        },{
                                                            available: true,
                                                            type: 'static',
                                                            displayType: 'enum',
                                                            enumType: 'language',
                                                            name: 'source',
                                                            toggle: $scope.model.status!='REVISION' ? 'source' : '_'
                                                        },
                                                        {
                                                            available: false,
                                                            type: 'language',
                                                            name: 'source',
                                                            placeholder: 'labels.SELECTLANGUAGE',
                                                            required: true
                                                        },{
                                                            available: true,
                                                            type: 'static',
                                                            displayType: 'enumSet',
                                                            enumType: 'language',
                                                            name: 'destinations',
                                                            toggle: 'destinations'
                                                        },{
                                                            available: false,
                                                            type: 'language',
                                                            multiple: true,
                                                            name: 'destinations',
                                                            placeholder: 'labels.SELECTLANGUAGES',
                                                            required: true
                                                        },{
                                                            available: true,
                                                            type: 'radiocheckboxes',
                                                            name: 'dtp',
                                                            subName: 'dtpTypes',
                                                            subValueField: 'value',
                                                            subLabelField: 'label',
                                                            required: true,
                                                            options: [
                                                                {
                                                                    label: 'labels.YES',
                                                                    value: true,
                                                                    options: [
                                                                        {
                                                                            label: 'enums.dtp.LAYOUT_SOURCE',
                                                                            value: 'LAYOUT_SOURCE'
                                                                        },{
                                                                            label: 'enums.dtp.PDF_LOW',
                                                                            value: 'PDF_LOW'
                                                                        },{
                                                                            label: 'enums.dtp.PDF_HIGH',
                                                                            value: 'PDF_HIGH'
                                                                        },{
                                                                            label: 'enums.dtp.PLAIN',
                                                                            value: 'PLAIN'
                                                                        },{
                                                                            label: 'enums.dtp.GRAPHICTEXT',
                                                                            value: 'GRAPHICTEXT'
                                                                        }
                                                                    ]
                                                                },{
                                                                    label: 'labels.NO',
                                                                    value: false
                                                                }
                                                            ]
                                                        },{
                                                            available: $rootScope.user.group.opts.hasReviewInProject || ($rootScope.user.admin && $scope.userSelect[0] && $scope.userSelect[0].group.opts.hasReviewInProject), 
                                                            type: 'checkbox',
                                                            name: 'hasReview',
                                                            onchange: function(){
                                                                if(($rootScope.user.group.opts.hasReviewDeadline || ($rootScope.user.admin && $scope.userSelect[0] && $scope.userSelect[0].group.opts.hasReviewDeadline))){
                                                                    for(let i=0; i<$scope.editForm.fields.length; i++){
                                                                        if($scope.editForm.fields[i].name=='reviewDeadline'){
                                                                            $scope.editForm.fields[i].available = $scope.model.hasReview;
                                                                        }
                                                                    }
                                                                }
                                                                if(($rootScope.user.group.opts.canAnticipateReview || ($rootScope.user.admin && $scope.userSelect[0] && $scope.userSelect[0].group.opts.canAnticipateReview))){
                                                                    for(let i=0; i<$scope.editForm.fields.length; i++){
                                                                        if($scope.editForm.fields[i].name=='anticipateReview'){
                                                                            $scope.editForm.fields[i].available = $scope.model.hasReview;
                                                                        }
                                                                    }
                                                                }
                                                            }

                                                        },{
                                                            available: $scope.model.hasReview && (($rootScope.user.group.opts.hasReviewInProject || ($rootScope.user.admin && $scope.userSelect[0] && $scope.userSelect[0].group.opts.hasReviewInProject)) && ($rootScope.user.group.opts.canAnticipateReview || ($rootScope.user.admin && $scope.userSelect[0] && $scope.userSelect[0].group.opts.canAnticipateReview))), 
                                                            type: 'checkbox',
                                                            name: 'anticipateReview'
                                                        },{
                                                            available: $scope.model.hasReview && (($rootScope.user.group.opts.hasReviewInProject || ($rootScope.user.admin && $scope.userSelect[0] && $scope.userSelect[0].group.opts.hasReviewInProject)) && ($rootScope.user.group.opts.hasReviewDeadline || ($rootScope.user.admin && $scope.userSelect[0] && $scope.userSelect[0].group.opts.hasReviewDeadline))), 
                                                            type: 'number',
                                                            name: 'reviewDeadline',
                                                            style: { width: '4em' }
                                                        },{
                                                            available: true,
                                                            type: 'selectwithvalue',
                                                            name: 'charNumberLimit',
                                                            valueField: 'value',
                                                            labelField: 'label',
                                                            showValue: {
                                                                '': false, 'SOURCE': false, 'NUMBER': true
                                                            },
                                                            data: [
                                                                { value: '', label: 'enums.charNumberLimit.NO' },
                                                                { value: 'SOURCE', label: 'enums.charNumberLimit.SOURCE' },
                                                                { value: 'NUMBER', label: 'enums.charNumberLimit.NUMBERINPUT' }
                                                            ],
                                                            selectStyle: {  },
                                                            inputStyle: { marginTop: '4px' },
                                                            onchange: function(){
                                                                if($scope.model.charNumberLimit!='NUMBER'){
                                                                    $scope.model.charNumberLimitValue = ''
                                                                }
                                                            }
                                                        },{
                                                            available: true,
                                                            type: 'textarea',
                                                            name: 'notes'
                                                        },{
                                                            available: true,
                                                            type: 'suppliers',
                                                            name: 'suppliers',
                                                            data: $scope.suppliers,
                                                            valueField: 'supplier',
                                                            labelField: 'supplierName',
                                                            required: true
                                                        },{
                                                            available: true,
                                                            type: 'checkbox',
                                                            name: 'urgentOffer'
                                                        },{
                                                            available: true,
                                                            type: 'datetime',
                                                            name: 'offerDeadline',
                                                            noWeekend: true,
                                                            placeholder: 'fields.TIME',
                                                            availableHours: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23],
                                                            hasTime: $rootScope.user.group.opts.offerDlFieldWTime || ($rootScope.user.admin && $scope.userSelect[0] && $scope.userSelect[0].group.opts.offerDlFieldWTime),
                                                            defaultTime: 64800
                                                        },{
                                                            available: true,
                                                            type: 'checkbox',
                                                            name: 'skipConfirm',
                                                            onchange: function(){
                                                                for(let i=0; i<$scope.editForm.fields.length; i++){
                                                                    if($scope.editForm.fields[i].name=='skipConfirmLimit'){
                                                                        $scope.editForm.fields[i].available = $scope.model.skipConfirm;
                                                                    }
                                                                }
            
                                                            }
                                                        },{
                                                            available: $scope.model.skipConfirm,
                                                            type: 'decimal',
                                                            displayType: 'decimal',
                                                            name: 'skipConfirmLimit',
                                                            column: 12,
                                                            def: 0,
                                                            decimals: 0,
                                                            decimalSep: $rootScope.user.decimalSep,
                                                            currency: $scope.model.currency,
                                                            labelParams: { currency: ($scope.model.currency)},
                                                            postfix: $filter('translate')('enums.currencySymbol.' + ($scope.model.currency))
                                                        },{
                                                            available: !$scope.model.skiprevision,
                                                            type: 'checkbox',
                                                            name: 'skipSourceReport',
                                                            checkboxLabel: 'labels.SKIPREVISION'
                                                        },{
                                                            available: $rootScope.user.group.opts.hasSectorInProject || ($rootScope.user.admin && $scope.userSelect[0] && $scope.userSelect[0].group.opts.hasSectorInProject),
                                                            type: 'select',
                                                            name: 'sector',
                                                            data: [{id:'',name:'-'}].concat(($rootScope.user.admin ? ($scope.userSelect[0] ? $scope.userSelect[0].group.sectors : []) : $rootScope.user.group.sectors) || []),
                                                            valueField: 'id',
                                                            labelField: 'name',
                                                            column: 12
                                                        },{
                                                            available: true,
                                                            type: 'file',
                                                            name: 'upload',
                                                            limit: -1,
                                                            canUpload: $rootScope.user.groupType=='CLIENT',
                                                            bucket: $rootScope.bucketName($scope.model.group)
                                                        },{
                                                            available: true,
                                                            type: 'checkbox',
                                                            name: 'sourceFilesVisible'
                                                        },{
                                                            available: $scope.model.group=='leo',
                                                            type: 'number',
                                                            decimals: 0,
                                                            name: 'sD',
                                                            label: 'fields.SERVICEDISCOUNT',
                                                            postfix: '%'
                                                        },{
                                                            available: $scope.hasQAi && ($rootScope.user.groupType=='CLIENT' || $rootScope.user.admin),
                                                            type: 'radiocheckboxes',
                                                            name: 'withQAi',
                                                            required: true,
                                                            options: [
                                                                {
                                                                    label: 'labels.YES',
                                                                    value: true
                                                                },{
                                                                    label: 'labels.NO',
                                                                    value: false
                                                                }
                                                            ]
                                                        },{
                                                            available: true,
                                                            type: 'separator'
                                                        },{
                                                            available: true,
                                                            type: 'submit',
                                                            name: 'empty',
                                                            label: 'labels.SAVE'
                                                        }

                                            ],
                                            validate: function(){
                                                var errors = [];
                                                    for(var j=0; j<this.fields.length; j++){
                                                        var field = this.fields[j];
                                                        if(field.required && !this.model[field.name] && this.model[field.name]!==false){
                                                            errors.push({field:field,error:'required'});
                                                        }
                                                    }

                                                if((this.model.dtp=="true" || this.model.dtp===true) && (!this.model.dtpTypes || this.model.dtpTypes.length==0)){
                                                    errors.push({field:selectField(this, 'dtp'),error:'required'});
                                                }
                                                if((this.model.urgentOffer==true && !this.model.offerDeadline) || (!this.model.offerDeadline && this.model.group=='leo')){
                                                    errors.push({field:selectField(this, 'offerDeadline'),error:'required'});
                                                }
                                                if(this.model.skipConfirm===true && this.model.suppliers.length>1){
                                                    errors.push({field:selectField(this, 'skipConfirm'),error:'onlyOneSupplierToSkipConfirm'});
                                                }
                                                if(this.model.charNumberLimit=='NUMBER' && !this.model.charNumberLimitValue){
                                                    errors.push({field:selectField(this, 'charNumberLimit'), error: 'required'});
                                                }
                                                if(this.model.hasReview && (''+this.model.reviewDeadline!='' && this.model.reviewDeadline!==null) && 
                                                    (isNaN(this.model.reviewDeadline) || isNaN(parseInt(this.model.reviewDeadline)) || parseInt(this.model.reviewDeadline)<0 || parseInt(this.model.reviewDeadline)>99)){
                                                    errors.push({field:selectField(this, 'reviewDeadline'), error: 'invalid'})
                                                }

                                                var fake = 0;
                                                var notFake = 0;
                                                var fakeSupplier = '';
                                                for(var i=0; i<this.model.suppliers.length; i++){
                                                    var id = this.model.suppliers[i];
                                                    var supplier = $scope.suppliers.filter(function(s) { return s.supplier==id})[0];
                                                    if(supplier.fake) {
                                                        fake++;
                                                        fakeSupplier = supplier.supplierName;
                                                    }
                                                    else notFake++;
                                                }
                                                if(fake>0 && notFake>0){
                                                    errors.push({field:this.fields[10],error:'fakeAndNotFakeSuppliers', data: fakeSupplier});
                                                }
                                                if(errors.length) {
                                                    var errorMessages ="<ul>";
                                                    for(var i=0; i<errors.length; i++){
                                                        var e = errors[i];
                                                        errorMessages += "<li>"
                                                            +$filter('translate')('labels.VALIDATIONERROR'+e.error.toUpperCase(), 
                                                                { 
                                                                    name: $filter('translate')('fields.'+e.field.name.toUpperCase()),
                                                                    data: e.data
                                                                })
                                                            +"</li>";
                                                    }
                                                    errorMessages += "</ul>";
                                                    $scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), errorMessages);
                                                    return false;
                                                }
                                                else return true;
                                            },
                                            submit: function(){
                                                if(this.validate()){
                                                    //Set dtpTypes to empty if dtp is 'no'
                                                    if(this.model.dtp === false || this.model.dtp === 'false') {
                                                        this.model.dtpTypes = [];
                                                    }
                                                    ngDialog.openConfirm({
                                                        template: '/app/views/entities/project-confirmedit.html',
                                                        className: 'ngdialog-theme-default',
                                                        scope: $scope
                                                    }).then(function (value) {
                                                            loadingProject = true;
                                                            $scope.editForm.status = 'submitting';
                                                            $scope.model.action = 'edit';
                                                            D.save($scope.type, $scope.model).then(
                                                                function(response){
                                                                    $scope.editForm.status = 'submitted';
                                                                    $timeout(function(){ $state.go('app.entity', {action:'view',type:'project',filter:response.id}, { reload: true }); }, CONFIG.stateGoTimeout)
                                                                }
                                                                
                                                            ).catch(function(response){
                                                                    if(response.status==500 && response.data.exc=='InvalidValueException'
                                                                        && response.data.msg.indexOf('beforeOfferDeadline')){
                                                                            $scope.editForm.errorLabel = 'labels.ERRORBEFOREOFFERDEADLINE'
                                                                        }
                                                                    $scope.editForm.status = 'error';
                                                                    loadingProject = false;
                                                                });
                                                    });
                                                }
                                            }
                                        }
                                        
                                        if ($scope.model.opts && $scope.model.opts.githubBranch && $scope.model.opts.githubRepo) {
                                            $scope.model.branches = [{
                                                branch: $scope.model.opts.githubBranch,
                                                branchName: $scope.model.opts.githubRepo,
                                                repobranch: $scope.model.opts.githubRepo + '/' + $scope.model.opts.githubBranch
                                            }];
                                        }

                                        $scope.viewForm = {
                                            title: '',
                                            status: '',
                                            type: 'project',
                                            model: $scope.model,
                                            fields: [
                                                {
                                                    available: true,
                                                    type: 'static',
                                                    name: 'name',
                                                    column: 6
                                                },{
                                                    available: !$scope.model.joinedInCode,
                                                    type: 'empty',
                                                    name: 'empty',
                                                    column: 6
                                                },{
                                                    available: !!$scope.model.joinedInCode,
                                                    type: 'static',
                                                    name: 'joinedInCode',
                                                    column: 6
                                                },
                                                //--------
                                                {   available: true, type: 'separator', noSpace: true },
                                                {
                                                    available: true,
                                                    type: 'static',
                                                    name: 'ownerName',
                                                    image: $rootScope.app.config.baseUrl + '/avatar/'+$scope.model.owner,
                                                    column: 6,
                                                    cls: 'maxH35'
                                                },{
                                                    available: true,
                                                    type: 'static',
                                                    name: 'clientCode',
                                                    column: 6
                                                },
                                                //--------
                                                {   available: !!$scope.model.order, type: 'separator', noSpace: true },
                                                {
                                                    available: !!$scope.model.order,
                                                    type: 'static',
                                                    name: 'order',
                                                    column: 6
                                                },{
                                                    available: !!$scope.model.order,
                                                    type: 'empty',
                                                    name: 'empty',
                                                    column: 6
                                                },
                                                //--------
                                                {   available: true, type: 'separator', noSpace: true },
                                                {
                                                    available: true,
                                                    type: 'static',
                                                    displayType: 'date',
                                                    name: 'createdOn',
                                                    column: 6
                                                },{
                                                    available: true,
                                                    type: 'static',
                                                    displayType: 'date',
                                                    name: 'delivery',
                                                    column: 6
                                                },
                                                //--------
                                                {   available: true, type: 'separator', noSpace: true },
                                                {
                                                    available: true,
                                                    type: 'static',
                                                    displayType: 'enum',
                                                    enumType: 'language',
                                                    name: 'source',
                                                    column: 6
                                                },{
                                                    available: true,
                                                    type: 'static',
                                                    displayType: 'enumSet',
                                                    enumType: 'language',
                                                    name: 'destinations',
                                                    column: 6
                                                },
                                                //--------
                                                {   available: true, type: 'separator', noSpace: true },
                                                {
                                                    available: true,
                                                    type: 'static',
                                                    displayType: 'boolean',
                                                    name: 'dtp',
                                                    column: 6
                                                },{
                                                    available: true,
                                                    type: 'static',
                                                    displayType: 'enumSet',
                                                    enumType: 'dtp',
                                                    name: 'dtpTypes',
                                                    column: 6
                                                },
                                                //--------
                                                {   available: $rootScope.user.group.opts.hasReviewInProject || $rootScope.user.admin, type: 'separator', noSpace: true }, 
                                                {
                                                    available: $rootScope.user.group.opts.hasReviewInProject || ($rootScope.user.admin),
                                                    type: 'static',
                                                    displayType: 'boolean',
                                                    name: 'hasReview',
                                                    column: 6
                                                },{
                                                    available: !!(($scope.model.hasReview) && (($rootScope.user.group.opts.hasReviewInProject && $rootScope.user.group.opts.canAnticipateReview) || ($rootScope.user.admin && $scope.model.hasReview))),
                                                    type: 'static',
                                                    displayType: 'boolean',
                                                    name: 'anticipateReview',
                                                    column: 6
                                                },{
                                                    available: !!(($scope.model.hasReview && $scope.model.reviewDeadline!=null && $scope.model.reviewDeadline>0) && (($rootScope.user.group.opts.hasReviewInProject && $rootScope.user.group.opts.hasReviewDeadline) || ($rootScope.user.admin && $scope.model.reviewDeadline))),
                                                    type: 'static',
                                                    displayType: 'number',
                                                    name: 'reviewDeadline',
                                                    column: 6
                                                },
                                                //--------
                                                {   available: true, type: 'separator', noSpace: true },
                                                {
                                                    available: true,
                                                    type: 'static',
                                                    displayType: 'enum',
                                                    enumType: 'charNumberLimit',
                                                    name: 'charNumberLimit',
                                                    column: 6,
                                                    withValue: true
                                                },{
                                                    available: true,
                                                    type: 'empty',
                                                    name: 'empty',
                                                    column: 6
                                                },
                                                //--------
                                                {   available: true, type: 'separator', noSpace: true },
                                                {
                                                    available: true,
                                                    type: 'static',
                                                    displayType: 'list',
                                                    displayField: 'name',
                                                    name: 'suppliersData',
                                                    column: 6
                                                },{
                                                    available: $scope.model.status=='CONFIRMED' || $scope.model.status=='PROCESSING' || $scope.model.status=='DELIVERED' || $scope.model.status=='ARCHIVED',
                                                    type: 'static',
                                                    name: 'supplierName',
                                                    label: 'fields.CHOSENSUPPLIER',
                                                    column: 6
                                                },{
                                                    available: !($scope.model.status=='CONFIRMED' || $scope.model.status=='PROCESSING' || $scope.model.status=='DELIVERED' || $scope.model.status=='ARCHIVED'),
                                                    type: 'empty',
                                                    name: 'empty',
                                                    column: 6
                                                },
                                                //--------
                                                {   available: true, type: 'separator', noSpace: true },
                                                {
                                                    available: true,
                                                    type: 'static',
                                                    displayType: 'boolean',
                                                    name: 'urgentOffer',
                                                    column: 6
                                                },{
                                                    available: true,
                                                    type: 'static',
                                                    displayType: 'date',
                                                    name: 'offerDeadlineWithTime',
                                                    label: 'fields.OFFERDEADLINE',
                                                    def: ' ',
                                                    column: 6,
                                                    format: $scope.model.offerDeadlineHasTime ? window.userDateFormat+' LT' : window.userDateFormat
                                                },
                                                //--------
                                                {   available: true, type: 'separator', noSpace: true },
                                                {
                                                    available: !$scope.model.skiprevision,
                                                    type: 'static',
                                                    displayType: 'boolean',
                                                    name: 'skipSourceReport',
                                                    label: 'labels.SKIPREVISION',
                                                    column: 6
                                                },{
                                                    available: !$scope.model.skiprevision,
                                                    type: 'empty',
                                                    name: 'empty',
                                                    column: 6
                                                },
                                                //--------
                                                {   available: true, type: 'separator', noSpace: true },
                                                {
                                                    available: true,
                                                    type: 'static',
                                                    displayType: 'boolean',
                                                    name: 'skipConfirm',
                                                    column: 6
                                                },{
                                                    available: $scope.model.skipConfirm && $scope.model.opts.skipConfirmLimit>0,
                                                    type: 'static',
                                                    displayType: 'currency',
                                                    name: 'skipConfirmLimit',
                                                    column: 6,
                                                    def: 0,
                                                    decimals: 0,
                                                    decimalSep: $rootScope.user.decimalSep,
                                                    currency: $scope.model.currency,
                                                    labelParams: { currency: ($scope.model.currency)}
                                                },{
                                                    available: !($scope.model.skipConfirm && $scope.model.opts.skipConfirmLimit>0),
                                                    type: 'empty',
                                                    name: 'empty',
                                                    column: 6
                                                },
                                                //--------
                                                {   available: true, type: 'separator', noSpace: true },
                                                {
                                                    available: true,
                                                    type: $scope.model.status=='DRAFT' && $rootScope.user.groupType=='CLIENT' ? 'checkbox' : 'static',
                                                    displayType: 'boolean',
                                                    name: 'sourceFilesVisible',
                                                    column: 6
                                                },
                                                {   available: true, type: 'separator', noSpace: true },
                                                {
                                                    available: $scope.hasQAi && ($rootScope.user.groupType=='CLIENT' || $rootScope.user.admin),
                                                    type: 'static',
                                                    name: 'withQAi',
                                                    displayType: 'boolean'
                                                },
                                                {
                                                    available: true,
                                                    type: 'empty',
                                                    name: 'empty',
                                                    column: 6
                                                },
                                                //--------
                                                {   available: true, type: 'separator', noSpace: true },
                                                {
                                                    available: !!$scope.model.sector,
                                                    type: 'static',
                                                    name: 'sectorName',
                                                    label: 'fields.SECTOR',
                                                    column: 6
                                                },{
                                                    available: !!$scope.model.sector,
                                                    type: 'empty',
                                                    name: 'empty',
                                                    column: 6
                                                },
                                                //--------
                                                {   available: $scope.model.group=='leo' && $rootScope.user.admin, type: 'separator', noSpace: true },
                                                {
                                                    available: $scope.model.group=='leo' && $rootScope.user.admin,
                                                    type: 'static',
                                                    name: 'sD',
                                                    displayType: 'perc',
                                                    total: 100,
                                                    decimals: 0,
                                                    label: 'fields.SERVICEDISCOUNT',
                                                    column: 6
                                                },{
                                                    available: $scope.model.group=='leo' && $rootScope.user.admin,
                                                    type: 'empty',
                                                    name: 'empty',
                                                    column: 6
                                                },
                                                //--------
                                                {   available: true, type: 'separator', noSpace: true },
                                                {
                                                    available: true,
                                                    type: 'staticFormatted',
                                                    name: 'notes',
                                                    column: 12
                                                },{
                                                    available: $rootScope.user.admin && $scope.model.innerNotes && $scope.model.innerNotes.length>0,
                                                    type: 'staticFormatted',
                                                    name: 'innerNotes',
                                                    column: 12
                                                },
                                                {
                                                    available: false && $scope.model.group=='tdi',
                                                    type: 'addoneelement',
                                                    name: 'branches',
                                                    canDelete: $scope.model.status=='DRAFT' && $rootScope.user.groupType=='CLIENT',
                                                    elementLabelField: 'repobranch',
                                                    onadd: function(event){
                                                        event.preventDefault();
                                                        
                                                        $scope.addBranchForm = $scope.addBranchFormFn($scope.viewForm)
                                                        
                                                        ngDialog.open({
                                                            template: '/app/views/entities/project-addbranch.html',
                                                            className: 'ngdialog-theme-default ngdialog-theme-large',
                                                            scope: $scope
                                                        })
                                                    },
                                                    onremove: function(index, element){
                                                        $scope.viewForm.model.branches.splice(index,1)
                                                    }
                                                },{
                                                    available: true,
                                                    type: 'file',
                                                    name: 'upload',
                                                    label: false && $scope.model.group=='tdi' ? 'fields.UPLOADFILESANDSCREENSHOTS' : 'fields.UPLOAD',
                                                    limit: -1,
                                                    canUpload: $scope.model.status=='DRAFT' && $rootScope.user.groupType=='CLIENT',
                                                    sync: {
                                                        folder: 'source',
                                                        download: true
                                                    },
                                                    tooltip: function(){ return $scope.model.status=='DRAFT' && $rootScope.user.groupType=='CLIENT' ? {
                                                        name: 'DRAFTPROJECTUPLOAD',
                                                        wait: 2,
                                                        position: 'top',
                                                        attachTo: '#Files_upload_' + $scope.model.id,
                                                        arrowSize: 'long'
                                                    } : null }(),
                                                    zipFilename: $scope.model.code + '_' + $filter('translate')('fields.SOURCEFILES').replace(' ','_'),
                                                    canUploadAsLink: $rootScope.user.group.opts.canUploadAsLink,
                                                    bucket: $rootScope.bucketName($scope.model.group)
                                                }
                                            ]
                                        }
                                    }
                                );

                            $scope.addBranchFormFn = function(form){

                                $scope.repositories = [];
                                $scope.branches = [];

                                var addBranchForm = {
                                    model: {},
                                    loading: false,
                                    fields: [
                                        {
                                            available: false,
                                            type: 'submit',
                                            label: 'labels.ADD'
                                        }
                                    ],
                                    validate: function(){
                                        var errors = [];
                                        for(var j = 0; j < this.fields.length; j++){
                                            var field = this.fields[j];
                                            if(field.required && !this.model[field.name] && this.model[field.name] !== false){
                                                errors.push({ field: field, error: 'required' });
                                            }
                                        }

                                        if(errors.length) {
                                            var errorMessages = "<ul>";
                                            for(var i = 0; i < errors.length; i++){
                                                var e = errors[i];
                                                errorMessages += "<li>"
                                                    + $filter('translate')('labels.VALIDATIONERROR' + e.error.toUpperCase(), {
                                                        name: $filter('translate')('fields.' + e.field.name.toUpperCase())
                                                    })
                                                    + "</li>";
                                            }
                                            errorMessages += "</ul>";
                                            $scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), errorMessages);
                                            return false;
                                        }

                                        return true;
                                    },
                                    submit: function(){
                                        if(addBranchForm.loading){
                                            return;
                                        }

                                        if(!addBranchForm.model.repository || !addBranchForm.model.branch){
                                            return;
                                        }

                                        if(this.validate()){

                                            addBranchForm.loading = true;

                                            var payload = {
                                                id: 'GetFilesFromGitHub',
                                                project: form.model.id,
                                                repository: addBranchForm.model.repository,
                                                branch: addBranchForm.model.branch
                                            };

                                            D.save('github/GetFilesFromGitHub', payload).then(
                                                function(res){

                                                    if(!form.model.branches) form.model.branches = [];

                                                    form.model.branches.push({
                                                        repository: addBranchForm.model.repository,
                                                        repositoryName: addBranchForm.model.repositoryName,
                                                        branch: addBranchForm.model.branch,
                                                        branchName: addBranchForm.model.branchName,
                                                        repobranch: addBranchForm.model.repository + '/' + addBranchForm.model.branch
                                                    });

                                                    var refreshBtnId = 'refresh_upload_' + (form.model.id || form.model.tempId);

                                                    $timeout(function(){
                                                        var refreshBtn = document.getElementById(refreshBtnId);
                                                        if(refreshBtn){
                                                            refreshBtn.click();
                                                        }
                                                        ngDialog.close();
                                                    }, 100);
                                                },
                                                function(err){
                                                    $scope.pop('error', 'Error', 'GitHub import error');
                                                    console.error(err);
                                                }
                                            ).finally(function(){
                                                addBranchForm.loading = false;
                                            });
                                        }
                                    }
                                };

                                D.query('github', 'repositories', { cache: false }).then(
                                    function(res){
                                        $scope.repositories = Array.isArray(res) ? res : (res.data || res.items || []);

                                        addBranchForm.fields.splice(0, 0, {
                                            available: true,
                                            type: 'radiowithcontent',
                                            name: 'repository',
                                            valueField: 'full_name',
                                            labelField: 'full_name',
                                            required: true,
                                            placeholder: 'Select repository',
                                            options: $scope.repositories,
                                            optionsMap: $scope.repositories.reduce((acc, p) => {
                                                acc[p.full_name] = p;
                                                return acc;
                                            }, {}),
                                            onselect: function(option){
                                                addBranchForm.model.repository = option.full_name;
                                                addBranchForm.model.repositoryName = option.full_name;
                                                addBranchForm.model.branch = null;
                                                addBranchForm.model.branchName = null;

                                                for(let i = addBranchForm.fields.length - 1; i >= 0; i--){
                                                    let f = addBranchForm.fields[i];
                                                    if(f.name != 'repository' && f.name != 'branch' && f.type != 'submit'){
                                                        addBranchForm.fields.splice(i, 1);
                                                    }
                                                    if(f.name == 'branch'){
                                                        addBranchForm.fields.splice(i, 1);
                                                    }
                                                }

                                                for(let i = 0; i < addBranchForm.fields.length; i++){
                                                    if(addBranchForm.fields[i].type == 'submit'){
                                                        addBranchForm.fields[i].available = false;
                                                    }
                                                }

                                                D.query('github', 'branches&repository=' + encodeURIComponent(option.full_name), { cache: false }).then(
                                                    function(res){
                                                        $scope.branches = Array.isArray(res) ? res : (res.data || res.items || []);

                                                        addBranchForm.fields.splice(1, 0, {
                                                            available: true,
                                                            type: 'radiowithcontent',
                                                            name: 'branch',
                                                            valueField: 'name',
                                                            labelField: 'name',
                                                            required: true,
                                                            placeholder: 'Select branch',
                                                            options: $scope.branches,
                                                            optionsMap: $scope.branches.reduce((acc, p) => {
                                                                acc[p.name] = p;
                                                                return acc;
                                                            }, {}),
                                                            onselect: function(branchOption){
                                                                addBranchForm.model.branch = branchOption.name;
                                                                addBranchForm.model.branchName = branchOption.name;

                                                                for(let i = 0; i < addBranchForm.fields.length; i++){
                                                                    if(addBranchForm.fields[i].type == 'submit'){
                                                                        addBranchForm.fields[i].available = true;
                                                                    }
                                                                }
                                                            }
                                                        });
                                                    },
                                                    function(err){
                                                        $scope.branches = [];
                                                        $scope.pop('error', 'Error', 'GitHub branch import error');
                                                        console.error(err);
                                                    }
                                                );
                                            }
                                        });
                                    },
                                    function(err){
                                        $scope.repositories = [];
                                        $scope.pop('error', 'Error', 'GitHub repository import error');
                                        console.error(err);
                                    }
                                );

                                return addBranchForm;
                            };
                            
                            $scope.viewFormInAnalysis = {
                                title: '',
                                status: '',
                                type: 'project',
                                model: $scope.model,
                                fields: [
                                    {
                                        available: true,
                                        type: 'static',
                                        name: 'ownerName',
                                        image: $rootScope.app.config.baseUrl + '/avatar/'+$scope.model.owner,
                                        column: 6,
                                        cls: 'maxH35'
                                    },
                                    //--------
                                    {   available: true, type: 'separator', noSpace: true },
                                    {
                                        available: true,
                                        type: 'static',
                                        displayType: 'date',
                                        name: 'createdOn',
                                        column: 6
                                    },{
                                        available: true,
                                        type: 'static',
                                        displayType: 'date',
                                        name: 'delivery',
                                        column: 6
                                    },
                                    //--------
                                    {   available: true, type: 'separator', noSpace: true },
                                    {
                                        available: true,
                                        type: 'static',
                                        displayType: 'boolean',
                                        name: 'dtp',
                                        column: 6
                                    },{
                                        available: true,
                                        type: 'static',
                                        displayType: 'enumSet',
                                        enumType: 'dtp',
                                        name: 'dtpTypes',
                                        column: 6
                                    },
                                    //--------
                                    {   available: $rootScope.user.group.opts.hasReviewInProject || $rootScope.user.admin, type: 'separator', noSpace: true }, 
                                    {
                                        available: $rootScope.user.group.opts.hasReviewInProject || ($rootScope.user.admin && $scope.model.group!=='aag'),
                                        type: 'static',
                                        displayType: 'boolean',
                                        name: 'hasReview',
                                        column: 6
                                    },{
                                        available: !!(($scope.model.hasReview) && (($rootScope.user.group.opts.hasReviewInProject && $rootScope.user.group.opts.canAnticipateReview) || ($rootScope.user.admin && $scope.model.hasReview))),
                                        type: 'static',
                                        displayType: 'boolean',
                                        name: 'anticipateReview',
                                        column: 6
                                    },{
                                        available: !!(($scope.model.hasReview && $scope.model.reviewDeadline!=null && $scope.model.reviewDeadline>0) && (($rootScope.user.group.opts.hasReviewInProject && $rootScope.user.group.opts.hasReviewDeadline) || ($rootScope.user.admin && $scope.model.reviewDeadline))),
                                        type: 'static',
                                        displayType: 'number',
                                        name: 'reviewDeadline',
                                        column: 6
                                    },{
                                        available: $rootScope.user.group.opts.hasReviewInProject || ($rootScope.user.admin && $scope.model.group!=='aag'),
                                        type: 'empty',
                                        name: 'empty',
                                        column: 6
                                    },
                                    //--------
                                    {   available: true, type: 'separator', noSpace: true },
                                    {
                                        available: true,
                                        type: 'static',
                                        displayType: 'enum',
                                        enumType: 'charNumberLimit',
                                        name: 'charNumberLimit',
                                        column: 6,
                                        withValue: true
                                    },{
                                        available: true,
                                        type: 'empty',
                                        name: 'empty',
                                        column: 6
                                    },
                                    //--------
                                    {   available: true, type: 'separator', noSpace: true },
                                    {
                                        available: true,
                                        type: 'static',
                                        displayType: 'list',
                                        displayField: 'name',
                                        name: 'suppliersData',
                                        column: 6
                                    },
                                    //--------
                                    {   available: true, type: 'separator', noSpace: true },
                                    {
                                        available: true,
                                        type: 'static',
                                        displayType: 'boolean',
                                        name: 'urgentOffer',
                                        column: 6
                                    },{
                                        available: true,
                                        type: 'static',
                                        displayType: 'date',
                                        name: 'offerDeadlineWithTime',
                                        label: 'fields.OFFERDEADLINE',
                                        def: ' ',
                                        column: 6,
                                        format: $scope.model.offerDeadlineHasTime ? window.userDateFormat+' LT' : window.userDateFormat
                                    },
                                    //--------
                                    {   available: true, type: 'separator', noSpace: true },
                                    {
                                    	available: true,
                                    	type: 'static',
                                    	displayType: 'boolean',
                                    	name: 'sourceFilesVisible',
                                    	column: 6
                                    },{
                                        available: true,
                                        type: 'empty',
                                        name: 'empty',
                                        column: 6
                                    },
                                    //--------
                                    {   available: true, type: 'separator', noSpace: true },
                                    {
                                    	available: !!$scope.model.sector,
                                    	type: 'static',
                                        name: 'sectorName',
                                        label: 'fields.SECTOR',
                                    	column: 6
                                    },{
                                        available: !!$scope.model.sector,
                                        type: 'empty',
                                        name: 'empty',
                                        column: 6
                                    },
                                    //--------
                                    {   available: true, type: 'separator', noSpace: true },
                                    {
                                        available: true,
                                        type: 'staticFormatted',
                                        name: 'notes',
                                        column: 12
                                    }
                                ]
                            };


                            $scope.listenToChangesFn = function(){
                                var listenedP = ''+$scope.id;
                                $scope.onProjectChanged = function(value, lp){
                                    if(lp==$scope.id && lp==$state.params.filter){
                                        if(!loadingProject){
                                            if($state.params.action=='edit'){
                                                /*$scope.editForm.status = 'notsubmittable';
                                                ngDialog.openConfirm({
                                                    template: '/app/views/entities/project-confirmrefresh.html',
                                                    className: 'ngdialog-theme-default',
                                                    scope: $scope
                                                    }).then(function (value) {
                                                        $timeout(function(){ $state.go($state.current, {}, {reload: true}); }, CONFIG.stateGoTimeout)
                                                    })*/
                                            } else {
                                                D.load($scope.type, $scope.id).then(
                                                    function(updatedProject){
                                                        if(updatedProject.status!=$scope.model.status){
                                                            if(updatedProject.status=='SENT' && $scope.model.status=='DRAFT') {
                                                                $timeout(function(){ $state.go($state.current, {}, {reload: true}); }, CONFIG.stateGoTimeout)
                                                                return;
                                                            }
                                                            if(updatedProject.status=='PROCESSING' && $scope.model.status=='CONFIRMED') return;
                                                            /*TODO $timeout(function(){
                                                                $scope.pop('warning', $filter('translate')('labels.PROJECTUPDATED'), 
                                                                    $filter('translate')('labels.PROJECTUPDATEDINFO', {model: $scope.model}) + $filter('translate')('labels.PROJECTUPDATEDINFOBUTTONS', {model: $scope.model}))
                                                            }, 5000)*/
                                                        }
                                                    }).catch(console.error)
                                            }
                                        }
                                    }
                                }
                                
                                if($scope.id){
                                    FIREBASE.listen('Project', $scope.id, function(value){
                                        if(value && FIREBASE.isAfter(value.timestamp,$scope.model.T)){
                                            $scope.onProjectChanged(value, listenedP);
                                        }
                                    }, null, { interval: 60000 });
                                }
                                
                            }
                            $scope.listenToChangesFn();

                            $scope.viewChangeStatusForm = $scope.model.status=='DRAFT' || $rootScope.user.admin;
                            if($scope.model.status=='DRAFT' && $rootScope.user.groupType=='CLIENT'){
                            	$scope.viewChangeStatusForm = $rootScope.files['project'+$scope.model.id+'upload'] && $rootScope.files['project'+$scope.model.id+'upload'].length>0;
                            	$rootScope.$watch('files[\'project'+$scope.model.id+'upload\']', function(){
                            		$scope.viewChangeStatusForm = $rootScope.files['project'+$scope.model.id+'upload'] && $rootScope.files['project'+$scope.model.id+'upload'].length>0;
                            		$scope.uploadedFiles = $rootScope.files['project'+$scope.model.id+'upload'];
                            	});
                            }
                            if($scope.model.status=='SENT' && !$scope.model.assignee)
                                $scope.viewChangeStatusForm = false;
                            if($scope.model.status=='DRAFT' && $rootScope.user.groupType=='ADMIN'){
                            	$scope.viewChangeStatusForm = false;
                            }
                            if($scope.model.status=='ESTIMATION' && $state.params.action=='view')
                                $scope.viewChangeStatusForm = false;
                            if($scope.model.status=='ESTIMATION' && $state.params.action=='offers')
                                $scope.viewChangeStatusForm = false;
                            if($scope.model.status=='CONFIRMED' && $rootScope.user.groupType=='SUPPLIER')
                            	$scope.viewChangeStatusForm = true;
                            if($scope.model.status=='CONFIRMED' && $rootScope.user.groupType=='CLIENT')
                            	$scope.viewChangeStatusForm = false;
                            if($scope.model.status=='REVISION')
                            	$scope.viewChangeStatusForm = false;
                            if($scope.model.status=='REVISION' && $rootScope.user.groupType=='CLIENT'){
                            	$scope.viewChangeStatusForm = true;
                            	if($scope.model.changedFiles)
                            		$scope.viewChangeStatusForm = false;
                            }
                            if($scope.model.status=='PROCESSING' || $scope.model.status=='DELIVERED' || $scope.model.status=='ARCHIVED')
                            	$scope.viewChangeStatusForm = false;
                            if(($scope.model.status=='PROCESSING' || $scope.model.status=='CONFIRMED') && $rootScope.user.admin)
                            	$scope.viewChangeStatusForm = false;
                            if($scope.model.status=='STOPPED')
                                $scope.viewChangeStatusForm = false;
                            if($scope.model.status=='ANALYSIS' && $state.params.action!=='analyze'){
                                $scope.viewChangeStatusForm = false;
                            }

                            if($rootScope.user.admin){
                                $scope.$watch('model.skiprevision', function(){
                                    if($scope.analysisForm && $scope.analysisForm['clientNotes'] && $scope.analysisForm['clientNotes'].fields){
                                        $scope.analysisForm['clientNotes'].fields[0].available = $scope.model.skiprevision;
                                    }
                                    if($scope.changeStatusForm){
                                        $scope.changeStatusForm.model = $scope.model;
                                    }
                                });

                                D.load('group', $scope.model.group, { cache: false }).then(function(response){
                                    $scope.model.skiprevision = response.opts.skipSourceReport;
                                    //$scope.model.clientNotes = response.notes;
                                    if(!$scope.model.skiprevision && $scope.model.skipSourceReport){
                                        $scope.model.skiprevision = $scope.model.skipSourceReport;
                                    }
                                    $scope.joinProjectsDefaultUser = response.opts.joinProjectsDefaultUser
                                });
                            }

                            $scope.openWordsPreview = function(){
                                D.load('packet', 'current').then(function(response){
                                    $scope.currentPacket = response
                                }).catch(console.error)
                                ngDialog.open({
                                    template: '/app/views/entities/project-wordspreview.html',
                                    className: 'ngdialog-theme-default ngdialog-theme-large',
                                    scope: $scope,
                                    cache: false
                                  });
                            }
                            
                            if($scope.model.status === 'ANALYSIS') { 
                                $scope.model.automaticOffer = true 
                                if($scope.model.hasGlossary){
                                    D.query('file', { field: 'glossary', type: 'group', entityid: $scope.model.group }, { cache: false }).then(function(response){
                                        if(response.length){
                                            //$scope.model.glossary = response.map(function(f){ return f.name })
                                            $scope.changeStatusForm.fields[$scope.changeStatusForm.fields.findIndex(function(f){ return f.name=='glossary'})].data = response.sort(function(a,b){ return a.name.localeCompare(b.name) })
                                        }
                                    }).catch(console.error)
                                }
                                if($scope.model.hasReview){
                                    D.query('account', 'customRole=REVIEWER&_disabled=false&groupId='+$scope.model.group, { cache: false }).then(
                                        function(response){
                                            
                                            $scope.missingReviewers=[];
                                            for(var dest in $scope.model.destinations){
                                                $scope.missingReviewers.push($scope.model.destinations[dest]);
                                                for(var revDest=0; revDest<response.length; revDest++){
                                                    if($scope.model.group == response[revDest].groupId){
                                                        if($scope.model.destinations[dest]==response[revDest].opts.reviewLanguage && $scope.model.group == response[revDest].groupId){
                                                            $scope.missingReviewers.pop();
                                                        }
                                                    }
                                                }
                                            }
                                            if($scope.missingReviewers.length>0){
                                                const msg1 = $filter('translate')('labels.TRANSLATIONSWITHOUTREVIEWERS');
                                                let msg2 = '<br/>';
                                                for(var missRev in $scope.missingReviewers){
                                                    msg2 = msg2+$scope.missingReviewers[missRev]+'<br/>'
                                                }
                                                const msg3 = $filter('translate')('labels.CONFIRMSTATUSCHANGE');
                                                $scope.additionalMessage=msg1+msg2+msg3;
                                            }
                                            
                                        },
                                        function(error){
                                            $scope.error = error;
                                        }
                                    ).catch(console.error);
                                }
                            }
                            $scope.changeStatusForm = {
                                title: 'labels.CHANGESTATUSFROM' + $scope.model.status,
                                status: '',
                                type: 'project',
                                model: $scope.model,
                                fields: [
                                    {
                                        available: $scope.model.status === 'ANALYSIS' && $scope.model.hasGlossary,
                                        type: 'checkboxes',
                                        name: 'glossary',
                                        labelColumn: 4,
                                        inputColumn: 8,
                                        labelField: 'name',
                                        valueField: 'name',
                                        data: [],
                                        subLabelField: 'instructions'
                                    },{
                                        available: $scope.model.status === 'ANALYSIS',
                                        type: 'checkbox',
                                        name: 'skiprevision',
                                        labelColumn: 4,
                                        inputColumn: 4
                                    },{
                                        available: $scope.model.status === 'ANALYSIS',
                                        type: 'static',
                                        displayType: 'boolean',
                                        name: 'skipConfirm',
                                        labelColumn: 4,
                                        inputColumn: 4
                                    },{
                                        available: $scope.model.status === 'ANALYSIS' && $scope.model.skipConfirmLimit>0,
                                        type: 'static',
                                        displayType: 'currency',
                                        name: 'skipConfirmLimit',
                                        decimals: 0,
                                        decimalSep: $rootScope.user.decimalSep,
                                        currency: $scope.model.currency,
                                        labelColumn: 4,
                                        inputColumn: 4
                                    },{
                                        available: $scope.model.status === 'ANALYSIS',
                                        type: 'checkbox',
                                        name: 'automaticOffer',
                                        labelColumn: 4,
                                        inputColumn: 4
                                    },{
                                        available: ($scope.model.status === 'ANALYSIS' || $scope.model.status=='SENT') && $scope.model.dtp && $scope.model.suppliers.length>1 && !$scope.model.code.endsWith('-I'),
                                        type: 'checkbox',
                                        name: 'separateOffers',
                                        labelColumn: $scope.model.status === 'ANALYSIS' ? 4 : 8,
                                        inputColumn: 4
                                    },{
                                        available: $scope.model.status === 'REVISION' && $rootScope.user.group.opts.previewWords,
                                        type: 'button',
                                        noLabel: true,
                                        cls: 'btn-default btn-xs',
                                        btnLabel: 'labels.WORDSPREVIEW',
                                        onClick: function(form, event){
                                            event.preventDefault()
                                            $scope.openWordsPreview()
                                        },
                                        labelColumn: 4,
                                        inputColumn: 4
                                    },
                                    {
                                        available: $scope.model.status === 'ANALYSIS' && $scope.model.group === 'leo',
                                        type: 'number',
                                        decimals: 0,
                                        name: 'serviceDiscount',
                                        postfix: '%',
                                        labelColumn: 4,
                                        inputColumn: 4
                                    },
                                    {
                                        available: $scope.model.status === 'ANALYSIS',
                                        type: 'separator'
                                    },
                                    {
                                        available: true,
                                        type: 'submit',
                                        name: 'empty',
                                        label: 'labels.CONTINUE',
                                        labelColumn: $scope.model.status === 'ANALYSIS' ? 4 : 0,
                                        inputColumn: $scope.model.status === 'ANALYSIS' ? 4 : 12,
                                        tooltip: function(){ return $scope.model.status=='CONFIRMED' && $rootScope.user.groupType=='SUPPLIER' ? {
                                                name: 'STARTWORK',
                                                wait: 2,
                                                position: 'right',
                                                attachTo: '.app-field-empty input[type=submit]',
                                                arrowSize: 'long'
                                            } : null 
                                        }()
                                    }
                                ],
                                submit: function(){
                                    if($scope.model.status === 'ANALYSIS'){
                                        for(var dest in $scope.model.destinations){
                                            if(!($scope.analysis[$scope.model.source+'_'+$scope.model.destinations[dest]] 
                                                && $scope.analysis[$scope.model.source+'_'+$scope.model.destinations[dest]].analyzed 
                                                && $scope.analysis[$scope.model.source+'_'+$scope.model.destinations[dest]].file)){
                                                    $scope.pop('error',$filter('translate')('labels.MISSINGANALYSIS'));
                                                    return;
                                                }
                                        }
                                    }
                                    $scope.changeStatusForm.status = 'submitting';
                                    var confirmFn = ngDialog.openConfirm
                                    if($scope.model.status == 'SENT'){
                                        confirmFn = function(){
                                            return {
                                                then: function(f){
                                                    f(true)
                                                }
                                            }
                                        }
                                    }
                                    confirmFn({
                                      template: '/app/views/entities/project-confirm.html',
                                      className: 'ngdialog-theme-default',
                                      scope: $scope
                                    }).then(function (value) {
                                    		var previousStatus = $scope.model.status;
                                            $scope.model.status='NEXT';
                                            D.save($scope.type, $scope.model).then(
                                                function(response){
                                                    loadingProject = true;
                                                    $scope.changeStatusForm.status = 'submitted';
                                                    $scope.model = response;
                                                    $scope.listenToChangesFn();
                                                    if(response.status == 'ANALYSIS'){
                                                        $timeout(function(){ $state.go('app.entity',
                                                            {action:'analyze', type:'project', filter: $scope.model.id },
                                                            { reload: true }); }, CONFIG.stateGoTimeout)
                                                    } else if(response.status == 'PROCESSING'){
                                                        $timeout(function(){ $state.go('app.entity',
                                                                {action:'process', type:'project', filter: $scope.model.id },
                                                                { reload: true }); }, CONFIG.stateGoTimeout)
                                                    }
                                                    else{
                                                        $timeout(function(){ $state.go('app.entity',
                                                            {action:'view', type:'project', filter: $scope.model.id },
                                                            { reload: true }); }, CONFIG.stateGoTimeout)
                                                    }
                                                }
                                                
                                            ).catch(function(response){
                                                	$scope.model.status=previousStatus;
                                                    $scope.changeStatusForm.status = 'error';
                                                    if(response.data && response.data.msg && response.data.msg=='analysisPdf=0'){
                                                        $scope.changeStatusForm.errorLabel = 'labels.ERRORNOANALYSISPDF';
                                                    }
                                                    if(response.data && response.data.msg && response.data.msg=='suppliers=noreal'){
                                                        $scope.changeStatusForm.errorLabel = 'labels.ERRORNOREALSUPPLIERS';
                                                    }
                                                });
                                    }, function (reason) {
                                        $scope.changeStatusForm.status = '';
                                    });

                                }
                            };

                            $scope.initForceDeliveryForm = function(){
                                let deliverableLanguages = []
                                for(let i=0; i < $scope.translations.length; i++){
                                    if($scope.translations[i].status!='DELIVERED'){
                                        deliverableLanguages.push($scope.translations[i].destination)
                                    }
                                }
                                $scope.forceDeliveryForm = {
                                        title: 'labels.FORCEDELIVERYALL',
                                        status: '',
                                        type: 'project',
                                        model: Object.assign($scope.model, { languagesToBeDelivered: deliverableLanguages }),
                                        fields: [
                                            {
                                                available: true,
                                                type: 'checkboxes',
                                                name: 'languagesToBeDelivered',
                                                label: 'fields.LANGUAGES',
                                                data: $scope.translations.filter(function(t){ return t.status!='DELIVERED' }),
                                                valueField: 'destination',
                                                labelField: 'destination',
                                                labelEnum: 'language',
                                                hideSelectUnselectAll: true
                                            },{
                                                available: true,
                                                type: 'file',
                                                name: 'deliveryAll',
                                                canUpload: true,
                                                limit: -1,
                                                sync: {
                                                        folder: 'delivery', 
                                                        upload: true,
                                                        lang: '*',
                                                        code: $scope.model.code
                                                },
                                                bucket: $rootScope.bucketName($scope.model.group)
                                            },{
                                                available: true,
                                                type: 'submit',
                                                name: 'empty',
                                                label: 'labels.FORCEDELIVERYALL',
                                                labelColumn: 0
                                            }
                                        ],
                                        submit: function(){
                                            ngDialog.openConfirm({
                                                template: '/app/views/entities/translations-confirmdeliver.html',
                                                className: 'ngdialog-theme-default',
                                                scope: $scope
                                            }).then(function (value) {
                                                $scope.forceDeliveryForm.status = 'submitting';
                                                $scope.forceDeliveryForm.model.action = 'deliverAll';
                                                
                                                D.save('project', $scope.forceDeliveryForm.model).then(
                                                    function(response){
                                                        loadingProject = true;
                                                        $timeout(function(){ $state.go('app.entity', {
                                                            type: 'project',
                                                            filter: $scope.model.id,
                                                            action: 'process'
                                                        }, { reload: true }); }, CONFIG.stateGoTimeout)
                                                    }
                                                    
                                                ).catch(function(err){
                                                        $scope.forceDeliveryForm.status = 'error';
                                                        if(err.data && err.data.exc && err.data.exc=='InvalidValueException'){
                                                            if(err.data.msg.indexOf('webdavFileExists=')===0){
                                                                $scope.forceDeliveryForm.errorLabel = $filter('translate')('labels.WEBDAVFILEEXISTS', { file: err.data.msg.substring('webdavFileExists='.length) })
                                                            }
                                                        }	
                                                    });
                                            });
                                        }
                                    }
                                    if($scope.translations.filter(function(t){ return t.status!='DELIVERED' }).length<=1){
                                        $scope.forceDeliveryForm = null
                                    }
                                    $scope.forceBackForm = {
                                        title: 'labels.TRANSLATIONBACKFROMIMPORTALL',
                                        status: '',
                                        type: 'translation',
                                        model: Object.assign($scope.model, { languagesToBeSentBack: [] }),
                                        fields: [
                                            {
                                                available: true,
                                                type: 'checkboxes',
                                                name: 'languagesToBeSentBack',
                                                label: 'fields.LANGUAGES',
                                                data: $scope.translations.filter(function(t){ return t.status=='IMPORT' }),
                                                valueField: 'destination',
                                                labelField: 'destination',
                                                labelEnum: 'language',
                                                hideSelectUnselectAll: true
                                            },
                                            {
                                                available: true,
                                                type: 'submit',
                                                name: 'empty',
                                                label: 'labels.TRANSLATIONBACKFROMIMPORTALL',
                                                labelColumn: 0
                                            }
                                        ],
                                        submit: function(){
                                            ngDialog.openConfirm({
                                                template: '/app/views/entities/confirm.html',
                                                className: 'ngdialog-theme-default',
                                                scope: $scope
                                            }).then(function (value) {
                                                $scope.forceBackForm.status = 'submitting';
                                                $scope.forceBackForm.model.action = 'back';
                                                var sentBack = 0
                                                for(var l=0; l<$scope.model.languagesToBeSentBack.length; l++){
                                                    D.save('translation', Object.assign($scope.translations.filter(function(t){ return t.destination==$scope.model.languagesToBeSentBack[l] })[0], {action:'back'})).then(
                                                        function(response){
                                                            sentBack++
                                                            if(sentBack==$scope.model.languagesToBeSentBack.length){
                                                                loadingProject = true;
                                                                $timeout(function(){ $state.go('app.entity', {
                                                                    type: 'project',
                                                                    filter: $scope.model.id,
                                                                    action: 'process'
                                                                }, { reload: true }); }, CONFIG.stateGoTimeout)
                                                            }
                                                        }
                                                    ).catch(function(response){
                                                            $scope.forceBackForm.status = 'error';
                                                        })
                                                }
                                            });
                                        }
                                    }
                                }
                                if($scope.translations && $rootScope.user.admin) $scope.initForceDeliveryForm()

                                


                        }).catch(console.error);
                }).catch(console.error);
        }
    };

    var timeoutRetryUploadOtherFilesFn = null


    $scope.analysis = {};
    $scope.hasOptimizationForm = {};
    $scope.analysisForm = {};
    $scope.preAnalysisForm = {};
    $scope.translationForm = {};
    $scope.analysisFilesForm = {};
    $scope.preAnalysisFilesForm = {};
    $scope.analysisResetForm = {};
    $scope.activeAnalysis = 0;
    $scope.totalAnalysis = { contextMatch: 0, fullMatch: 0, fuzzyMatch: 0, noMatch: 0, total: 0, recovered: 0 };
    $scope.loadAnalysis = function(){
        if($scope.model.id && $scope.model.status!='DRAFT'){
            D.query('analysis', 'project='+$scope.model.id, { cache:false }).then(
                function(response){
                    response.sort(function(a1, a2){
                        return $filter('translate')('enums.language.'+a1.destination) > $filter('translate')('enums.language.'+a2.destination) ? 1 : -1;
                    });
                    if($state.params.action==='analyze' && $scope.model.destinations.length>1){
                        $scope.analysis[$scope.model.source+'_*'] = {
                            hasOptimization: response.filter(function(an){ return an.hasOptimization===true; }).length>0 || null,
                            machineTranslationValue: false,
                            preFile: response.filter(function(an){ return !(Object.keys(an.preAnalysis).length === 0 && an.preAnalysis.constructor === Object); }).length>0
                        }
                    }

                    $scope.downloadReport = function(id, filename){
                        D.download('/analysis.xlsx?project=' + id, filename)
                    }

                    $scope.analysisForm[$scope.model.source] = $rootScope.user.admin ? {
                            title: 'labels.LOADGENERICANALYSIS',
                            status: '',
                            type: 'project',
                            model: $scope.model,
                            fields: [
                                {
                                    available: true,
                                    type: 'file',
                                    name: 'analysis',
                                    canUpload: true,
                                    noLabel: true,
                                    inputColumn: 12,
                                    limit: -1,
                                    sync: {
                                        folder: 'source',
                                        upload: true
                                    },
                                    bucket: $rootScope.bucketName($scope.model.group),
                                    filesSelectable: $rootScope.user.admin,
                                    selectionActions: [
                                        { icon: 'aqi-action-delete', label: 'labels.DELETE', action: 'delete' }
                                    ] 
                                }
                            ]
                        } : { };
                        $scope.analysisFilesForm[$scope.model.source] = $rootScope.user.admin ? {
                            title: 'labels.LOADGENERICANALYSIS',
                            status: '',
                            type: 'project',
                            model: $scope.model,
                            fields: [
                                {
                                    available: true,
                                    type: 'file',
                                    name: 'analysis',
                                    canUpload: true,
                                    noLabel: true,
                                    inputColumn: 12,
                                    limit: -1,
                                    bucket: $rootScope.bucketName($scope.model.group),
                                    filesSelectable: $rootScope.user.admin,
                                    selectionActions: [
                                        { icon: 'aqi-action-delete', label: 'labels.DELETE', action: 'delete' }
                                    ] 
                                }
                            ]
                        } : { };
                        if($state.params.action==='review' || $state.params.action==='report'){
                            $scope.clientCsvNForm = {
                                title: 'labels.CSVFILES',
                                status: '',
                                type: 'project',
                                model: $scope.model,
                                fields: [
                                    {
                                        available: true,
                                        type: 'file',
                                        name: 'multicsvnorm',
                                        canUpload: false,
                                        canDelete: false,
                                        noLabel: true,
                                        inputColumn: 12,
                                        limit: -1,
                                        bucket: $rootScope.bucketName($scope.model.group),
                                        filesSelectable: $rootScope.user.admin,
                                        selectionActions: [
                                            { icon: 'aqi-action-delete', label: 'labels.DELETE', action: 'delete' }
                                        ] 
                                    }
                                ]
                            }
                            $scope.clientCsvOForm = {
                                title: 'labels.CSVFILES',
                                status: '',
                                type: 'project',
                                model: $scope.model,
                                fields: [
                                    {
                                        available: true,
                                        type: 'file',
                                        name: 'multicsvopt',
                                        canUpload: false,
                                        canDelete: false,
                                        noLabel: true,
                                        inputColumn: 12,
                                        limit: -1,
                                        bucket: $rootScope.bucketName($scope.model.group),
                                        filesSelectable: $rootScope.user.admin,
                                        selectionActions: [
                                            { icon: 'aqi-action-delete', label: 'labels.DELETE', action: 'delete' }
                                        ] 
                                    }
                                ]
                            }
                            $scope.clientCsvForm = {
                                title: 'labels.CSVFILES',
                                status: '',
                                type: 'analysis',
                                model: { id: $scope.model.id + '-' + $scope.model.source + '-' + $scope.model.destinations[0] },
                                fields: [
                                    {
                                        available: true,
                                        type: 'file',
                                        name: 'upload',
                                        allow: 'csv',
                                        canUpload: false,
                                        canDelete: false,
                                        noLabel: true,
                                        inputColumn: 12,
                                        limit: -1,
                                        bucket: $rootScope.bucketName($scope.model.group),
                                        filesSelectable: $rootScope.user.admin,
                                        selectionActions: [
                                            { icon: 'aqi-action-delete', label: 'labels.DELETE', action: 'delete' }
                                        ] 
                                    }
                                ]
                            }
                        }
                        $scope.automaticGT = _.contains($scope.model.dtpTypes, 'GRAPHICTEXT')
                        $scope.automaticGTvalues = {}
                        $scope.copyAutomaticGTValue = function(v){
                            for(var i in $scope.model.destinations){
                                if($scope.automaticGTvalues[$scope.model.destinations[i]]===undefined || $scope.automaticGTvalues[$scope.model.destinations[i]]===null){
                                    $scope.automaticGTvalues[$scope.model.destinations[i]] = v;
                                }
                            }
                        }
                        $scope.automaticLoadForm = {
                            title: 'labels.AUTOMATIC',
                            status: '',
                            type: 'project',
                            model: $scope.model,
                            fields: [{
                                available: true,
                                type: 'submit',
                                name: 'empty',
                                label: 'labels.LOADAUTOMATIC',
                                labelColumn: 0
                            }],
                            submit: function(){
                                /*ngDialog.openConfirm({
                                    template: '/app/views/entities/confirm.html',
                                    className: 'ngdialog-theme-default',
                                    scope: $scope
                                  }).then(function (value) {*/
                                      $scope.model.mqLanguages = {}
                                      for(var k in $scope.model.destinations){
                                        $scope.model.mqLanguages[$scope.model.destinations[k]] = $rootScope.mqLanguageCode($scope.model.destinations[k])
                                      }
                                      $scope.automaticLoadForm.status = 'submitting'
                                      L.log('AFTP:automaticLoadForm.submit', $scope.model.code)
                                      LR.one('analysis', $scope.model.code).customPOST($scope.model)
                                        .then(function(resp){
                                            L.log('AFTP:automaticLoadForm.response', $scope.model.code, resp)
                                            $scope.automaticResult = resp;
                                            $scope.automaticLoadForm.status = ''
                                        })
                                        .catch(function(err){
                                            L.log('AFTP:automaticLoadForm.error', $scope.model.code, err)
                                            $scope.automaticLoadForm.status = 'error'
                                        })
                                  //})
                            }
                        }
                        
                        $scope.automaticExecForm = {
                            title: '',
                            status: '',
                            type: 'project',
                            model: $scope.model,
                            fields: [{
                                available: true,
                                type: 'submit',
                                name: 'empty',
                                noLabel: true,
                                label: 'labels.EXECAUTOMATIC',
                                column: 9
                            },{
                                available: true,
                                type: 'button',
                                name: 'empty',
                                noLabel: true,
                                label: 'labels.UNDOAUTOMATIC',
                                column: 3,
                                cls: 'btn-danger',
                                onClick: function(form, event){
                                    event.stopPropagation()
                                    event.preventDefault()
                                    ngDialog.openConfirm({
                                        template: '/app/views/entities/confirm.html',
                                        className: 'ngdialog-theme-default',
                                        scope: $scope
                                    }).then(function (value) {
                                        R.one('action','ResetAnalysis').customPUT({project:$scope.model.id})
                                         .then(function(){
                                             if(timeoutRetryUploadOtherFilesFn) $timeout.cancel(timeoutRetryUploadOtherFilesFn)
                                            $timeout(function(){ $state.go('app.entity', {
                                                type: 'project',
                                                filter: $scope.model.id,
                                                action: 'analyze'
                                            }, { reload: true }); }, CONFIG.stateGoTimeout)
                                         })
                                    })
                                }
                            }],
                            submit: function(){
                                
                                    L.log('AFTP:automaticExecForm.submit')
                                    $scope.automaticExecForm.status = 'submitting'
                                    var uploadOtherFilesFn = []
                                    var uploadOtherFilesCounter = 0
                                    var preAnalysisFn = []
                                    var preAnalysisCounter = 0
                                    var analysisFn = []
                                    var analysisCounter = 0
                                    $rootScope.syncForms = {}
                                    for(var l in $scope.model.destinations){
                                        L.log('AFTP:automaticExecForm.for', l)
                                        var dest = $scope.model.destinations[l];
                                        uploadOtherFilesFn.push(function(d, index){
                                            return function(){
                                                L.log('AFTP:automaticExecForm.uploadOtherFilesFn', d)
                                                var dr = $scope.$on('$refreshFile', function (event, data) {
                                                    L.log('AFTP:automaticExecForm.onRefreshFile', d, data)
                                                    //other file uploaded
                                                    if (data.type === 'analysis' && data.field === 'upload' && data.entityId === $scope.analysis[$scope.model.source + '_' + d].id
                                                        && data.files && data.files.filter && data.files.filter((f) => { return f.extension!='csv'}).length>0) {
                                                        dr()
                                                        L.log('AFTP:automaticExecForm.onRefreshFile.if=true', d, data)
                                                        $scope.automaticResult.destinations[d].otherFilesUploaded = true
                                                        $scope.automaticResult.destinations[d].otherFilesUploadedCount = data.files.filter((f) => { return f.extension!='csv'}).length
                                                        uploadOtherFilesCounter++
                                                        if(uploadOtherFilesFn[uploadOtherFilesCounter]){
                                                            //upload next lang
                                                            L.log('AFTP:automaticExecForm.onRefreshFile.uploadNextLang', d, uploadOtherFilesCounter)
                                                            $timeout(uploadOtherFilesFn[uploadOtherFilesCounter], 500)
                                                        } else {
                                                            //launch analysis
                                                            L.log('AFTP:automaticExecForm.onRefreshFile.launchAnalysis', d)
                                                            $timeout(analysisFn[0], 500)
                                                        }
                                                        
                                                    }
                                                })
                                                L.log('AFTP:automaticExecForm.uploadOtherFilesFn.uploadOtherFiles', d, $scope.automaticResult.destinations[d].files.length)
                                                if($scope.automaticResult.destinations[d].files.length){
                                                    //upload other files
                                                    L.log('AFTP:automaticExecForm.uploadOtherFilesFn.uploadOtherFiles.if=true', d)
                                                    if(!$rootScope.syncForms || !$rootScope.syncForms['analysis_'+$scope.analysis[$scope.model.source + '_' + d].id+'_upload']){ //non è ancora pronto il form di sync
                                                        L.log('AFTP:automaticExecForm.uploadOtherFilesFn.uploadOtherFiles.RETRY', d)
                                                        dr() //toglie il listener sul refresh
                                                        timeoutRetryUploadOtherFilesFn = $timeout(uploadOtherFilesFn[index], 1000) //rilancia la stessa funzione
                                                        return
                                                    }
                                                    $scope.$broadcast('$automaticUpload', {
                                                        field: 'upload',
                                                        type: 'analysis',
                                                        modelId: $scope.analysis[$scope.model.source + '_' + d].id,
                                                        files: $scope.automaticResult.destinations[d].files.map(function(f){ return f.path })
                                                    })
                                                } else {
                                                    L.log('AFTP:automaticExecForm.uploadOtherFilesFn.uploadOtherFiles.if=false', d)
                                                    uploadOtherFilesCounter++
                                                    if(uploadOtherFilesFn[uploadOtherFilesCounter]){
                                                        //upload next lang
                                                        L.log('AFTP:automaticExecForm.uploadOtherFilesFn.uploadNextLang', d, uploadOtherFilesCounter)
                                                        $timeout(uploadOtherFilesFn[uploadOtherFilesCounter], 500)
                                                    } else {
                                                        //launch analysis
                                                        L.log('AFTP:automaticExecForm.uploadOtherFilesFn.launchAnalysis', d)
                                                        $timeout(analysisFn[0], 500)
                                                    }
                                                }
                                            }
                                        }(dest, uploadOtherFilesFn.length))
                                        preAnalysisFn.push(function(d){
                                            return function(){
                                                L.log('AFTP:automaticExecForm.preAnalysisFn', d, $scope.automaticGT)
                                                if($scope.automaticGT){
                                                    $scope.preAnalysisForm[$scope.model.source + '_' + d].model.noMatchG = $scope.automaticGTvalues[d] || 0
                                                    $scope.preAnalysisForm[$scope.model.source + '_' + d].fields[1].onchange($scope.preAnalysisForm[$scope.model.source + '_' + d], $scope.preAnalysisForm[$scope.model.source + '_' + d].fields[1])
                                                }
                                                $scope.preAnalysisForm[$scope.model.source + '_' + d].submit(function(){
                                                    L.log('AFTP:automaticExecForm.preAnalysisFn.preAnalysisForm.submit', d)
                                                    preAnalysisCounter++
                                                    $scope.automaticResult.destinations[d].preAnalysis = true
                                                    if(preAnalysisFn[preAnalysisCounter]){
                                                        L.log('AFTP:automaticExecForm.preAnalysisFn.preAnalysisForm.next', d, preAnalysisCounter)
                                                        $timeout(preAnalysisFn[preAnalysisCounter], 500)
                                                    } else {
                                                        L.log('AFTP:automaticExecForm.preAnalysisFn.preAnalysisForm.uploadOtherFiles', d)
                                                        $timeout(uploadOtherFilesFn[0], 2000)
                                                    }
                                                })
                                            }
                                        }(dest))
                                        analysisFn.push(function(d){
                                            return function(){
                                                L.log('AFTP:automaticExecForm.analysisFn', d, $scope.automaticGT)
                                                if($scope.automaticGT){
                                                    $scope.analysisForm[$scope.model.source + '_' + d].model.noMatchG = $scope.automaticGTvalues[d] || 0
                                                    $scope.analysisForm[$scope.model.source + '_' + d].fields[2].onchange($scope.analysisForm[$scope.model.source + '_' + d], $scope.analysisForm[$scope.model.source + '_' + d].fields[2])
                                                }
                                                $scope.analysisForm[$scope.model.source + '_' + d].submit(function(){
                                                    L.log('AFTP:automaticExecForm.analysisFn.analysisForm.submit', d)
                                                    analysisCounter++
                                                    $scope.automaticResult.destinations[d].analysis = true
                                                    if(analysisFn[analysisCounter]){
                                                        L.log('AFTP:automaticExecForm.analysisFn.analysisForm.next', d, analysisCounter)
                                                        $timeout(analysisFn[analysisCounter], 500)
                                                    } else {
                                                        L.log('AFTP:automaticExecForm.analysisFn.analysisForm.uploadOtherFiles', d, analysisCounter)
                                                        $scope.automaticExecForm.status = 'submitted'
                                                    }
                                                })
                                            }
                                        }(dest))
                                    }
                                    var afterOptimizationChoice = function(){
                                        if($scope.automaticResult.optimizedLogFile){
                                            L.log('AFTP:automaticExecForm.afterOptimizationChoice.optimizedLogFile')
                                            //is optimized
                                            //for each lang: norm analysis
                                            //for each lang: upload other files
                                            //for each lang: opt analysis
                                            $timeout(preAnalysisFn[0], 100)
                                        } else {
                                            L.log('AFTP:automaticExecForm.afterOptimizationChoice.notOptimizedLogFile')
                                            //not optimized
                                            //for each lang: upload other files
                                            //for each lang: norm analysis
                                            $timeout(uploadOtherFilesFn[0], 1000)
                                        }
                                    }
                                    var deregister1 = $scope.$on('$refreshFile', function (event, data) {
                                        L.log('AFTP:automaticExecForm.deregister1', data)
                                        //norm file uploaded
                                        if (data.type === 'project' && data.field === 'multicsvnorm' && data.entityId === $scope.model.id && data.files.length>0) {
                                            deregister1()
                                            L.log('AFTP:automaticExecForm.deregister1.if=true')
                                            $scope.automaticResult.normalizedLogFileUploaded = true
                                            if ($scope.automaticResult.optimizedLogFile) {
                                                L.log('AFTP:automaticExecForm.deregister1.if=true.optimized', $scope.automaticResult.optimizedLogFile)
                                                //upload opt file
                                                $scope.$broadcast('$automaticUpload', {
                                                    field: 'multicsvopt',
                                                    type: 'project',
                                                    modelId: $scope.model.id,
                                                    files: [$scope.automaticResult.optimizedLogFile]
                                                })
                                            } else {
                                                L.log('AFTP:automaticExecForm.deregister1.if=true.notoptimized')
                                                //set not optimized
                                                var sd = $scope.model.destinations.length>1 ? '*' : $scope.model.destinations[0]
                                                $scope.analysis[$scope.model.source+'_'+sd].hasOptimizationValue = false
                                                $scope.hasOptimizationForm[$scope.model.source+'_'+sd].submit(afterOptimizationChoice)
                                            }
                                        }
                                    })
                                    var deregister2 = $scope.$on('$refreshFile', function (event, data) {
                                        L.log('AFTP:automaticExecForm.deregister2', data)
                                        //opt file uploaded
                                        if (data.type === 'project' && data.field === 'multicsvopt' && data.entityId === $scope.model.id && data.files.length>0) {
                                            deregister2()
                                            L.log('AFTP:automaticExecForm.deregister2.if=true')
                                            L.log('$refreshFile', data)
                                            $scope.automaticResult.optimizedLogFileUploaded = true
                                            //set optimized
                                            var sd = $scope.model.destinations.length>1 ? '*' : $scope.model.destinations[0]
                                            $scope.analysis[$scope.model.source+'_'+sd].hasOptimizationValue = true
                                            $scope.hasOptimizationForm[$scope.model.source+'_'+sd].submit(afterOptimizationChoice)
                                        }
                                    })
                                    //upload norm file
                                    L.log('AFTP:automaticExecForm.ifNormalizedLogFile', $scope.automaticResult.normalizedLogFile)
                                    if ($scope.automaticResult.normalizedLogFile) {
                                        $scope.$broadcast('$automaticUpload', {
                                            field: 'multicsvnorm',
                                            type: 'project',
                                            modelId: $scope.model.id,
                                            files: [$scope.automaticResult.normalizedLogFile]
                                        })
                                    }
                                    

                            }
                        }
                        $scope.analysisForm['multiCsv'] = $rootScope.user.admin ? {
                            title: 'labels.MULTIANALYSISCSV',
                            status: '',
                            type: 'project',
                            model: $scope.model,
                            fields: [
                                {
                                    available: true,
                                    type: 'file',
                                    name: 'multicsvnorm',
                                    canUpload: true,
                                    //noLabel: true,
                                    //inputColumn: 12,
                                    limit: 1,
                                    allow: 'csv',
                                    sync: {
                                        folder: 'logs', 
                                        upload: true
                                    },
                                    bucket: $rootScope.bucketName($scope.model.group),
                                    filesSelectable: $rootScope.user.admin,
                                    selectionActions: [
                                        { icon: 'aqi-action-delete', label: 'labels.DELETE', action: 'delete' }
                                    ] 
                                },
                                {
                                    available: true,
                                    type: 'file',
                                    name: 'multicsvopt',
                                    canUpload: true,
                                    //noLabel: true,
                                    //inputColumn: 12,
                                    limit: 1,
                                    allow: 'csv',
                                    sync: {
                                        folder: 'logs', 
                                        upload: true
                                    },
                                    bucket: $rootScope.bucketName($scope.model.group),
                                    filesSelectable: $rootScope.user.admin,
                                    selectionActions: [
                                        { icon: 'aqi-action-delete', label: 'labels.DELETE', action: 'delete' }
                                    ] 
                                }
                            ]
                        } : { };
                        $scope.model.skiprevisionalert = $filter('translate')('labels.SKIPREVISIONALERT');
                        $scope.analysisForm['clientNotes'] = $rootScope.user.admin ? {
                            title: 'labels.NOTESFORCLIENT',
                            status: '',
                            type: 'project',
                            model: $scope.model,
                            successLabel: 'labels.SUCCESSSAVE',
                            fields: [
                                {
                                    available: $scope.model.skiprevision,
                                    type: 'static',
                                    labelColumn: 0,
                                    noLabel: true,
                                    inputColumn: 12,
                                    cls: 'alert alert-warning',
                                    name: 'skiprevisionalert'
                                },{
                                    available: true,
                                    type: 'textarea',
                                    name: 'analysisNotes',
                                    labelColumn: 0,
                                    noLabel: true,
                                    inputColumn: 12,
                                    onchange: function(){
                                        $scope.clientNotesSaved = false;
                                    }
                                },{
                                    available: true,
                                    type: 'file',
                                    name: 'clientNotesFiles',
                                    canUpload: true,
                                    noLabel: true,
                                    inputColumn: 12,
                                    limit: -1,
                                    sync: {
                                        upload: true,
                                        folder: 'sourcereport'
                                    },
                                    bucket: $rootScope.bucketName($scope.model.group),
                                    filesSelectable: $rootScope.user.admin,
                                    selectionActions: [
                                        { icon: 'aqi-action-delete', label: 'labels.DELETE', action: 'delete' }
                                    ] 
                                },{
                                    available: true,
                                    type: 'submit',
                                    name: 'empty',
                                    label: 'labels.SAVE',
                                    labelColumn: 0
                                }
                            ],
                            submit: function(){
                                $scope.analysisForm['clientNotes'].status = 'submitting';
                                $scope.clientNotesSaved = false;
                            	$scope.model.action = 'notes';
                            	D.save($scope.type, $scope.model).then(
                                        function(response){
                                        	//$scope.model = response;
                                            $scope.analysisForm['clientNotes'].status = 'submitted';
                                            $scope.clientNotesSaved = true;
                                        }
                                        
                                        ).catch(function(response){
                                        	$scope.analysisForm['clientNotes'].status = 'error';
                                        });
                            }
                        } : { };
                        $scope.analysisForm['notesForSupplier'] = $rootScope.user.admin ? {
                            title: $scope.model.separateOffers ? 'fields.NOTESFORSUPPLIERT' : 'fields.NOTESFORSUPPLIER',
                            status: '',
                            type: 'project',
                            model: $scope.model,
                            successLabel: 'labels.SUCCESSSAVE',
                            fields: [
                                {
                                    available: true,
                                    type: 'textareaWithDocsBrowser',
                                    name: 'notesForSupplier',
                                    labelColumn: 0,
                                    noLabel: true,
                                    inputColumn: 12,
                                    onchange: function(){
                                        $scope.supplierNotesSaved = false;
                                    },
                                    docsBrowser: {
                                        group: $scope.model.group,
                                        groupName: $scope.model.groupName
                                    }
                                },{
                                    available: true,
                                    type: 'file',
                                    name: 'supplierNotesFiles',
                                    canUpload: true,
                                    noLabel: true,
                                    inputColumn: 12,
                                    limit: -1,
                                    sync: {
                                        upload: true,
                                        folder: 'source'
                                    },
                                    bucket: $rootScope.bucketName($scope.model.group),
                                    filesSelectable: $rootScope.user.admin,
                                    selectionActions: [
                                        { icon: 'aqi-action-delete', label: 'labels.DELETE', action: 'delete' }
                                    ] 
                                },{
                                    available: true,
                                    type: 'submit',
                                    name: 'empty',
                                    label: 'labels.SAVE',
                                    labelColumn: 0
                                }
                            ],
                            submit: function(){
                            	$scope.analysisForm['notesForSupplier'].status = 'submitting';
                                $scope.model.action = 'notes';
                                $scope.supplierNotesSaved = false;
                            	D.save($scope.type, $scope.model).then(
                                        function(response){
                                        	//$scope.model = response;
                                            $scope.analysisForm['notesForSupplier'].status = 'submitted';
                                            $scope.supplierNotesSaved = true;
                                        }
                                        
                                        ).catch(function(response){
                                        	$scope.analysisForm['notesForSupplier'].status = 'error';
                                        });
                            }
                        } : { };
                        $scope.model.deliveryT = $scope.model.delivery
                        $scope.model.deliveryI = $scope.model.delivery
                        $scope.analysisForm['notesForSupplierI'] = $rootScope.user.admin ? {
                            title: 'fields.SEPARATEDOFFERS',
                            status: '',
                            type: 'project',
                            model: $scope.model,
                            successLabel: 'labels.SUCCESSSAVE',
                            fields: [
                                {
                                    available: true,
                                    type: 'date',
                                    name: 'deliveryT',
                                    minDate: $scope.model.offerDeadline + 86400000
                                },
                                {
                                    available: true,
                                    type: 'date',
                                    name: 'deliveryI',
                                    minDate: $scope.model.offerDeadline + 86400000
                                },
                                {
                                    available: true,
                                    type: 'textareaWithDocsBrowser',
                                    name: 'notesForSupplierI',
                                    labelColumn: 6,
                                    labelAlign: 'left',
                                    inputColumn: 12,
                                    onchange: function(){
                                        $scope.supplierNotesSavedI = false;
                                    },
                                    docsBrowser: {
                                        group: $scope.model.group,
                                        groupName: $scope.model.groupName
                                    }
                                },{
                                    available: true,
                                    type: 'file',
                                    name: 'supplierNotesFilesI',
                                    canUpload: true,
                                    noLabel: true,
                                    inputColumn: 12,
                                    limit: -1,
                                    sync: {
                                        upload: true,
                                        folder: 'source'
                                    },
                                    bucket: $rootScope.bucketName($scope.model.group),
                                    filesSelectable: $rootScope.user.admin,
                                    selectionActions: [
                                        { icon: 'aqi-action-delete', label: 'labels.DELETE', action: 'delete' }
                                    ] 
                                },{
                                    available: true,
                                    type: 'submit',
                                    name: 'empty',
                                    label: 'labels.SAVE',
                                    labelColumn: 0
                                }
                            ],
                            submit: function(){
                            	$scope.analysisForm['notesForSupplierI'].status = 'submitting';
                                $scope.model.action = 'notesI';
                                $scope.supplierNotesSavedI = false;
                            	D.save($scope.type, $scope.model).then(
                                        function(response){
                                        	//$scope.model = response;
                                            $scope.analysisForm['notesForSupplierI'].status = 'submitted';
                                            $scope.supplierNotesSavedI = true;
                                        }
                                        
                                        ).catch(function(response){
                                        	$scope.analysisForm['notesForSupplierI'].status = 'error';
                                        });
                            	
                            }
                        } : { };
                    $scope.updateGNM = function(form, field){
                    	for(var i=0; i<$scope.anDestArray.length; i++){
                    		$scope.analysis[$scope.anDestArray[i]].noMatchG = form.model[field.name];
                    		$scope.analysis[$scope.anDestArray[i]].noMatch = $scope.analysis[$scope.anDestArray[i]].noMatchG + $scope.analysis[$scope.anDestArray[i]].noMatchT;
                    		$scope.analysis[$scope.anDestArray[i]].total = $scope.analysis[$scope.anDestArray[i]].contextMatch
                    													 + $scope.analysis[$scope.anDestArray[i]].fullMatch
                    													 + $scope.analysis[$scope.anDestArray[i]].fuzzyMatch
                    													 + $scope.analysis[$scope.anDestArray[i]].noMatch;
                    	}
                    };
                    $scope.anDestArray = [];
                    for(var i=0; i<response.length; i++){
                        var a = response[i];
                        var id = (a.source + '_' + a.destination);
                        $scope.analysis[id] = a;
                        $scope.anDestArray.push(id);
                        $scope.totalAnalysis.analyzed = true;
                        $scope.totalAnalysis.contextMatch = $scope.totalAnalysis.contextMatch ? $scope.totalAnalysis.contextMatch + a.contextMatch : a.contextMatch;
                        $scope.totalAnalysis.fullMatch = $scope.totalAnalysis.fullMatch ? $scope.totalAnalysis.fullMatch + a.fullMatch : a.fullMatch;
                        $scope.totalAnalysis.fuzzyMatch = $scope.totalAnalysis.fuzzyMatch ? $scope.totalAnalysis.fuzzyMatch + a.fuzzyMatch : a.fuzzyMatch;
                        $scope.totalAnalysis.noMatch = $scope.totalAnalysis.noMatch ? $scope.totalAnalysis.noMatch + a.noMatch : a.noMatch;
                        $scope.totalAnalysis.noMatchG = $scope.totalAnalysis.noMatchG ? $scope.totalAnalysis.noMatchG + a.noMatchG : a.noMatchG;
                        $scope.totalAnalysis.total = $scope.totalAnalysis.total ? $scope.totalAnalysis.total + a.total : a.total;
                        $scope.totalAnalysis.normContext = $scope.totalAnalysis.normContext ? $scope.totalAnalysis.normContext + a.normContext : a.normContext;
                        $scope.totalAnalysis.normFull = $scope.totalAnalysis.normFull ? $scope.totalAnalysis.normFull + a.normFull : a.normFull;
                        $scope.totalAnalysis.normFuzzy = $scope.totalAnalysis.normFuzzy ? $scope.totalAnalysis.normFuzzy + a.normFuzzy : a.normFuzzy;
                        $scope.totalAnalysis.normNo = $scope.totalAnalysis.normNo ? $scope.totalAnalysis.normNo + a.normNo : a.normNo;
                        $scope.totalAnalysis.normTotal = $scope.totalAnalysis.normTotal ? $scope.totalAnalysis.normTotal + a.normTotal : a.normTotal;
                        $scope.totalAnalysis.recovered = $scope.totalAnalysis.recovered ? $scope.totalAnalysis.recovered + a.recovered : a.recovered;
                        $scope.totalAnalysis.mtFuzzy = $scope.totalAnalysis.mtFuzzy ? $scope.totalAnalysis.mtFuzzy + a.mtFuzzy : a.mtFuzzy;
                        $scope.totalAnalysis.mtNo = $scope.totalAnalysis.mtNo ? $scope.totalAnalysis.mtNo + a.mtNo : a.mtNo;
                        $scope.totalAnalysis.mtNormFuzzy = $scope.totalAnalysis.mtNormFuzzy ? $scope.totalAnalysis.mtNormFuzzy + a.mtNormFuzzy : a.mtNormFuzzy;
                        $scope.totalAnalysis.mtNormNo = $scope.totalAnalysis.mtNormNo ? $scope.totalAnalysis.mtNormNo + a.mtNormNo : a.mtNormNo;

                        $scope.totalAnalysis.hasOptimization = $scope.totalAnalysis.hasOptimization || a.hasOptimization
                        $scope.totalAnalysis.client = a.client

                        if(a.preAnalysis && !(Object.keys(a.preAnalysis).length === 0 && a.preAnalysis.constructor === Object)){ //se c'è almeno una preanalisi allora la rendo visibile
                            $scope.totalAnalysis.preFile = true;
                        }

                        var usePreA = false;
                        if(!a.preAnalysis || (Object.keys(a.preAnalysis).length === 0 && a.preAnalysis.constructor === Object)) {
                            usePreA = true;
                            a.preAnalysis = a; //se non c'è preanalisi, per il calcolo della preanalisi totale uso l'analisi
                        }

                        if(!$scope.totalAnalysis.preAnalysis) $scope.totalAnalysis.preAnalysis = {contextMatch: 0, fullMatch: 0, fuzzyMatch: 0, noMatch: 0, total: 0}
                        $scope.totalAnalysis.preAnalysis.analyzed = true;
                        $scope.totalAnalysis.preAnalysis.chartId = '_'
                        $scope.totalAnalysis.preAnalysis.contextMatch = $scope.totalAnalysis.preAnalysis.contextMatch ? $scope.totalAnalysis.preAnalysis.contextMatch + a.preAnalysis.contextMatch : a.preAnalysis.contextMatch;
                        $scope.totalAnalysis.preAnalysis.fullMatch = $scope.totalAnalysis.preAnalysis.fullMatch ? $scope.totalAnalysis.preAnalysis.fullMatch + a.preAnalysis.fullMatch : a.preAnalysis.fullMatch;
                        $scope.totalAnalysis.preAnalysis.fuzzyMatch = $scope.totalAnalysis.preAnalysis.fuzzyMatch ? $scope.totalAnalysis.preAnalysis.fuzzyMatch + a.preAnalysis.fuzzyMatch : a.preAnalysis.fuzzyMatch;
                        $scope.totalAnalysis.preAnalysis.noMatch = $scope.totalAnalysis.preAnalysis.noMatch ? $scope.totalAnalysis.preAnalysis.noMatch + a.preAnalysis.noMatch : a.preAnalysis.noMatch;
                        $scope.totalAnalysis.preAnalysis.noMatchG = $scope.totalAnalysis.preAnalysis.noMatchG ? $scope.totalAnalysis.preAnalysis.noMatchG + a.preAnalysis.noMatchG : a.preAnalysis.noMatchG;
                        $scope.totalAnalysis.preAnalysis.total = $scope.totalAnalysis.preAnalysis.total ? $scope.totalAnalysis.preAnalysis.total + a.preAnalysis.total : a.preAnalysis.total;
                        $scope.totalAnalysis.preAnalysis.normContext = $scope.totalAnalysis.preAnalysis.normContext ? $scope.totalAnalysis.preAnalysis.normContext + a.preAnalysis.normContext : a.preAnalysis.normContext;
                        $scope.totalAnalysis.preAnalysis.normFull = $scope.totalAnalysis.preAnalysis.normFull ? $scope.totalAnalysis.preAnalysis.normFull + a.preAnalysis.normFull : a.preAnalysis.normFull;
                        $scope.totalAnalysis.preAnalysis.normFuzzy = $scope.totalAnalysis.preAnalysis.normFuzzy ? $scope.totalAnalysis.preAnalysis.normFuzzy + a.preAnalysis.normFuzzy : a.preAnalysis.normFuzzy;
                        $scope.totalAnalysis.preAnalysis.normNo = $scope.totalAnalysis.preAnalysis.normNo ? $scope.totalAnalysis.preAnalysis.normNo + a.preAnalysis.normNo : a.preAnalysis.normNo;
                        $scope.totalAnalysis.preAnalysis.normTotal = $scope.totalAnalysis.preAnalysis.normTotal ? $scope.totalAnalysis.preAnalysis.normTotal + a.preAnalysis.normTotal : a.preAnalysis.normTotal;
                        $scope.totalAnalysis.preAnalysis.mtFuzzy = $scope.totalAnalysis.preAnalysis.mtFuzzy ? $scope.totalAnalysis.preAnalysis.mtFuzzy + a.preAnalysis.mtFuzzy : a.preAnalysis.mtFuzzy;
                        $scope.totalAnalysis.preAnalysis.mtNo = $scope.totalAnalysis.preAnalysis.mtNo ? $scope.totalAnalysis.preAnalysis.mtNo + a.preAnalysis.mtNo : a.preAnalysis.mtNo;
                        $scope.totalAnalysis.preAnalysis.mtNormFuzzy = $scope.totalAnalysis.preAnalysis.mtNormFuzzy ? $scope.totalAnalysis.preAnalysis.mtNormFuzzy + a.preAnalysis.mtNormFuzzy : a.preAnalysis.mtNormFuzzy;
                        $scope.totalAnalysis.preAnalysis.mtNormNo = $scope.totalAnalysis.preAnalysis.mtNormNo ? $scope.totalAnalysis.preAnalysis.mtNormNo + a.preAnalysis.mtNormNo : a.preAnalysis.mtNormNo;
                        $scope.totalAnalysis.preAnalysis.client = a.client

                        if(usePreA) {
                            a.preAnalysis = ''
                        }
                        $scope.analysis[id].machineTranslationValue = $scope.analysis[id].mt;
                        $scope.hasOptimizationForm[id] = $rootScope.user.admin ? {
                            title: 'labels.HASOPTIMIZATION',
                            titleParams: { lang: a.destination},
                            type: 'analysis',
                            model: $scope.analysis[id],
                            fields: [
                                {
                                    available: true,
                                    type: 'radio',
                                    name: 'hasOptimizationValue',
                                    options: [
                                        { value: true, label: 'labels.YES' },
                                        { value: false, label: 'labels.NO' }
                                    ],
                                    labelColumn: 4,
                                    inputColumn: 8
                                },{
                                    available: true,
                                    type: 'radio',
                                    name: 'machineTranslationValue',
                                    options: [
                                        { value: true, label: 'labels.YES' },
                                        { value: false, label: 'labels.NO' }
                                    ],
                                    labelColumn: 4,
                                    inputColumn: 8
                                },{
                                    available: true,
                                    type: 'submit',
                                    name: 'empty'
                                }
                            ],
                            submit: function(callback){
                                L.log('AFTP:hasOptimizationForm.submit', id)
                                this.status = 'submitting';
                                var id = this.model.source + '_' + this.model.destination;
                                this.model.action = 'setOptimization';
                                D.save('analysis', this.model).then(
                                    function(response){
                                        L.log('AFTP:hasOptimizationForm.submit.response', id, response)
                                    	$scope.hasOptimizationForm[(response.source + '_' + response.destination)].status = 'submitted';
                                        for(var i=0; i<$scope.anDestArray.length; i++){
                                    		D.load('analysis', $scope.analysis[$scope.anDestArray[i]].id).then(
	                                    			function(response){
                                                        L.log('AFTP:hasOptimizationForm.submit.load', id, response, callback)
                                                        $scope.analysis[(response.source + '_' + response.destination)] = response;
                                                        $scope.analysisResetForm[(response.source + '_' + response.destination)].fields[0].label = $scope.analysis[(response.source + '_' + response.destination)].file ? 'labels.RESETANALYSIS' : ($scope.analysis[(response.source + '_' + response.destination)].preFile ? 'labels.RESETPREANALYSIS' : 'labels.RESETHASOPTIMIZATION');
                                                        $scope.analysisForm[(response.source + '_' + response.destination)].title = $scope.analysis[(response.source + '_' + response.destination)].hasOptimization ? 'labels.LOADANALYSIS' : 'labels.LOADPREANALYSIS';
                                                        $scope.analysisForm[(response.source + '_' + response.destination)].titleClass = 'title-with-bg ' + ($scope.analysis[(response.source + '_' + response.destination)].hasOptimization ? 'bg-green' : 'bg-purple');
                                                        if(callback) callback()
	                                    			}
	                                    	).catch(function(err){
                                                L.log('AFTP:hasOptimizationForm.submit.load.erro', id, err)
                                            });
                                    	}

                                    }
                                    
                                ).catch(function(response){
                                        L.log('AFTP:hasOptimizationForm.submit.error', id, response)
                                    	$scope.hasOptimizationForm[id].status = 'error';
                                    });
                                delete this.model.action;
                            }
                        } : {}
                        $scope.analysis[id].code = $scope.model.code;
                        $scope.hasOptimizationForm[$scope.model.source+'_*'] = $rootScope.user.admin ? {
                            title: 'labels.HASOPTIMIZATION',
                            titleParams: { lang: '*'},
                            type: 'analysis',
                            model: $scope.analysis[$scope.model.source+'_*'],
                            fields: [
                                {
                                    available: true,
                                    type: 'radio',
                                    name: 'hasOptimizationValue',
                                    options: [
                                        { value: true, label: 'labels.YES' },
                                        { value: false, label: 'labels.NO' }
                                    ],
                                    labelColumn: 4,
                                    inputColumn: 8
                                },{
                                    available: true,
                                    type: 'radio',
                                    name: 'machineTranslationValue',
                                    options: [
                                        { value: true, label: 'labels.YES' },
                                        { value: false, label: 'labels.NO' }
                                    ],
                                    labelColumn: 4,
                                    inputColumn: 8
                                },{
                                    available: true,
                                    type: 'submit',
                                    name: 'empty'
                                }
                            ],
                            submit: function(callback){
                                this.status = 'submitting';
                                if($scope.analysis[$scope.model.source+'_*'].hasOptimizationValue!==null){
                                    for(var i=0; i<$scope.model.destinations.length; i++){
                                        var d = $scope.model.source+'_'+$scope.model.destinations[i];
                                        if($scope.analysis[d].hasOptimization==null){
                                            $scope.analysis[d].hasOptimizationValue = $scope.analysis[$scope.model.source+'_*'].hasOptimizationValue;
                                            $scope.analysis[d].machineTranslationValue = $scope.analysis[$scope.model.source+'_*'].machineTranslationValue;
                                            $scope.hasOptimizationForm[d].model = $scope.analysis[d];
                                            $scope.hasOptimizationForm[d].submit();
                                        }
                                    }
                                    var check = function(){
                                        var finished = true;
                                        for(var i=0; i<$scope.model.destinations.length; i++){
                                            var d = $scope.model.source+'_'+$scope.model.destinations[i];
                                            if($scope.analysis[d].hasOptimization==null){
                                                finished = false;
                                            }
                                        }
                                        if(finished){
                                            $scope.hasOptimizationForm[$scope.model.source+'_*'].status = 'submitted';
                                            $scope.analysis[$scope.model.source+'_*'].hasOptimization = !!$scope.analysis[$scope.model.source+'_*'].hasOptimizationValue;
                                            if(callback) callback()
                                        } else {
                                            $timeout(check, 1000);
                                        }
                                    }
                                    check();
                                }
                            }
                        } : {}
                        $scope.translationForm[id] = function(id){
                            return {
                                title: $scope.model.dtp ? 'labels.LOADFILESFORDTP' : 'labels.LOADFILESNODTP',
                                status: 'notsubmittable',
                                type: 'translation',
                                model: {
                                    id: $scope.model.id + '-' + a.source.toLowerCase() + '-' + a.destination.toLowerCase(),
                                    linguisticTask: false
                                },
                                refreshFile: function(data){
                                        $scope.translationForm[id].fields.forEach(function(f){
                                            if(f.name=='linguisticTask' || f.name=='deliverWithoutFiles'){
                                                if($rootScope.files['translation'+$scope.translationForm[id].model.id+($scope.model.dtp ? 'layout' : 'delivery')]
                                                    && $rootScope.files['translation'+$scope.translationForm[id].model.id+($scope.model.dtp ? 'layout' : 'delivery')].length>0){
                                                    $scope.translationForm[id].model[f.name] = false
                                                    f.disabled = true
                                                    f.onchange()
                                                } else {
                                                    f.disabled = false
                                                }
                                            }
                                        })
                                },
                                fields: [
                                    {
                                        available: true,
                                        type: 'file',
                                        name: $scope.model.dtp ? 'layout' : 'delivery',
                                        canUpload: true,
                                        noLabel: true,
                                        inputColumn: 12,
                                        limit: -1,
                                        sync: {
                                                folder: $scope.model.dtp ? 'dtpSource' : 'delivery', 
                                                upload: true,
                                                lang: $rootScope.mqLanguageCode(a.destination),
                                                code: $scope.model.code
                                        },
                                        bucket: $rootScope.bucketName($scope.model.group),
                                        filesSelectable: $rootScope.user.admin,
                                        selectionActions: [
                                            { icon: 'aqi-action-delete', label: 'labels.DELETE', action: 'delete' }
                                        ] 
                                    },{
                                        available: !$scope.model.dtp,
                                        type: 'checkbox',
                                        name: 'linguisticTask',
                                        onchange: function(_a){ return function(){
                                            if(!$scope.model.linguisticTasks) $scope.model.linguisticTasks = {}
                                            $scope.model.linguisticTasks[_a.destination] = $scope.translationForm[id].model.linguisticTask
                                            if($scope.translationForm[id].model.deliverWithoutFiles && $scope.translationForm[id].model.linguisticTask){
                                                $scope.translationForm[id].model.deliverWithoutFiles = false
                                                $scope.translationForm[id].fields.find(f => f.name=='deliverWithoutFiles').onchange(_a)
                                            }
                                            $scope.translationForm[id].fields.forEach(function(f){
                                                if(f.type=='file'){
                                                    f.canUpload = !$scope.translationForm[id].model.linguisticTask && !$scope.translationForm[id].model.deliverWithoutFiles
                                                }
                                            })
                                        }}(a),
                                        inputColumn: 6,
                                        labelColumn: 6
                                    },{
                                        available: !$scope.model.dtp,
                                        type: 'checkbox',
                                        name: 'deliverWithoutFiles',
                                        onchange: function(_a){ return function(){
                                            if(!$scope.model.deliverWithoutFiles) $scope.model.deliverWithoutFiles = {}
                                            $scope.model.deliverWithoutFiles[_a.destination] = $scope.translationForm[id].model.deliverWithoutFiles
                                            if($scope.translationForm[id].model.deliverWithoutFiles && $scope.translationForm[id].model.linguisticTask){
                                                $scope.translationForm[id].model.linguisticTask = false
                                                $scope.translationForm[id].fields.find(f => f.name=='linguisticTask').onchange(_a)
                                            }
                                            $scope.translationForm[id].fields.forEach(function(f){
                                                if(f.type=='file'){
                                                    f.canUpload = !$scope.translationForm[id].model.linguisticTask && !$scope.translationForm[id].model.deliverWithoutFiles
                                                }
                                            })
                                        }}(a),
                                        inputColumn: 6,
                                        labelColumn: 6
                                    }
                                ]
                            }
                        }(id)

                        let analysisAlertMsg = function(msg){
                            $scope.pop('warning', '', '<h1>ATTENZIONE:<br><br>la lingua indicata nel CSV ('+msg+') non sembra coincidere con le lingue del progetto</h1>')
                        }

                        $scope.analysisForm[id] = $rootScope.user.admin ? {
                            title: $scope.analysis[id].hasOptimization ? 'labels.LOADANALYSIS' : 'labels.LOADPREANALYSIS',
                            titleClass: 'title-with-bg ' + ($scope.analysis[id].hasOptimization ? 'bg-green' : 'bg-purple'),
                            titleParams: { lang: a.destination},
                            status: 'notsubmittable',
                            type: 'analysis',
                            model: $scope.analysis[id],
                            fileNumber: 2,
                            refreshFile: function(data){
                            	if($rootScope.files['analysis'+this.model.id+'upload'] && $rootScope.files['analysis'+this.model.id+'upload'].length>=this.fileNumber && this.status!='submitting')
                            		this.status = '';
                            },
                            fields: [
                                {
                                    available: true,
                                    type: 'button',
                                    cls: 'btn-default btn-xs',
                                    label: 'labels.SETZEROANALYSIS',
                                    noLabel: true,
                                    inputColumn: 12,
                                    name: 'zero',
                                    onClick: function(form, $event){
                                        $event.stopPropagation();
                                        $event.preventDefault();
                                        form.fileNumber = form.fileNumber==2 ? 1 : 2;
                                        form.status = 'notsubmittable';
                                        form.fields[0].label = form.fileNumber==2 ? 'labels.SETZEROANALYSIS' : 'labels.UNSETZEROANALYSIS';
                                        form.fields[0].cls = form.fileNumber==2 ? 'btn-default btn-xs' : 'btn-default btn-xs btn-info';
                                        form.refreshFile();
                                    }
                                },{
                                    available: true,
                                    type: 'file',
                                    name: 'upload',
                                    canUpload: true,
                                    noLabel: true,
                                    inputColumn: 12,
                                    limit: -1,
                                    allow: 'xliff|csv|tmx|zip|mqxlz|mqxliff',
                                    sync: {
                                        folder: ['logs','translationSource'], 
                                        upload: true,
                                        lang: $scope.model.destinations.length>1 ? $rootScope.mqLanguageCode(a.destination) : null
                                    },
                                    bucket: $rootScope.bucketName($scope.model.group),
                                    filesSelectable: $rootScope.user.admin,
                                    selectionActions: [
                                        { icon: 'aqi-action-delete', label: 'labels.DELETE', action: 'delete' }
                                    ] 
                                },{
                                	available: _.contains($scope.model.dtpTypes, 'GRAPHICTEXT'), //non spostare campo altrimenti correggere dove viene richiamato
                                	type: 'number',
                                	name: 'noMatchG',
                                	onchange: $scope.updateGNM
                                },{
                                    available: true,
                                    type: 'submit',
                                    name: 'empty',
                                    label: 'labels.ANALYZE',
                                    labelColumn: 0
                                }
                            ],
                            errorLabel: 'labels.ANALYSISERROR',
                            submit: function(callback){
                                L.log('AFTP:analysisForm.submit', id)
                                this.status = 'submitting';
                                var id = this.model.source + '_' + this.model.destination;
                                D.save('analysis', this.model).then(
                                    function(response){
                                        if(response.alertMsg){ analysisAlertMsg(response.alertMsg) }
                                        L.log('AFTP:analysisForm.submit.response', id, response)
                                    	$scope.analysisForm[(response.source + '_' + response.destination)].status = 'submitted';
                                        for(var i=0; i<$scope.anDestArray.length; i++){
                                    		D.load('analysis', $scope.analysis[$scope.anDestArray[i]].id).then(
	                                    			function(response){
                                                        L.log('AFTP:analysisForm.submit.load', id, response)
                                                        if(response.preAnalysis) response.preAnalysis = response.preAnalysis;
	                                    				$scope.analysis[(response.source + '_' + response.destination)] = response;
                                                        $scope.analysisResetForm[(response.source + '_' + response.destination)].fields[0].label = $scope.analysis[(response.source + '_' + response.destination)].file ? 'labels.RESETANALYSIS' : ($scope.analysis[(response.source + '_' + response.destination)].preFile ? 'labels.RESETPREANALYSIS' : 'labels.RESETHASOPTIMIZATION');

	                                    			}
	                                    	).catch(function(err){
                                                L.log('AFTP:analysisForm.submit.load.error', id, err)
                                            });
                                    	}
                                        L.log('AFTP:analysisForm.submit.callback', id, callback) //forse da spostare!!!
                                        if(callback) callback()
                                    }
                                    
                                ).catch(function(response){
                                        L.log('AFTP:analysisForm.submit.error', id, response)
                                    	$scope.analysisForm[id].status = 'error';
                                    });

                            }
                        } : { };
                        $scope.preAnalysisForm[id] = $rootScope.user.admin ? {
                            title: 'labels.LOADPREANALYSIS',
                            titleClass: 'title-with-bg bg-purple',
                            titleParams: { lang: a.destination},
                            status: 'notsubmittable',
                            type: 'analysis',
                            model: $scope.analysis[id],
                            refreshFile: function(data){
                            	if($rootScope.files['analysis'+this.model.id+'preupload'] && $rootScope.files['analysis'+this.model.id+'preupload'].length==1 && this.status!='submitting')
                            		this.status = '';
                            },
                            fields: [
                                {
                                    available: true,
                                    type: 'file',
                                    name: 'preupload',
                                    canUpload: true,
                                    noLabel: true,
                                    inputColumn: 12,
                                    limit: -1,
                                    allow: 'csv',
                                    sync: {
                                        folder: 'logs', 
                                        upload: true,
                                        lang: $scope.model.destinations.length>1 ? $rootScope.mqLanguageCode(a.destination) : null
                                    },
                                    bucket: $rootScope.bucketName($scope.model.group),
                                    filesSelectable: $rootScope.user.admin,
                                    selectionActions: [
                                        { icon: 'aqi-action-delete', label: 'labels.DELETE', action: 'delete' }
                                    ] 
                                },{
                                	available: _.contains($scope.model.dtpTypes, 'GRAPHICTEXT'), //non spostare campo deve avere indice 1 oppure correggere dove viene richiamato
                                	type: 'number',
                                	name: 'noMatchG',
                                	onchange: $scope.updateGNM
                                },{
                                    available: true,
                                    type: 'submit',
                                    name: 'empty',
                                    label: 'labels.ANALYZE',
                                    labelColumn: 0
                                }
                            ],
                            errorLabel: 'labels.ANALYSISERROR',
                            submit: function(callback){
                                L.log('AFTP:preAnalysisForm.submit', id)
                                this.status = 'submitting';
                                var id = this.model.source + '_' + this.model.destination;
                                D.save('analysis', this.model).then(
                                    function(response){
                                        if(response.alertMsg){ analysisAlertMsg(response.alertMsg) }
                                        L.log('AFTP:preAnalysisForm.submit.response', id, response)
                                    	$scope.preAnalysisForm[(response.source + '_' + response.destination)].status = 'submitted';
                                        for(var i=0; i<$scope.anDestArray.length; i++){
                                    		D.load('analysis', $scope.analysis[$scope.anDestArray[i]].id).then(
	                                    			function(response){
                                                        L.log('AFTP:preAnalysisForm.submit.load', id, response)
                                                        if(response.preAnalysis) response.preAnalysis = response.preAnalysis;
	                                    				$scope.analysis[(response.source + '_' + response.destination)] = response;
                                                        $scope.analysisResetForm[(response.source + '_' + response.destination)].fields[0].label = $scope.analysis[(response.source + '_' + response.destination)].file ? 'labels.RESETANALYSIS' : ($scope.analysis[(response.source + '_' + response.destination)].preFile ? 'labels.RESETPREANALYSIS' : 'labels.RESETHASOPTIMIZATION');

	                                    			}
	                                    	).catch(function(err){
                                                L.log('AFTP:preAnalysisForm.submit.load.error', id, err)
                                            });
                                    	}
                                        L.log('AFTP:preAnalysisForm.submit.callback', id, callback) //forse da spostare!!!
                                        if(callback) callback()
                                    }
                                    
                                ).catch(function(response){
                                        L.log('AFTP:preAnalysisForm.submit.error', id, response)
                                    	$scope.preAnalysisForm[id].status = 'error';
                                    });

                            }
                        } : { };
                        $scope.preAnalysisForm[$scope.model.source+'_*'] = $rootScope.user.admin ? {
                            title: 'labels.LOADPREANALYSIS',
                            titleClass: 'title-with-bg bg-purple',
                            titleParams: { lang: '*'},
                            status: '',
                            type: 'project',
                            model: $scope.model,
                            fields: [
                                {
                                    available: true,
                                    type: 'file',
                                    name: 'multicsvnorm',
                                    canUpload: false,
                                    noLabel: true,
                                    inputColumn: 12,
                                    limit: -1,
                                    allow: 'csv',
                                    bucket: $rootScope.bucketName($scope.model.group),
                                    filesSelectable: $rootScope.user.admin,
                                    selectionActions: [
                                        { icon: 'aqi-action-delete', label: 'labels.DELETE', action: 'delete' }
                                    ] 
                                },{
                                	available: _.contains($scope.model.dtpTypes, 'GRAPHICTEXT'),
                                	type: 'number',
                                	name: 'noMatchG',
                                	onchange: $scope.updateGNM
                                },{
                                    available: true,
                                    type: 'submit',
                                    name: 'empty',
                                    label: 'labels.ANALYZE',
                                    labelColumn: 0
                                }
                            ],
                            errorLabel: 'labels.ANALYSISERROR',
                            submit: function(){
                                this.status = 'submitting';
                                    for(var i=0; i<$scope.model.destinations.length; i++){
                                        var d = $scope.model.source+'_'+$scope.model.destinations[i];
                                        if($scope.analysis[d].hasOptimization){
                                            if(this.fields[1].available){
                                                $scope.preAnalysisForm[d].model.noMatchG = this.model.noMatchG;
                                            }
                                            $scope.preAnalysisForm[d].submit();
                                        }
                                    }
                                    var check = function(){
                                        var finished = true;
                                        for(var i=0; i<$scope.model.destinations.length; i++){
                                            var d = $scope.model.source+'_'+$scope.model.destinations[i];
                                            if($scope.analysis[d].preFile==null && $scope.analysis[d].hasOptimization){
                                                finished = false;
                                            }
                                        }
                                        if(finished){
                                            $scope.preAnalysisForm[$scope.model.source+'_*'].status = 'submitted';
                                            $scope.analysis[$scope.model.source+'_*'].preFile = '*';
                                        } else {
                                            $timeout(check, 1000);
                                        }
                                    }
                                    check();
                                    
                                

                            }
                        } : { };
                        $scope.analysisFilesForm[id] = $rootScope.user.admin ? {
                            title: 'labels.LOADANALYSIS',
                            titleParams: { lang: a.destination},
                            status: 'notsubmittable',
                            type: 'analysis',
                            model: $scope.analysis[id],
                            fields: [
                                {
                                    available: true,
                                    type: 'file',
                                    name: 'upload',
                                    canUpload: true,
                                    noLabel: true,
                                    inputColumn: 12,
                                    limit: -1,
                                    allow: 'xliff|csv|tmx|zip|mqxlz|mqxliff',
                                    sync: {
                                        folder: ['logs','translationSource'], 
                                        upload: true,
                                        lang: $scope.model.destinations.length>1 ? $rootScope.mqLanguageCode(a.destination) : null
                                    },
                                    bucket: $rootScope.bucketName($scope.model.group),
                                    filesSelectable: $rootScope.user.admin,
                                    selectionActions: [
                                        { icon: 'aqi-action-delete', label: 'labels.DELETE', action: 'delete' }
                                    ] 
                                }
                            ],
                            submit: function(){

                            }
                        } : { };
                        $scope.preAnalysisFilesForm[id] = $rootScope.user.admin ? {
                            title: 'labels.LOADPREANALYSIS',
                            titleParams: { lang: a.destination},
                            status: 'notsubmittable',
                            type: 'analysis',
                            model: $scope.analysis[id],
                            fields: [
                                {
                                    available: true,
                                    type: 'file',
                                    name: 'preupload',
                                    canUpload: true,
                                    noLabel: true,
                                    inputColumn: 12,
                                    limit: -1,
                                    allow: 'csv',
                                    sync: {
                                        folder: ['logs'], 
                                        upload: true,
                                        lang: $scope.model.destinations.length>1 ? $rootScope.mqLanguageCode(a.destination) : null
                                    },
                                    bucket: $rootScope.bucketName($scope.model.group),
                                    filesSelectable: $rootScope.user.admin,
                                    selectionActions: [
                                        { icon: 'aqi-action-delete', label: 'labels.DELETE', action: 'delete' }
                                    ] 
                                }
                            ],
                            submit: function(){

                            }
                        } : { };
                        $scope.analysisResetForm[id] = $rootScope.user.admin ? {
                            title: '',
                            status: '',
                            type: 'analysis',
                            model: $scope.analysis[id],
                            fields: [
                                {
                                    available: true,
                                    type: 'submit',
                                    name: 'empty',
                                    cls: 'btn-warning',
                                    label: $scope.analysis[id].file ? ($scope.analysis[id].hasOptimization ? 'labels.RESETANALYSIS' : 'labels.RESETPREANALYSIS') : ($scope.analysis[id].preFile ? 'labels.RESETPREANALYSIS' : 'labels.RESETHASOPTIMIZATION'),
                                    labelColumn: 0
                                }
                            ],
                            submit: function(){
                                $scope.analysisResetForm[(this.model.source + '_' + this.model.destination)].status = 'submitting';
                                var aId = this.model.id;
                                D.remove('analysis', aId).then(
                                    function(response){
                                        D.load('analysis', aId).then(
                                            function(response){
                                                if(response.hasOptimization===null) {
                                                    $timeout(function(){ $state.go('app.entity', {
                                                        type: 'project',
                                                        filter: $scope.model.id,
                                                        action: 'analyze'
                                                    }, { reload: true }); }, CONFIG.stateGoTimeout)
                                                }
                                                $scope.analysisResetForm[(response.source + '_' + response.destination)].status = '';
                                                $scope.analysisForm[(response.source + '_' + response.destination)].status = 'notsubmittable';
                                                $scope.preAnalysisForm[(response.source + '_' + response.destination)].status = 'notsubmittable';
                                                if(response.preAnalysis) response.preAnalysis = response.preAnalysis;
                                                $scope.analysis[(response.source + '_' + response.destination)] = response;
                                                $scope.analysisResetForm[(response.source + '_' + response.destination)].fields[0].label = $scope.analysis[(response.source + '_' + response.destination)].file ? 'labels.RESETANALYSIS' : ($scope.analysis[(response.source + '_' + response.destination)].preFile ? 'labels.RESETPREANALYSIS' : 'labels.RESETHASOPTIMIZATION');
                                                for(var i=0; i<$scope.anDestArray.length; i++){
                                                	if($scope.analysis[$scope.anDestArray[i]].noMatchG){
                                                		$scope.analysis[(response.source + '_' + response.destination)].noMatchG = $scope.analysis[$scope.anDestArray[i]].noMatchG;
                                                		break;
                                                	}
                                                }
                                            }
                                        ).catch(console.error);


                                    }
                                ).catch(console.error);

                            }
                        } : { };
                    }
                    $scope.totalAnalysis.normDiscount = 100-($scope.totalAnalysis.normTotal*100/ ($scope.totalAnalysis.total ? $scope.totalAnalysis.total : 1) );
                    if($scope.totalAnalysis.preAnalysis){
                        $scope.totalAnalysis.preAnalysis.normDiscount = 100-($scope.totalAnalysis.preAnalysis.normTotal*100/ ($scope.totalAnalysis.preAnalysis.total ? $scope.totalAnalysis.preAnalysis.total : 1) );
                    }
                    for(var j=0; j<$scope.anDestArray.length; j++){
                    	if(!$scope.analysis[$scope.anDestArray[j]].noMatchG){
		                    for(var i=0; i<$scope.anDestArray.length; i++){
		                    	if($scope.analysis[$scope.anDestArray[i]].noMatchG){
		                    		$scope.analysis[$scope.anDestArray[j]].noMatchG = $scope.analysis[$scope.anDestArray[i]].noMatchG;
		                    		break;
		                    	}
		                    }
                    	}
                    }
                }
            ).catch(console.error);
        }
    };
    $scope.copyAnalysisPopup = function(dest){
        var destinations = [];
        for(var i=0; i<$scope.model.destinations.length; i++){
            if($scope.model.destinations[i]!=dest){
                destinations.push({
                    key: $scope.model.destinations[i],
                    label: $filter('translate')('enums.language.'+$scope.model.source) + ' → ' + $filter('translate')('enums.language.'+$scope.model.destinations[i])
                });
            }
        }
        var a = $scope.analysis[$scope.model.source + '_' + dest];
        $scope.copyAnalysisForm = {
            title: 'labels.COPYANALYSIS',
            status: '',
            type: 'analysis',
            model: a,
            fields: [
                {
                    available: true,
                    type: 'checkboxes',
                    name: 'copyTo',
                    data: destinations,
                    valueField: 'key',
                    labelField: 'label',
                    required: true
                },
                {
                    available: true,
                    type: 'submit'
                }
            ],
            submit: function(){
                
                if(a.copyTo && a.copyTo.length){
                    ngDialog.openConfirm({
                        template: '/app/views/entities/confirm.html',
                        className: 'ngdialog-theme-default',
                        scope: $scope
                      }).then(function (value) {
                        $scope.copyAnalysisForm.status = 'submitting';
                            a.action = 'CopyAnalysis';
                            D.save('analysis', a).then(function(resp){
                                ngDialog.close();
                                $timeout(function(){ $state.go('app.entity',
                                    {action:'analyze', type:'project', filter: $scope.model.id },
                                    { reload: true }); }, CONFIG.stateGoTimeout)
                            }).catch(function(err){
                                $scope.copyAnalysisForm.status = 'error';
                            });
                        });
                }
            }
        }
        ngDialog.open(({
            template: '/app/views/entities/analysis_copy.html',
            className: 'ngdialog-theme-default ngdialog-theme-large',
            scope: $scope,
            cache: false
          }));
    }

    $scope.activeTab = -1;

    $scope.isActiveTab = function(i){
        return $scope.activeTab == i;
    }
    $scope.setActiveTab = function(i){
        $scope.activeTab = i;
    }


    $scope.offer = {
        total: 0,
        totalNoDiscount: 0,
        sum: true
    };
    $scope.offers = {};
    $scope.setOfferDirty = function(dest, dirty){
        if($scope.offers[$scope.model.source + '_' + dest]){
            console.log('setOfferDirty', dest, dirty)
            $scope.offers[$scope.model.source + '_' + dest].dirty = dirty
        }
    }
    $scope.updateOffer = function(value, dest, saved, forceDisable, doNotReload){
        console.log('parentUpdateOffer', value, dest, saved, forceDisable)
        if(saved && !doNotReload){
            D.query('offer', 'project='+$scope.model.id).then(function(resp){
                for(var i=0; i<resp.length; i++){
                    if(resp[i].destination!=dest){
                        $scope.offer[resp[i].destination] = resp[i].total
                    }
                }
                $scope.updateOffer(value, dest, saved, forceDisable, true)
            })
            return
        }
        if(dest)
            $scope.offer[dest] = value;
        $scope.offer.total = 0;
        var offerNumber = 0;
        for(var i=0; i<$scope.model.destinations.length; i++){
            var d = $scope.model.destinations[i];
            if((($scope.offer[d] || $scope.offer[d]===0) && $scope.offers[$scope.model.source+'_'+d]) || d==saved)
            	offerNumber++;
            $scope.offer.total += $scope.offer[d] ? $scope.offer[d] : 0;
            if($scope.offers[$scope.model.source+'_'+d] && $scope.offers[$scope.model.source+'_'+d].dirty){
                forceDisable = true;
            }
        }
        $scope.offer.totalNoDiscount = $scope.offer.total;
        if($scope.offer.discount){
            if($scope.offer.discount<0) $scope.offer.discount=-$scope.offer.discount;
            $scope.offer.total = Math.round(($scope.offer.total - ($scope.offer.total * ($scope.offer.discount/100))) * 100) / 100;
        }
        if(offerNumber==$scope.model.destinations.length && !forceDisable){
            $timeout(function(){ if($scope.sendOfferForm) $scope.sendOfferForm.status=''; }, 100)
        } else {
            $timeout(function(){ if($scope.sendOfferForm) $scope.sendOfferForm.status='notsubmittable'; }, 100)
        }
    }
    $scope.isThereAnOfferAccepted = false;

    $scope.offersLastT = 0;
    $scope.listenToOffersChanges = function(){
        FIREBASE.listen('Offer', $scope.model.id, function(value){
            if(value && FIREBASE.isAfter(value.timestamp,$scope.offersLastT) && $scope.offersLastT>0){
                $scope.loadOffers();
            }
        }, null, { interval: 60000 });
    }

    $scope.orders = null
    $scope.loadOrders = function(client){
        if(!$scope.orders){
            D.query('order', 'open=true&client='+client, { cache: false }).then(
                function(response){
                    if(response.length>0){
                        $scope.orders = response
                        if($scope.creationForm){
                            $scope.creationForm.fields.forEach(function(f) {
                                if(f.name=='order') f.available = true
                            })
                        }
                        if($scope.editForm){
                            $scope.editForm.fields.forEach(function(f) {
                                if(f.name=='order') f.available = true
                            })
                        }
                    }
                }
            ).catch(console.error)
        }
    }

    $scope.loadingOffers = null
    $scope.loadOffers = function(){
        $scope.offers = [];
        if($scope.loadingOffers===null) $scope.loadingOffers = true
        D.query('offer', 'project='+$scope.model.id + '&_loadOffers=true', { cache:false }).then(
            function(response){
                $scope.offers = [];
                for(var i=0; i<response.length; i++){
                    response[i].recent = new Date().getTime() - response[i].T < 30000;
                    if($rootScope.user.admin){
                        if(response[i].sum){
                            $scope.offers.push(response[i]);
                        }
                    } else{
                        $scope.offers.push(response[i]);
                    }
                    $scope.offersLastT = $scope.offersLastT<response[i].T ? response[i].T : $scope.offersLastT;
                }
                for(var i=0; i<$scope.offers.length; i++){
                    if($scope.model.status=='ESTIMATION') $scope.offers[i].accepted = false //se progetto ancora in quotazione offerta non può essere accettata (corregge eventuale errore nei dati)
                    if($scope.offers[i].accepted) {
                        $scope.isThereAnOfferAccepted = true;
                    }
                }
                $scope.loadingOffers = false
            }
        ).catch(console.error);
        $scope.splittedProjectsWithSupplier = null
        if($state.params.action=='offers' && !$scope.isThereAnOfferAccepted && $rootScope.user.group.type=='CLIENT' && $rootScope.user.opts.canacceptoffers){
            if($scope.model.code.match('-[A|B]$')){
                D.query('project','_splittedFrom=' + $scope.model.id).then(
                    function(response){
                        $scope.splittedProjectsWithSupplier = []
                        $scope.splittedProjectsWithSupplierString = ''
                        for(var i=0; i<response.length; i++){
                            if(response[i].supplier){
                                $scope.splittedProjectsWithSupplier.push(response[i])
                                $scope.splittedProjectsWithSupplierString += ',' + response[i].supplier + ','
                            }
                        }
                    }
                ).catch(console.error)
            }
        }
    };
    $scope.acceptedOffer = {};
    $scope.selectOffer = function(offer){
    	if(offer.total!==null && !$scope.isThereAnOfferAccepted && $rootScope.user.group.type=='CLIENT' && $rootScope.user.opts.canacceptoffers){
	    	var id = offer.id;
	    	$scope.acceptedOffer = {};
	        $scope.model.acceptedOffer = '';
	        for(var i=0; i<$scope.offers.length; i++){
	            if($scope.offers[i].id==id && !$scope.offers[i].selected){
	                $scope.offers[i].selected = true;
	                $scope.acceptedOffer = $scope.offers[i];
	                $scope.model.acceptedOffer = $scope.offers[i].id;
	                $scope.viewChangeStatusForm = true;
	            }
	            else
	                $scope.offers[i].selected = false;
	        }
    	}
    };
    $scope.loadOffer = function(){
        if(!$rootScope.user || !$rootScope.user.group || !$rootScope.user.group.id){
            $rootScope.$watch('user.id', function(){
                $scope.loadOffer();
            });
            return
        }
        var oId = $scope.model.id + '-' + $rootScope.user.group.id;
        D.load('offer', oId).then(
            function(response){
            	$scope.offer = response;
                $scope.offer.project = $scope.model.id;
                $scope.offer.currency = $scope.offer.currency || $scope.model.currency;
                $scope.discountForm = {
                    cls: 'form-compact',
                    model: $scope.offer,
                    fields: [{
                        available: true,
                        type: 'decimal',
                        name: 'discount',
                        noLabel: true,
                        decimals: 2,
                        postfix: '%',
                        labelColumn: 12,
                        inputColumn: 12,
                        cls: 'pull-right',
                        style: { 'min-width': '65px' },
                        onchange: function () { $scope.updateOffer() }
                    }]
                }
                $scope.openOfferAttachmentForm = function(){
                    $scope.offerAttachmentForm = $scope.offerAttachmentForm ? null : {
                        cls: 'form-compact',
                        model: { id: $scope.offer.id || ($scope.offer.project + '-' + $rootScope.user.group.id) },
                        type: 'offer',
                        fields: [{
                            available: true,
                            type: 'file',
                            name: 'supplierAttachment',
                            canUpload: !$scope.offer.sent,
                            noLabel: true,
                            inputColumn: 12,
                            limit: -1,
                            bucket: $rootScope.bucketName($scope.model.group),
                            filesSelectable: false,
                            isHorizontal: true
                        }]
                    }
                }
                $scope.offerAttachmentForm = null
                $scope.sendOfferForm = {
                    cls: 'form-compact',
                    status: 'notsubmittable',
                    fields: [
                        {
                            available: true,
                            type: 'submit',
                            name: 'empty',
                            labelColumn: 12,
                            inputColumn: 12,
                            cls: 'pull-right',
                            noLabel: true
                        }
                    ],
                    validate: function(){
                    	var errors = [];
                    	if(!_.size($scope.offers))errors.push({error:'missingOffer'});
                    	for(var key in $scope.offers){
                    		if($scope.offers.hasOwnProperty( key ) && !$scope.offers[key].total && $scope.offers[key].total!==0){
                    			errors.push({error:'missingOffer'});
                    		}
                    	}
                    	if($scope.offer.discount==='' || $scope.offer.discount===null || $scope.offer.discount===undefined)
                            errors.push({error:'required',field:{name:'discount'} });
                    	if(!$scope.offer.proposedDate)
                    		errors.push({error:'required',field:{name:'proposedDate'} });

                    	if(errors.length) {
                    		var errorMessages ="<ul>";
                    		for(var i=0; i<errors.length; i++){
                    			var e = errors[i];
                    			errorMessages += "<li>"
                    				+$filter('translate')('labels.VALIDATIONERROR'+e.error.toUpperCase(), { name: $filter('translate')('fields.'+e.field.name.toUpperCase()) })
                    				+"</li>";
                    		}
                    		errorMessages += "</ul>";
                    		$scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), errorMessages);
                    		return false;
                    	}
                    	else return true;
                    },
                    submit: function(){
                    	if(this.validate()){
                            $scope.updateOffer()
                    		ngDialog.openConfirm({
                                template: 'confirmSendOfferDialog',
                                className: 'ngdialog-theme-default',
                                scope: $scope
                              }).then(function (value) {
                            	  $scope.sendOfferForm.status = 'submitting';
      	                        var o = $scope.offer;
      	                        o.sent = true;
      	                        D.save('offer', o).then(
      	                            function(response){
      	                                $scope.sendOfferForm.status = 'submitted';
      	                                $scope.offer = response;
      	                                $scope.offer.sent = true;
                                          $timeout(function(){ $state.go('app.do',
                                              {action:'open', type:'project', filter: $scope.model.id },
                                              { reload: true }); }, CONFIG.stateGoTimeout)
      	                            }
      	                            
      	                        ).catch(function(response){
      	                                $scope.sendOfferForm.status = 'error';
      	                              $scope.offer.sent = false;
      	                            });
                              });

                    	}
                    }
                };
            }
        ).catch(console.error);
    };

    $scope.reEnableOffers = function(){
    	ngDialog.openConfirm({
            template: '/app/views/entities/offer-confirmedit.html',
            className: 'ngdialog-theme-default',
            scope: $scope
          }).then(function (value) {
	    	D.load('project', $scope.model.id).then(
	    			function(response){
	    				if(response.status=='ESTIMATION'){
	    					D.remove('offer', $scope.offer.id).then(
	    			    			function(){
	    			    				$timeout(function(){ $state.go('app.do',
	    			                        {action:'open', type:'project', filter: $scope.model.id },
	    			                        { reload: true }); }, CONFIG.stateGoTimeout)
	    			    			}
	    			    	).catch(console.error);
	    				} else {
	    					$scope.pop('error','labels.ERROR','labels.PROJECTALREADYASSIGNED')
	    				}
	    			}).catch(console.error);
          });


    };

    $scope.openOfferDetails = function(offer){
    	if(offer.total!==null){
	    	offer.loadingDetails = true;
            var scope = $scope.$new();
            scope.openedFromProject = true;
            scope.offer = offer;
	    	D.query('offer', 'project='+$scope.model.id+'&supplier='+offer.supplier+'&sum=false').then(
	                function(response){
	                	offer.loadingDetails = false;
	                	offer.offers = response;
                        offer.totalOfferBeforeDiscount = offer.offers.reduce((prev, curr) => prev + curr.total, 0)
	                	ngDialog.open({
	                	      template: '/app/views/entities/offer-details.html',
	                	      className: 'ngdialog-theme-default ngdialog-theme-large',
	                	      scope: scope,
	                	      cache: false
	                	    })
	                }
	            ).catch(console.error);
    	}
    };

    $scope.editOffer = function(offer, field){
        var scope = $scope.$new();
        offer.action = 'AdminEditOffer';
        let adjLanguages = []
        if(field=='adjustment'){
            ($scope.model.destinations || $scope.project.destinations).forEach(function(d) {
                adjLanguages.push({ value: d, label: d })
            })
        }
        scope.form = {
            model: Object.assign({ action: 'AdminEditOffer' }, offer, field=='adjustment' ? { adjustedLangs: [].concat($scope.model.destinations || $scope.project.destinations) } : {}),
            info: !field ? $filter('translate')('labels.EDITOFFERINFO') : (field=='adjustment' ? $filter('translate')('labels.ADJUSTMENTINFO') : ''),
            fields: [
                {
                    available: field=='discount',
                    name: 'discount',
                    type: 'decimal',
                    displayType: 'decimal',
                    decimalSep: $rootScope.user.decimalSep,
                    decimals: 2,
                    postfix: '%',
                    style: { 'min-width': '65px' }
                },{
                    available: field=='adjustment',
                    name: 'adjustment',
                    type: 'decimal',
                    displayType: 'decimal',
                    decimalSep: $rootScope.user.decimalSep,
                    decimals: 2,
                    labelColumn: 4,
                    inputColumn: 8,
                    postfix: $filter('translate')('enums.currencySymbol.' + offer.currency),
                    required: true
                },{
                    available: field=='adjustment',
                    name: 'adjustedLangs',
                    label: 'fields.LANGUAGES',
                    type: adjLanguages.length > 1 ? 'checkboxes' : 'hidden',
                    labelEnum: 'language',
                    data: adjLanguages,
                    required: true,
                    labelColumn: 4,
                    inputColumn: 8,
                    hideSelectUnselectAll: true
                },{
                    available: !field,
                    type: 'decimal',
                    displayType: 'decimal',
                    decimalSep: $rootScope.user.decimalSep,
                    decimals: 3,
                    name: 'rate',
                    labelColumn: 6,
                    inputColumn: 6,
                    postfix: $filter('translate')('enums.currencySymbol.' + offer.currency),
                    required: true
                },{
                    available: offer.pagination && !field,
                    type: 'decimal',
                    displayType: 'decimal',
                    decimalSep: $rootScope.user.decimalSep,
                    decimals: 2,
                    name: 'pagination',
                    labelColumn: 6,
                    inputColumn: 6,
                    postfix: $filter('translate')('enums.currencySymbol.' + $scope.model.currency || $scope.project.currency),
                    required: offer.pagination && !field
                },{
                    available: !field,
                    type: 'decimal',
                    displayType: 'decimal',
                    decimalSep: $rootScope.user.decimalSep,
                    decimals: 2,
                    name: 'extra',
                    labelColumn: 6,
                    inputColumn: 6,
                    postfix: $filter('translate')('enums.currencySymbol.' + $scope.model.currency || $scope.project.currency),
                    required: false
                },{
                    available: true,
                    type: 'submit',
                    name: 'empty',
                    label: 'labels.SAVE'
                }
            ],
            validate: function(){
                var errors = [];
                for(var i=0; i<this.fields.length; i++){
                        var field = this.fields[i];
                        if(field.required && field.available && !this.model[field.name]){
                            errors.push({field:field,error:'required'});
                        }

                }
                if(errors.length) {
                    var errorMessages ="<ul>";
                    for(var i=0; i<errors.length; i++){
                        var e = errors[i];
                        errorMessages += "<li>"
                            +$filter('translate')('labels.VALIDATIONERROR'+e.error.toUpperCase(), { name: $filter('translate')('fields.'+e.field.name.toUpperCase()) })
                            +"</li>";
                    }
                    errorMessages += "</ul>";
                    this.status = 'error';
                    return false;
                }
                else return true;
            },
            submit: function(){
                if(this.validate()){
                    this.status = 'submitting';
                    R.one('offer', this.model.id).customPUT(this.model).then(
                        function(response){
                            ngDialog.close();
                            $scope.openOfferDetails(response)
                            $scope.loadOffers();
                        },
                        function(response){
                            this.status = 'error';
                        }
                    );
                }
            }
        }
        ngDialog.open({
                template: '/app/views/entities/offer-edit.html',
                className: 'ngdialog-theme-default',
                scope: scope,
                cache: false
              })
        
    }

    $scope.popupFileList = function(files, title, params){

	    	var scope = $scope.$new();
	    	scope.files = files;
            scope.title = title;
            scope.params = params
	    	ngDialog.open({
	                	      template: '/app/views/entities/file-popuplist.html',
	                	      className: 'ngdialog-theme-default',
	                	      scope: scope,
	                	      cache: false
	                	    });

    };

    $scope.loadFiles = function(mode){
        D.query('file','entityId=' + $scope.model.id +'&type=project&field=upload', { cache: false }).then(
            function(response){
                $scope.uploadedFiles = response;
            }
        ).catch(console.error);
        if((mode=='estimate') || (mode=='supplierview') || (mode=='offers') || (mode=='review')){
        	D.query('file','entityId=' + $scope.model.id +'&type=project&field=analysis', { cache: false }).then(
                    function(response){
                        $scope.analysisFiles = response;
                        $scope.analysisFilesParams = {
                            type: 'project',
                            field: 'analysis',
                            entity: $scope.model.id,
                            name: $scope.model.code + '_' + $filter('translate')('fields.ANALYSISPDF')
                        }
                    }
                ).catch(console.error);
        	D.query('file','entityId=' + $scope.model.id +'&type=project&field=upload', { cache: false }).then(
                    function(response){
                        $scope.sourceFiles = response;
                        $scope.sourceFilesParams = {
                            type: 'project',
                            field: 'upload',
                            entity: $scope.model.id,
                            name: $scope.model.code + '_' + $filter('translate')('fields.SOURCEFILES')
                        }
                    }
                ).catch(console.error);
            if($rootScope.user.group.type=='SUPPLIER' && $rootScope.user.group.opts.canviewcsv){
                D.query('file','parentId=' + $scope.model.id +'&extension=csv&parenttype=project&parentfield=analysis:upload', { cache: false }).then(
                    function(response){
                        $scope.csvFiles = [ response[0] ]; 
                    }
                ).catch(console.error);
            }
        }
        if((mode=='estimate') || (mode=='supplierview') || (mode=='process') || (mode=='offers') || (mode=='review')){
            D.query('file','entityId=' + $scope.model.id +'&type=project&field=supplierNotesFiles', { cache: false }).then(
                    function(response){
                        $scope.supplierNotesFiles = response;
                        $scope.supplierNotesFilesParams = {
                            type: 'project',
                            field: 'supplierNotesFiles',
                            entity: $scope.model.id,
                            name: $scope.model.code + '_' + $filter('translate')('fields.SUPPLIERINSTRUCTIONS')
                        }
                    }
                ).catch(console.error);
        }
        if(mode=='review' || mode=='report'){
        	D.query('file','entityId=' + $scope.model.id +'&type=project&field=clientNotesFiles', { cache: false }).then(
                    function(response){
                        $scope.clientNotesFiles = response;
                    }
                ).catch(console.error);
        }

        if(($scope.model.status=='DELIVERED' || $scope.model.status=='PROCESSING' || $scope.model.status=='CONFIRMED' || $scope.model.status=='ARCHIVED') &&
        ($scope.model.group=='tan' || $scope.model.group=='nrx') &&
        ($rootScope.user.group.id=='tan' || $rootScope.user.group.id=='nrx' || $rootScope.user.group.type=='ADMIN')){
            $scope.excelForm={
                type: 'project',
                model: $scope.model,
                fields:[
                    {
                        available: true,
                        type: 'file',
                        name: 'acceptedOfferAttachment',
                        canUpload: false,
                        cantDelete: true,
                        noLabel: true,
                        inputColumn: 12,
                        bucket: $rootScope.bucketName($scope.model.group)
                    }
                ]
            }
        }
    };

    $scope.translationsLastT = 0;
    $scope.listenToTranslationsChanges = function(){
        FIREBASE.listen('Translation', $scope.model.id, function(value){
            if(value && FIREBASE.isAfter(value.timestamp,$scope.translationsLastT) && $scope.translationsLastT>0){
                $scope.loadTranslations();
            }
        }, null, { interval: 60000 });
    }

    $scope.translationsForFiles = {};
    $scope.translationsFilesForm = {};
    $scope.loadTranslations = function(){
        D.query('translation', 'project='+$scope.model.id, { cache: false }).then(
            function(response){
                for(var i=0; i<response.length; i++){
                    response[i].recent = (new Date().getTime() - response[i].T < 30000) && response[i].modBy!=$rootScope.user.id;
                    $scope.translationsLastT = $scope.translationsLastT<response[i].T ? response[i].T : $scope.translationsLastT;
                }
                
                response.sort(function(a, b){
                    return $filter('translate')('enums.language.'+a.destination) > $filter('translate')('enums.language.'+b.destination) ? 1 : -1;
                });
                $scope.translations = response;
                $scope.translationsNotDelivered = $scope.translations.filter(t => t.status!='DELIVERED')
                $scope.translationsImport = $scope.translations.filter(t => t.status=='IMPORT')

                if($scope.model.hasReview){
                    for(let i=0; i<$scope.translations.length; i++){
                        if($scope.translations[i].status=='TRANSLATION') { $scope.translations[i].isBeforeReview = true; }
                        if(($scope.translations[i].status=='IMPORT' || $scope.translations[i].status=='LAYOUT') && $scope.model.dtp && !$scope.translations[i].anticipateReview) { $scope.translations[i].isBeforeReview = true; }
                    }
                }

                if($scope.model.group=='aag' && $rootScope.user.admin){
                    for(let t of $scope.translations){
                        if(t.status!='DELIVERED'){
                            D.save('translation', { id: t.id, action: 'checkExistingFileOnWebdav'}).then(function(response){

                            }).catch(function(err){
                                if(err.data && err.data.exc && err.data.exc=='InvalidValueException'){
                                    if(err.data.msg.indexOf('webdavFileExists=')===0){
                                        $scope.webdavFileExists = err.data.msg.substring('webdavFileExists='.length)
                                    }
                                    if(err.data.msg.indexOf('webdavCheck=')===0){
                                        $scope.webdavFileExists = 'CHECKERROR'
                                    }
                                }
                            })
                        }
                    }
                }

                $scope.QAErrors = 0;
                for(var i=0; i<$scope.translations.length; i++){
                    $scope.QAErrors += $scope.translations[i].QAErrors || 0;
                }

                var langToLocale = function(lang){
                    lang = lang.replace(/_/g, '-')
                    lang = lang.split('-')
                    if(lang.length>1){
                        lang[lang.length-1] = lang[lang.length-1].toUpperCase()
                    }
                    lang = lang.join('-')
                    return lang
                }
                $scope.deliveredZipName = $scope.model.code + '_' + $filter('translate')('fields.TRANSLATIONFINALS').replace(/\s/g,'_')
                D.query('file', 'type=project&field=translation:revision|translation:delivery&entityId=' + $scope.model.id, { cache: false })
                    .then(function (response) {
                        $scope.deliveredFiles = response
                        $scope.deliveredFilesSize = 0
                        for(var i=0; i<$scope.deliveredFiles.length; i++){
                            var f = $scope.deliveredFiles[i];
                            f.name = langToLocale(f.entity.split('-')[f.entity.split('-').length-1]) + '/' + f.name
                            $scope.deliveredFilesSize += f.size
                        }
                    }).catch(console.error)
                if($state.params.action=='process' && $rootScope.user.group.type=='SUPPLIER'){
                    $scope.toBeTranslatedZipName = $scope.model.code + '_' + $filter('translate')('enums.translationStatus.TRANSLATION').replace(/\s/g,'_')
                    $scope.toBeTranslatedExt = 'xliff|tmx|zip|mqxlz|mqxliff'
                    if($rootScope.user.group.opts.canviewcsv){
                        $scope.toBeTranslatedExt += '|csv'
                    }
                    D.query('file', 'type=project&entityId='+$scope.model.id+'&extension='+$scope.toBeTranslatedExt+'&field=analysis:upload', { cache: false }).then(
                        function(response){
                            $scope.toBeTranslatedFiles = response;
                        }).catch(console.error);
                    if($scope.model.dtp){
                        $scope.toBeImpaginatedZipName = $scope.model.code + '_' + $filter('translate')('enums.translationStatus.LAYOUT').replace(/\s/g,'_')
                        D.query('file', 'type=translation&parentid='+$scope.model.id+'&field=layout', { cache: false }).then(
                            function(response){
                                $scope.toBeImpaginatedFiles = response;
                            }).catch(console.error);
                    }
                }
                if($state.params.action=='process' && $rootScope.user.admin){
                    if($scope.initForceDeliveryForm) $scope.initForceDeliveryForm()
                    $scope.importedZipName = $scope.model.code + '_' + $filter('translate')('fields.TRANSLATIONXLIFF').replace(/\s/g,'_')
                    D.query('file', 'type=project&field=translation:translation&entityId=' + $scope.model.id, { cache: false })
                    .then(function (response) {
                        $scope.importedFiles = response
                        $scope.importedFilesSize = 0
                        for(var i=0; i<$scope.importedFiles.length; i++){
                            var f = $scope.importedFiles[i];
                            f.name = langToLocale(f.entity.split('-')[f.entity.split('-').length-1]) + '/' + f.name
                            $scope.importedFilesSize += f.size
                        }
                    }).catch(console.error)

                    var ids = '';
                    for(var i=0; i<response.length; i++){
                        if(ids) ids+='|';
                        ids+=response[i].id;
                    }
                    $scope.downloadAllTranslationsForm = {
                        title: '',
                        status: 'notsubmittable',
                        type: 'project',
                        model: $scope.model,
                        fields: [
                            {
                                available: true,
                                type: 'zipfile',
                                name: 'translation:translation',
                                canUpload: false,
                                label: 'fields.TRANSLATIONXLIFF',
                                labelColumn: 4,
                                inputColumn: 8
                            }
                        ]
                    }
                    $scope.downloadAllImpaginatedForm = {
                        title: '',
                        status: 'notsubmittable',
                        type: 'project',
                        model: $scope.model,
                        fields: [
                            {
                                available: true,
                                type: 'zipfile',
                                name: 'translation:revision',
                                canUpload: false,
                                label: 'fields.TRANSLATIONREVISION',
                                labelColumn: 4,
                                inputColumn: 8
                            }
                        ]
                    }
                }

                if($state.params.action=='files'){
                	for(var i=0; i<$scope.model.destinations.length; i++){
                		$scope.translationsForFiles[$scope.model.destinations[i]] = true;
                		$scope.translationsFilesForm[$scope.model.destinations[i]] = {
                                title: '',
                                titleParams: { lang: $scope.model.destinations[i]},
                                status: 'notsubmittable',
                                type: 'translation',
                                model: {
                                    id: $scope.model.id + '-' + $scope.model.source + '-' + $scope.model.destinations[i],
                                },
                                fields: [
                                    {
                                        available: true,
                                        type: 'file',
                                        name: 'translation',
                                        canUpload: true,
                                        label: 'labels.LOADTRANSLATIONXLIFF',
                                        labelParams: { lang: $scope.model.destinations[i]},
                                        labelColumn: 4,
                                        inputColumn: 12,
                                        limit: -1,
                                        allow: 'xliff|zip|mqxlz|mqxliff',
                                        zipFilename: $scope.model.code + '_' + $scope.model.destinations[i] + '_xliff',
                                        bucket: $rootScope.bucketName($scope.model.group),
                                        filesSelectable: $rootScope.user.admin,
                                        selectionActions: [
                                            { icon: 'aqi-action-delete', label: 'labels.DELETE', action: 'delete' }
                                        ] 
                                    },{
                                        available: $scope.model.dtp,
                                        type: 'file',
                                        name: 'layout',
                                        canUpload: true,
                                        label: 'labels.LOADFILESFORDTP',
                                        labelParams: { lang: $scope.model.destinations[i]},
                                        labelColumn: 4,
                                        inputColumn: 12,
                                        limit: -1,
                                        zipFilename: $scope.model.code + '_' + $scope.model.destinations[i] + '_dtp',
                                        bucket: $rootScope.bucketName($scope.model.group),
                                        filesSelectable: $rootScope.user.admin,
                                        selectionActions: [
                                            { icon: 'aqi-action-delete', label: 'labels.DELETE', action: 'delete' }
                                        ] 
                                    },{
                                        available: true,
                                        type: 'file',
                                        name: 'revision',
                                        canUpload: true,
                                        label: 'labels.LOADTRANSLATIONLAYOUT',
                                        labelParams: { lang: $scope.model.destinations[i]},
                                        labelColumn: 4,
                                        inputColumn: 12,
                                        limit: -1,
                                        zipFilename: $scope.model.code + '_' + $scope.model.destinations[i] + '_layout',
                                        bucket: $rootScope.bucketName($scope.model.group),
                                        filesSelectable: $rootScope.user.admin,
                                        selectionActions: [
                                            { icon: 'aqi-action-delete', label: 'labels.DELETE', action: 'delete' }
                                        ] 
                                    },{
                                        available: !$scope.model.dtp,
                                        type: 'file',
                                        name: 'delivery',
                                        canUpload: true,
                                        label: 'labels.LOADFILESNODTP',
                                        labelColumn: 4,
                                        inputColumn: 12,
                                        limit: -1,
                                        zipFilename: $scope.model.code + '_' + $scope.model.destinations[i] + '_noDtp',
                                        bucket: $rootScope.bucketName($scope.model.group),
                                        filesSelectable: $rootScope.user.admin,
                                        selectionActions: [
                                            { icon: 'aqi-action-delete', label: 'labels.DELETE', action: 'delete' }
                                        ] 
                                    }
                                ]
                            };
                	}
                }

            }
        ).catch(console.error);
    };

    $scope.setFullDiscount = function(v){
    	$scope.model.discountFull = v;
    	$scope.model.action = 'setFullDiscount';
        $scope.changingFullDiscount = true
    	D.save('project', $scope.model).then(
    			function(response){
    				$scope.model.discountFull = response.discountFull;
    				delete $scope.model.action;
    				$scope.loadAnalysis();
                    $scope.changingFullDiscount = false
    			}
    	).catch(console.error);
    };

    $scope.toggleAdminListener = function(){
        ngDialog.openConfirm({
            template: '/app/views/entities/confirm.html',
            className: 'ngdialog-theme-default',
            scope: $scope
          }).then(function (value) {
            $scope.togglingAdminListener = true
            $scope.model.action = 'toggleListenerAdmin'
            D.save('project', $scope.model).then(function(response){
                $scope.togglingAdminListener = false
                $scope.model.isAdminListener = (','+response.opts.listenerAdmins+',').indexOf(',' + $rootScope.user.id + ',')>=0
            }).catch(function(){
                $scope.togglingAdminListener = false
            })
          })
    }


    $scope.togglingLanguageAnalystReviewListener = {}
    $scope.toggleLanguageAnalystReviewListener = function(translation, forceValue){
        if(translation=='*'){
            for(let i=0; i<$scope.translations.length; i++){
                if($scope.translations[i].opts.reviewNotificationsToLa!==forceValue && $scope.translations[i].review){
                    $scope.toggleLanguageAnalystReviewListener($scope.translations[i].id, forceValue)
                }
            }
        } else {
            for(let i=0; i<$scope.translations.length; i++){
                let id = $scope.translations[i].id 
                if(id == translation && $scope.translations[i].review){
                    $scope.togglingLanguageAnalystReviewListener[id] = true;
                    $scope.translations[i].action = 'setNotificationListener';
                    if(forceValue!==undefined) $scope.translations[i].notificationListenerValue = forceValue
                    D.save('translation', $scope.translations[i]).then(function(resp){
                        $scope.translations[i] = resp;
                        $scope.togglingLanguageAnalystReviewListener[id] = false;
                    }).catch(function(){
                        $scope.togglingLanguageAnalystReviewListener[id] = false;
                    });
                }
            }
        }
    }

    $scope.openAdminNotes = function(){

        $scope.changeANForm = {
            title: '',
            status: '',
            type: 'project',
            model: $scope.model,
            fields: [
                {
                    available: true,
                    type: 'textarea',
                    name: 'adminNotes',
                    noLabel: true,
                    rows: 10,
                    labelColumn: 0,
                    inputColumn: 12
                },{
                    available: true,
                    type: 'submit',
                    label: 'labels.SAVE'
                }
            ],
            submit: function(){
                $scope.changeANForm.status = 'submitting';
                $scope.model.action = 'edit';
                D.save('project', $scope.model).then(
                    function(response){
                        $scope.changeANForm.status = '';
                        $scope.model.action = '';
                        ngDialog.close();
                    }
                ).catch(function(response){
                        $scope.changeANForm.status = 'error';
                    });
            }
        }

        ngDialog.open({
                          template: '/app/views/entities/project-adminnotes.html',
                          className: 'ngdialog-theme-default ngdialog-theme-large',
                          scope: $scope,
                          cache: false
                        });
    };

    $scope.loadWait = function(){
        D.query('wait','awaited='+$scope.model.id, { cache: false }).then(function(response){
            $scope.model.awaitedby = response;
        }).catch(console.error);
        D.query('wait','waiting='+$scope.model.id, { cache: false }).then(function(response){
            $scope.model.waitingfor = response;
        }).catch(console.error);
    }

    $scope.loadCosts = function(reload){
        D.load('packet', 'project_'+$scope.model.id + (reload ? '_reload' : '')).then(function(response){
            var translated = 0
            var translatedTotal = 0
            var recovered = 0
            var recoveredTotal = 0
            var hasTransactions = false
            for(var j=0; j<response.transactions.length; j++){
                hasTransactions = true
                if(response.transactions[j].action=='TRANSLATED' || response.transactions[j].action=='USED'){
                    translated += response.transactions[j].words;
                    translatedTotal += response.transactions[j].words * response.transactions[j].price;
                }
                if(response.transactions[j].action=='RECOVERED'){
                    recovered += response.transactions[j].words;
                    recoveredTotal += response.transactions[j].words * response.transactions[j].price;
                }
            }
            var translatedAvg = 0.02;
            var recoveredAvg = 0.02;
            if(translated) translatedAvg = Math.round(1000 * translatedTotal / translated) / 1000;
            if(recovered) recoveredAvg = Math.round(1000 * recoveredTotal / recovered) / 1000;
            $scope.model.packet = response;
            
            D.load('packet', 'current' + $scope.model.group).then(function(r){
                if(!hasTransactions && r.price){
                    translatedAvg = r.price
                    recoveredAvg = r.price
                }
                D.query('analysis', 'project='+$scope.model.id, { cache: false }).then(
                    function(response){
                        response.sort(function(a, b){
                            return $filter('translate')('enums.language.'+a.destination) > $filter('translate')('enums.language.'+b.destination) ? 1 : -1;
                        });
                        $scope.langCosts = [];
                        for(var i=0; i<response.length; i++){
                            var a = response[i];
                            var eqrec = Math.round(a.recovered * 0.04 / recoveredAvg)
                            var cost = a.normTotal * translatedAvg + eqrec * recoveredAvg;
                            var price = (a.normTotal + a.recovered)>0 ? Math.round(1000*(a.normTotal * translatedAvg + eqrec * recoveredAvg))/1000 / (a.normTotal + eqrec) : 0
                            $scope.langCosts.push({
                                language: a.destination,
                                words: a.normTotal || 0,
                                eqrecovered: eqrec,
                                recovered: a.recovered || 0,
                                costs: cost,
                                price: price
                            })
                            if(!hasTransactions){
                                $scope.model.packet.size += a.normTotal + eqrec
                                $scope.model.packet.price += cost
                            }
                        }
                        $scope.langCostsTable = {
                            title: 'labels.LANGCOSTSTABLE',
                            filter: false,
                            orderBy: '',
                            order: '',
                            fields: [
                                {
                                    available: true,
                                    name: 'language',
                                    type: 'enum',
                                    enumType: 'language'
                                },{
                                    available: true,
                                    name: 'price',
                                    type: 'currency',
                                    decimals: 3,
                                    def: 0,
                                    decimalSep: $rootScope.user.decimalSep,
                                    style: { textAlign: 'right' },
                                    currency: $scope.model.currency
                                },{
                                    available: true,
                                    name: 'words',
                                    label: 'TRANSLATED',
                                    type: 'decimal',
                                    decimals: 0,
                                    def: 0,
                                    decimalSep: $rootScope.user.decimalSep,
                                    style: { textAlign: 'right' }
                                },{
                                    available: true,
                                    name: 'eqrecovered',
                                    label: 'RECOVEREDWORDSWITHA',
                                    type: 'decimal',
                                    decimals: 0,
                                    def: 0,
                                    decimalSep: $rootScope.user.decimalSep,
                                    style: { textAlign: 'right' },
                                    otherValue: {
                                        name: 'recovered',
                                        type: 'decimal',
                                        decimals: 0,
                                        def: 0,
                                        decimalSep: $rootScope.user.decimalSep
                                    }
                                },{
                                    available: true,
                                    name: 'costs',
                                    label: 'LANGCOSTS',
                                    type: 'currency',
                                    decimals: 2,
                                    def: 0,
                                    decimalSep: $rootScope.user.decimalSep,
                                    style: { textAlign: 'right' },
                                    currency: $scope.model.currency
                                }
                            ]
                        }
                    }).catch(console.error)
            }).catch(console.error)
            
        }).catch(console.error)
        $scope.costsTable = {
            title: 'labels.TRANSACTIONSTABLE',
            filter: false,
            orderBy: '',
            order: '',
            fields: [
                {
                    available: true,
                    name: 'timestamp',
                    label: 'DATE',
                    type: 'date',
                    format: 'YYYY-MM-DD HH:mm:ss'
                },{
                    available: true,
                    name: 'price',
                    type: 'currency',
                    decimals: 3,
                    decimalSep: $rootScope.user.decimalSep,
                    style: { textAlign: 'right' },
                    currency: $scope.model.currency
                },{
                    available: true,
                    name: 'words',
                    label: 'TRANSACTIONWORDS',
                    type: 'decimal',
                    decimals: 0,
                    decimalSep: $rootScope.user.decimalSep,
                    style: { textAlign: 'right' },
                    otherValue: {
                        name: 'quantity',
                        type: 'decimal',
                        decimals: 0,
                        decimalSep: $rootScope.user.decimalSep,
                        condition: function(m){
                            return m.action=='RECOVERED'
                        }
                    }
                },{
                    available: true,
                    name: 'action',
                    label: 'PACKETACTION',
                    type: 'enum',
                    enumType: 'packetactions',
                },{
                    available: true,
                    name: 'reason',
                    type: 'string'
                }
            ]
        }
        
    }

    $scope.toggleStandby = function(){
        if($rootScope.user.group.type=='ADMIN'){
            $scope.model.action = 'standby';
            D.save('project', $scope.model).then(function(p){
                $scope.model = p;
            }).catch(console.error);
        }
    }

    $scope.selectTranslator = function(translation){
        if($rootScope.user.group.type=='SUPPLIER' && $rootScope.user.group.opts.manageTranslators){

            $scope.translatorIsAssigned = translation.translator;
            $scope.currentTranslation = translation;

            $scope.translatorsTable = {
                title: '',
                filter: true,
                orderBy: '',
                order: '',
                fields: [
                    {
                        available: true,
                        type:'img',
                        name: 'pic',
                        noLabel: true
                    },
                    {
                    	available: true,
                    	name: 'name',
                        filterType: 'text',
                        filterValue: ''
                    },{
                    	available: true,
                    	name: 'translatoredit',
                        type: 'click',
                        onclick: function(t){
                            $scope.editTranslatorForm.model = t;
                            $scope.showEditTranslatorForm = true;
                            
                        },
                    	icon: 'aqi-action-edit'
                    },{
                    	available: true,
                    	name: 'translatorselect',
                        type: 'click',
                        isButton: true,
                        buttonLabel: 'fields.TRANSLATORSELECT',
                    	onclick: function(t){
                            for(var i=0; i<$scope.translations.length; i++){
                                if($scope.translations[i].id == translation.id){
                                    $scope.translations[i].translator = t.id;
                                    $scope.translations[i].translatorName = t.name;
                                    $scope.translations[i].translatorPic = t.pic;
                                    $scope.translations[i].action = 'setTranslator';
                                    D.save('translation', $scope.translations[i]).then(function(resp){
                                        ngDialog.close();
                                    }).catch(console.error);
                                }
                            }
                            
                        },
                    	icon: 'aqi-link'
                    },{
                    	available: true,
                    	name: 'translatordelete',
                        type: 'click',
                        onclick: function(t){
                            ngDialog.openConfirm({
                                template: '/app/views/entities/confirm.html',
                                className: 'ngdialog-theme-default',
                                scope: $scope
                              }).then(function (value) {
                                D.remove('translator', t.id).then(function(response){
                                    for(var i=0; i<$scope.translators.length; i++){
                                        if($scope.translators[i].id==t.id){
                                            $scope.translators.splice(i, 1);
                                            $scope.translatorsTable.elementsLoaded--;
                                            break;
                                        }
                                    }
                                }).catch(function(err){
                                    $scope.pop('error', $filter('translate')('labels.TRANSLATORASSIGNED'));
                                });
                            });
                            
                        },
                    	icon: 'aqi-action-delete'
                    },
                ]
            }

            $scope.translatorsTable.availableFields = $scope.translatorsTable.fields.filter(function(f){ return f.available; });

            $scope.translatorsTable.elementsLoaded = 0;
            $scope.translatorsTablelastCursor = '';

            $scope.translatorsTableLoadMore = function(){
                $scope.translatorsTableLoad(10, $scope.translatorsTablelastCursor, 12);
            };
            $scope.translatorsTableLoad = function(range, cursor, times){
                //L.log('load ' + $scope.filtering);
                /*if($scope.filtering) {
                    $scope.preFilter = {times: times, cursor: cursor, range: range };
                    return;
                }*/
                if($rootScope.IE && times>2) times = 2;
            	var filter = '';
            	if(cursor) {
            		if(filter) filter += '&';
            		filter += '_cursor='+cursor;
            	}
                if(filter) filter += '&';
                filter += 'range=' + range;
            	if(!cursor) $scope.translators = [];
            	$scope.translatorsTable.loading = true;
	            D.query('translator', filter, { cache: false }).then(
	                        function(response){
	                        	for(var i=0; i<response.length; i++)
                                    $scope.translators.push(response[i]);
                                    
                                $scope.translators.sort(function(a, b){
                                    return a.name > b.name;
                                })

                                $scope.translatorsTable.elementsLoaded += response.length;
                                $scope.translatorsTablelastCursor = response.cursor;

                                if((response.length===range || response.queryRL===range) && response.cursor){
                                    if(times-1>0 || (response.length<response.queryRL && $scope.data.length<50))
	                        		    $scope.translatorsTableLoad(range+10>50 ? 50 : range+10, response.cursor, times-1);
                                    else{
                                        $scope.translatorsTable.loading = false;
                                        $scope.translatorsTable.finished = false;
                                    }
	                        	} else {
                                    $scope.translatorsTable.loading = false;
                                    $scope.translatorsTable.finished = true;
                                }
	                        },
	                        function(error){
	                            $scope.error = error;
	                            $scope.translatorsTable.loading = false;
	                        }
	                    ).catch(console.error);
            };
            $scope.translatorsTableLoad(10, '', 12);

            
            $scope.addTranslatorForm = {
                title: 'labels.TRANSLATORADD',
                status: '',
                type: 'translator',
                model: {
                    tempId: $rootScope.generateUUID(true, '_TEMP_')
                },
                fields: [
                    {
                        available: true,
                        type: 'text',
                        name: 'name',
                        required: true
                    },{
                        label: 'fields.UPLOADPICTURE',
                        available: true,
                        type: 'file',
                        name: 'picture',
                        limit: 1,
                        canUpload: true,
                        allow: 'jpg|jpeg|png',
                        bucket: $rootScope.bucketName()
                    },{
                        available: true,
                        type: 'submit',
                        label: 'labels.ADD'
                    }
                ],
                submit: function(){
                    if($scope.addTranslatorForm.model.name){
                        $scope.addTranslatorForm.status = 'submitting';
                        D.save('translator', $scope.addTranslatorForm.model).then(
                            function(response){
                                $scope.addTranslatorForm.status = '';
                                $scope.model.action = '';
                                $scope.addTranslatorForm.show = false;
                                $scope.translators.unshift(response);
                                $scope.translatorsTable.elementsLoaded++;
                                $scope.addTranslatorForm.model = {
                                    tempId: $rootScope.generateUUID(true, '_TEMP_')
                                }
                            } 
                        ).catch(function(response){
                                $scope.addTranslatorForm.status = 'error';
                            });
                    }
                }
            }
            $scope.editTranslatorForm = {
                title: 'fields.TRANSLATOREDIT',
                status: '',
                type: 'translator',
                model: {
                    tempId: $rootScope.generateUUID(true, '_TEMP_')
                },
                fields: [
                    {
                        available: true,
                        type: 'text',
                        name: 'name',
                        required: true
                    },{
                        label: 'fields.UPLOADPICTURE',
                        available: true,
                        type: 'file',
                        name: 'picture',
                        limit: 1,
                        canUpload: true,
                        allow: 'jpg|jpeg|png',
                        bucket: $rootScope.bucketName()
                    },{
                        available: true,
                        type: 'submit',
                        label: 'labels.SAVE'
                    }
                ],
                submit: function(){
                    if($scope.editTranslatorForm.model.name){
                        $scope.editTranslatorForm.status = 'submitting';
                        D.save('translator', $scope.editTranslatorForm.model).then(
                            function(response){
                                $scope.editTranslatorForm.status = '';
                                $scope.model.action = '';
                                $scope.showEditTranslatorForm = false;
                                for(var i=0; i<$scope.translators.length; i++){
                                    if($scope.translators[i].id==response.id){
                                        $scope.translators[i] = response;
                                    }
                                }
                                
                            }
                        ).catch(function(response){
                                $scope.addTranslatorForm.status = 'error';
                            });
                    }
                }
            }
            $scope.removeTranslator = function(){
                for(var i=0; i<$scope.translations.length; i++){
                    if($scope.translations[i].id == translation.id){
                        $scope.translations[i].translator = null;
                        $scope.translations[i].translatorName = null;
                        $scope.translations[i].translatorPic = '/app/images/user.png';
                        $scope.translations[i].action = 'setTranslator';
                        D.save('translation', $scope.translations[i]).then(function(resp){
                            ngDialog.close();
                        }).catch(console.error);
                    }
                }
            }
            ngDialog.open({
                template: '/app/views/entities/translators-manage.html',
                className: 'ngdialog-theme-default ngdialog-theme-large',
                scope: $scope,
                cache: false
              });
        }
    }
    

    $scope.loadLog = function(){
    	D.query('actionlog','project=' + $scope.model.id +'', { cache: false }).then(
                function(response){
                	$scope.timelineAlt = true;
                	$scope.elements = [];
                	for(var i=0; i<response.length; i++){
                		var e = response[i];
                		var data = angular.fromJson(e.data);
                		if(!$rootScope.user.admin && (!e.action || (e.action.indexOf('FILE')>=0 && e.data.entityType!='PROJECT' && e.data.entityField!='upload')))
                			continue;
                		$scope.elements.push({
                			datetime: e.T,
                			action: e.action,
                			title: $filter('translate')('enums.useraction.'+e.action),
                			content: $filter('translate')('enums.useraction.'+e.action+'_TEXT', angular.fromJson(e.data)),
                			data: data
                		});
                	}
                }
            ).catch(console.error);
    };

    $scope.urgeOffersPopup = function(){
        $scope.urgeOffersForm = {
            title: '',
            status: '',
            type: 'project',
            model: $scope.model,
            fields: [
                /*{
                    available: true,
                    type: 'date',
                    name: 'date',
                    label: 'fields.OFFERDEADLINE',
                    labelColumn: 6,
                    inputColumn: 6,
                    onchange: function(){
                        if(!$scope.model.date){
                            $scope.urgeOffersForm.status = 'notsubmittable';
                        } else {
                            $scope.urgeOffersForm.status = '';
                        }
                    }
                },*/{
                    available: true,
                    type: 'submit',
                    label: 'labels.SEND'
                }
            ],
            submit: function(){
                
                $scope.urgeOffersForm.status = 'submitting';
                $scope.model.action = 'UrgeOffers';
                D.save('project', $scope.model).then(
                    function(response){
                        $scope.urgeOffersForm.status = '';
                        $scope.model.action = '';
                        ngDialog.close();
                    } 
                ).catch(function(response){
                        $scope.urgeOffersForm.status = 'error';
                    });
                
            }
        }
        ngDialog.open({
            template: '/app/views/entities/project-urgeoffers.html',
            className: 'ngdialog-theme-default',
            scope: $scope,
            cache: false
          });
    }
    
    $scope.viewSimilarProjects = function(){
        D.query('project','_similarTo='+$scope.model.id+'&statusgroup=open|running').then(
            function(response){
                $scope.popupProjects = response.sort(function(a,b){
                    return a.ld - b.ld;
                });
                $scope.projectsPopupTable = {
                    title: '',
                    filter: false,
                    style: {
                        fontSize: '11px'
                    },
                    fields: [
                        {
                            available: true,
                            hasLink: true,
                            name: 'code',
                            label: 'PROJECTCODE',
                            style: {
                                minWidth: '100px'
                            }
                        },{
                            available: true,
                            hasLink: true,
                            name: 'name',
                            label: 'PROJECTNAME',
                            style: {
                                maxWidth: '300px',
                                wordWrap: 'break-word'
                            }
                        },{
                            available: true,
                            label: 'ASSIGNEE',
                            name: 'assigneeName'
                        },{
                            available: true,
                            name: 'recoveredWords'
                        },{
                            available: true,
                            name: 'status',
                            label: 'PROJECTSTATUS',
                            type: 'enum',
                            enumType: 'status'
                        },{
                            available: true,
                            name: 'source',
                            type: 'enum',
                            enumType: 'language'
                        },{
                            available: true,
                            name: 'destinations',
                            type: 'enumSet',
                            enumType: 'language'
                        }
                    ],
                    link: {
                        state: 'app.do',
                        action: 'open',
                        type: 'project',
                        filter: 'id',
                        newWindow: true
                    }
                };
                
                ngDialog.open({
                    template: '/app/views/entities/projects-popup.html',
                    className: 'ngdialog-theme-default ngdialog-theme-large',
                    scope: $scope,
                    cache: false
                });
            }
        ).catch(console.error);
    }

    var loadingProject = false;
    let unwatchLoad = null
    var loadProject = function(){
        if(!$rootScope.user.id){
            unwatchLoad = $scope.$watch('user.id', function(){
                if($rootScope.user.id){
                    loadProject()
                }
            });
            return
        }
        loadingProject = true;
        D.load($scope.type, $scope.id).then(
            function(model){
                if(model.destinations){
                    model.destinations.sort(function(a, b){
                        return $filter('translate')('enums.language.'+a) > $filter('translate')('enums.language.'+b) ? 1 : -1;
                    });
                }
                model.analysisDestinations = model.destinations.slice();
                if(model.destinations.length > 1){
                    model.analysisDestinations.unshift('*');
                }
                $scope.model = model;

                $scope.model.charNumberLimit = $scope.model.opts.charNumberLimit;
                if($state.params.action=='view') $scope.model.charNumberLimit = $scope.model.opts.charNumberLimit || 'NO';
                $scope.model.charNumberLimitValue = $scope.model.opts.charNumberLimitValue;
                $scope.model.skipConfirmLimit = $scope.model.opts.skipConfirmLimit
                $scope.model.isAdminListener = (','+$scope.model.opts.listenerAdmins+',').indexOf(',' + $rootScope.user.id + ',')>=0
                $scope.model.separateOffers = $scope.model.opts.separateOffers
                if($state.params.action=='setimpaginationforfait'){
                    $scope.model.impaginationForfait = $scope.model.opts.impaginationForfait
                }

                $scope.model.joinedInCode = $scope.model.opts.joinedInCode
                
                if($scope.model.glossary && !$rootScope.user.admin){
                    $scope.loadGlossary()
                }
                
                if($scope.model.notesForSupplier) $scope.supplierNotesSaved = true;
                if($scope.model.analysisNotes) $scope.clientNotesSaved = true;
                $scope.showQA = $scope.model.createdOn >= new Date(2018, 0, 1).getTime();
                $scope.init($state.params.action);
                if($state.params.action!='open'){
                    $scope.loadAnalysis();
                    $scope.loadFiles($state.params.action);
                    if($state.params.action=='estimate'){
                        $scope.loadOffer();
                    }
                    if($state.params.action=='edit' || $state.params.action=='changeorder'){
                        $scope.loadOrders($scope.model.group)
                    }
                    if($state.params.action=='offers'){
                        $scope.loadOffers();
                        $scope.listenToOffersChanges();
                    }
                    if($state.params.action=='process'){
                        //$scope.createProcessForms();
                        $scope.loadTranslations();
                        $scope.listenToTranslationsChanges();
                    }
                    if($state.params.action=='files'){
                        $scope.loadTranslations();
                    }
                    if($state.params.action=='actionlog'){
                        $scope.loadLog();
                    }
                    if($rootScope.user.admin){
                        $scope.loadWait();
                    }
                    if($state.params.action=='costs'){
                        $scope.loadCosts();
                    }
                    if($rootScope.user.admin){
                        $scope.localFolderCheck();
                        $scope.destinationsFolders = '';
                        for(var i=0; i<$scope.model.destinations.length; i++){
                            $scope.destinationsFolders += '/' + $rootScope.mqLanguageCode($scope.model.destinations[i]) + ' '
                        }
                    }
                }
                loadingProject = false
            }
            
        ).catch(function(error){
                error.type = 'PROJECT';
                var newScope = $scope.$new(true)
                newScope.error = error;
                $scope.loaded = true;
                if($rootScope.user.id){
                    ngDialog.open({
                        template: '/app/views/entities/error.html',
                        className: 'ngdialog-theme-default',
                        scope: newScope,
                        cache: false,
                        preCloseCallback: function() {
                              $state.go('app.dashboard',{}, {location:'replace'});

                          }
                      });
                }
                loadingProject = false;
            });
    }
    $scope.loaded = false;
    if($state.params.action=='create' || $state.params.action=='import'){
        $scope.init('create');
    } else {
        loadProject();
    }

    $scope.localFolderCheck = function(){
        LR.one('files', $scope.model.code).get({onlyFolder:true}).then(function(resp){
            if(resp.folderExists===false){
                $scope.missingLocalFolder = true;
                LR.one('folder', $scope.model.code).get().then(function(resp){
                    $scope.localFolder = resp;
                    $scope.localFolder.createLocalFolderWithLanguages = $window.localStorage.getItem('createLocalFolderWithLanguages') ? true : false;
                }).catch(console.error)
            } else {
                $scope.missingLocalFolder = false;
                $scope.localFolder = resp;
                if($scope.localFolder.path.endsWith(CONFIG.folderSeparator)){ $scope.localFolder.path = $scope.localFolder.path.slice(0, -1)}
                var dirName = $scope.localFolder.path.split(CONFIG.folderSeparator)[$scope.localFolder.path.split(CONFIG.folderSeparator).length - 1]
                if(dirName.indexOf('_')>0){ 
                    var a = dirName.split(/_/);
                    var code = a.shift();
                    var suffix = a.join('_');
                    $scope.localFolder.suffix = suffix;
                    $scope.localFolder.pathEdit = $scope.localFolder.path.replace(CONFIG.folderSeparator + dirName, CONFIG.folderSeparator + code)
                }
                $scope.localFolder.createLocalFolderWithLanguages = $window.localStorage.getItem('createLocalFolderWithLanguages') ? true : false;
            }
        }).catch(console.error)
    }

    
    $scope.createLocalFolder = function(){
        $scope.localFolder.createLocalFolderWithLanguages ? $window.localStorage.setItem('createLocalFolderWithLanguages','true') : $window.localStorage.removeItem('createLocalFolderWithLanguages')
        LR.one('folder','').customPOST({
            suffix: $scope.localFolder.suffix, 
            code: $scope.model.code,
            languages: $rootScope.mqLanguageCode($scope.model.destinations),
            withLanguages: $scope.localFolder.createLocalFolderWithLanguages
        }).then(function(resp){
            $scope.localFolderCheck();
        }).catch(console.error);
    }

    $scope.modifyLocalFolder = function(){
        $scope.localFolder.createLocalFolderWithLanguages ? $window.localStorage.setItem('createLocalFolderWithLanguages','true') : $window.localStorage.removeItem('createLocalFolderWithLanguages')
        LR.one('folder','').customPUT({
            suffix: $scope.localFolder.suffix, 
            code: $scope.model.code,
            languages: $rootScope.mqLanguageCode($scope.model.destinations),
            withLanguages: $scope.localFolder.createLocalFolderWithLanguages
        }).then(function(resp){
            $scope.localFolderCheck();
        }).catch(console.error);
    }

    $scope.editingLocalFolder = false;
    $scope.editLocalFolder = function(){
        $scope.editingLocalFolder = !$scope.editingLocalFolder
    }

    $scope.openExplorer = function(path){
        LR.one('explorer', path).get().then(function(){}).catch(console.error);
    }

    $scope.closeMenuTooltip = function(){
        if($rootScope.currentPage=='project.view' && $rootScope.user.groupType=='CLIENT' && ($scope.model.status=='ANALYSIS' || $scope.model.status=='DRAFT' || $scope.model.status=='SENT')){
            $rootScope.closeTooltipByEvent($rootScope.currentPage,'menuactionsclientanalysis');
        }
        if($rootScope.currentPage=='project.review' && $rootScope.user.groupType=='CLIENT' && $scope.model.status=='REVISION'){
            $rootScope.closeTooltipByEvent($rootScope.currentPage,'menuactionsclientsourcereport');
        }
        if($rootScope.currentPage=='project.view' && $rootScope.user.groupType=='CLIENT' && $scope.model.status=='ESTIMATION'){
            $rootScope.closeTooltipByEvent($rootScope.currentPage,'menuactionsclientestimation');
        }
        if($rootScope.currentPage=='project.process' && $rootScope.user.groupType=='CLIENT' && $scope.model.status=='CONFIRMED'){
            $rootScope.closeTooltipByEvent($rootScope.currentPage,'menuactionsclientconfirmed');
        }
        if($rootScope.currentPage=='project.process' && $rootScope.user.groupType=='SUPPLIER' && $scope.model.status=='PROCESSING'){
            $rootScope.closeTooltipByEvent($rootScope.currentPage,'menuactionssupplierprocessing');
        }
    }

    $scope.exportingXlsx = false
    $scope.exportXlsx = function(){
        ngDialog.openConfirm({
            template: '/app/views/entities/confirm.html',
            className: 'ngdialog-theme-default',
            scope: $scope
          }).then(function (value) {
                $scope.exportingXlsx = true
                $scope.exportXlsxError = false
                R.one('action','ExportXLSX')
                .customPUT({project:$scope.model.id})
                .then(function(resp){
                    $scope.exportXlsxResult = 'https://storage.googleapis.com/' + resp.textResult
                    $scope.exportingXlsx = false
                    if(!resp.result){
                        $scope.exportXlsxError = true
                    }
                })
                .catch(function(err){
                    $scope.exportXlsxError = true
                })
          })
    }

    $scope.openGlossary = function(){
        $scope.glossaryForm = {
            title: 'fields.GLOSSARY',
            type: 'group',
            info: $filter('translate')('labels.SELECTEDGLOSSARY') + ': <pre>' + ($scope.model.glossary ? '&middot; ' + $scope.model.glossary.join('\n&middot; ') : $filter('translate')('labels.NONE')) + '</pre>',
            model: { id: $scope.model.group },
            fields: [
                {
                    available: true,
                    type: 'file',
                    name: 'glossary',
                    noLabel: true,
                    limit: -1,
                    canUpload: false,
                    cantDelete: true,
                    canAddInstructions: false,
                    bucket: $rootScope.bucketName($scope.model.group)
                }
            ]
        }
        ngDialog.open({
            template: '/app/views/entities/popup-glossary.html',
            className: 'ngdialog-theme-default ngdialog-theme-large',
            scope: $scope
        })
    }

    $scope.viewGlossary = function(){

        ngDialog.open({
            template: '/app/views/entities/popup-glossary.html',
            className: 'ngdialog-theme-default ngdialog-theme-large',
            scope: $scope
        })
    }

    $scope.loadGlossary = function(){
        if($scope.model.glossary){
            $scope.glossaryFiles = []
            $scope.lastGlossaryDate = null
            D.query('file', { type: 'group', field: 'glossary', entityId: $scope.model.group }, { cache: false }).then(function(response){
                for(var i=0; i<response.length; i++){
                    if($scope.model.glossary.indexOf(response[i].name)>=0){
                        $scope.glossaryFiles.push(response[i])
                        if($scope.lastGlossaryDate==null || $scope.lastGlossaryDate<response[i].createdOn){
                            $scope.lastGlossaryDate = response[i].createdOn
                        }
                    }
                }
            }).catch(console.error)
        }
    }

    $scope.$on('$destroy', function iVeBeenDismissed() {
        if(unwatch) unwatch()
        if(unwatchLoad) unwatchLoad()
        if(timeoutRetryUploadOtherFilesFn) $timeout.cancel(timeoutRetryUploadOtherFilesFn)
    });
  }
]);
